// media.js

import { imageOverlay } from "leaflet";

export const media = [
  // list of images and videos to display on map

  // Southern England
  {
    lat: 51.50066871058191,
    lng: -0.05953616174794717,
    thumbnail:
      "./data/output_ims/1. Tower Bridge from Bermondsey Angel Inn.jpg",
    name: "Tower Bridge and the City of London",
    description:
      "Along the south bank at Bermondsey I stopped and took my last look back at the city of London in the Spring sunshine.",
    type: "image",
  },
  {
    lat: 51.48311378279122,
    lng: -0.010698586187682631,
    thumbnail:
      "./data/output_ims/1a Cutty Sark Greenwich.jpg",
    name: "Cutty Sark",
    description:
      "The Greenwich peninsula is always worth a stop. The Cutty Sark is a stunning tribute to the advance of technology and ingenuity.",
    type: "image",
  },
  {
    lat: 51.445340926718856,
    lng: 0.368609515830732,
    thumbnail:
      "./data/output_ims/2 Tilbury on the  Thames from Gravesend ferry sketchbook.jpg",
    name: "Old Father Thames",
    description:
      "I’m looking across at Tilbury from Gravesend ferry seeing the great ships coming and going. It reminds me we are an island. Near here Turner painted the Fighting Temeraire.",
    type: "image",
  },
  {
    lat: 51.39733171237847,
    lng: 0.5040850096976737,
    thumbnail: "./data/output_ims/3  Rochester along the Medway.jpg",
    name: "Medway Magic",
    description:
      "The mighty Medway in the early evening light. This is a skyline that has barely changed in centuries. It’s still dominated by the cathedral and the castle.",
    type: "image",
  },
  {
    lat: 51.39237897241671,
    lng: 0.4986690992861079,
    thumbnail: "./data/output_ims/3a Rochester Castle.jpg",
    name: "Rochester Castle ",
    description:
      "The evening light across the Medway illuminates the ancient Castle and Cathedral. This is a timeless view that’s familiar to pilgrims and travellers throughout the ages.",
    type: "image",
  },
  {
    lat: 51.3674901871065,
    lng: 0.6407519205972764,
    thumbnail:
      "./data/output_ims/4  Cycling through the garden of England sketchbook.jpg",
    name: "Garden of England",
    description:
      "It’s the garden of England and I’m cycling off road through the great apple orchards of Kent. Of course, in March there aren’t too many apples on the trees!",
    type: "image",
  },
  {
    lat: 51.37792610386054,
    lng: 1.1917379371017802,
    thumbnail:
      "./data/output_ims/4a Reculver Kent.jpg",
    name: "Reculver",
    description:
      "There's a long expanse of marshland between Herne Bay and Birchington on the Isle of Thanet. Reculver ruined church clings to the cliff top with echoes of its ancient spiritual past.",
    type: "image",
  },
  {
    lat: 51.27151519806879,
    lng: 1.2138015655557317,
    thumbnail:
      "./data/output_ims/5 spring blossom from the Dog at Wingham sketchbook.jpg",
    name: "Cherry blossom at The Dog at Wingham",
    description:
      "I woke up in Room 5 at The Dog at Wingham hotel and painted the early morning light on the cherry blossom before breakfast.",
    type: "image",
  },
  {
    lat: 51.277863882260824,
    lng: 1.1828876212767603,
    thumbnail: "./data/output_ims/5a  Kent oasthouses at  Ickham.jpg",
    name: "Quintessentially Kent",
    description:
      "These four oast houses are quintessentially Kent. They are opposite the wonderful ancient church in the village of Ickham.",
    type: "image",
  },
  {
    lat: 51.36547416630915,
    lng: 1.1945817004801296,
    thumbnail: "./data/output_ims/5c Chislet windmill  sketchbook.jpg",
    name: "Chislet Windmill",
    description:
      "This unusual windmill caught my eye as I cycled towards Reculver, and I added my pal Stevie pedalling past to give some scale",
    type: "image",
  },
  {
    lat: 51.374929358508545,
    lng: 1.445630037670987,
    thumbnail: "./data/output_ims/5c North Foreland Lighthouse.jpg",
    name: "North Foreland Lighthouse",
    description:
      "This is one of the stunning squat stone lighthouses built to protect shipping coming around the coast into the Dover Straits. A century ago, members of the East London group of painters came on the train to Broadstairs to sketch this view. I always knew I’d stop and sketch it. I didn’t expect it to be in such a bright blue sky on a spring day.",
    type: "image",
  },
  {
    lat: 51.35921217921711,
    lng: 1.4452037435352305,
    thumbnail: "./data/output_ims/6  Broadstairs beach  sketchbook.jpg",
    name: "Broadstairs Beach",
    description:
      "I sat here on the harbour wall enjoying fish and chips beneath Dickins Bleak House. It’s a gorgeous view of this lovely beach.",
    type: "image",
  },
  {
    lat: 51.13003543233797,
    lng: 1.332512374861635,
    thumbnail: "./data/output_ims/6a Dover Castle.jpg",
    name: "Dover Castle",
    description:
      "It’s hard to get a good view of the impressive Dover Castle from the west. This was my glimpse of the great structure from the top of Dame Vera Lynne way.",
    type: "image",
  },
  {
    lat: 51.05790665230656,
    lng: 0.9544991408856376,
    thumbnail: "./data/output_ims/6b Romney Marsh  watercolour.jpg",
    name: "Romney Marsh",
    description:
      "Weaving my way through Romney Marsh, I’m struck by the vastness of the skies. This secretive remote expanse on the border of Kent and Sussex has a history stretching back into the dark ages. Archbishop Becket got stuck here crossing the marsh. This watercolour conveys something of it’s mystery.",
    type: "image",
  },
  {
    lat: 50.851783760916916,
    lng: 0.5624526115384703,
    thumbnail: "./data/output_ims/7 Hastings beach  sketchbook.jpg",
    name: "Hastings Beach",
    description:
      "I love being right along the waterfront and this spot has so much to offer. Refreshment, railings, flags, deckchairs, sunlight, and hopefulness.",
    type: "image",
  },
  {
    lat: 50.83635640332406,
    lng: 0.4633764180402558,
    thumbnail: "./data/output_ims/8  Boats at Bexhill sketchbook.jpg",
    name: "Boats at Bexhill",
    description:
      "All along the south coast there are fishing boats drawn up on the shingle to remind us that the sea has always been integral to life here.",
    type: "image",
  },
  {
    lat: 50.76542237113935,
    lng: 0.2905134113763362,
    thumbnail: "./data/output_ims/9 Eastbourne pier.jpg",
    name: "Eastbourne Pier",
    description:
      "Nothing defines a British beach quite like a pier. Eastbourne Pier is one of the finest in East Sussex. It looks dramatic in both silhouette and full sun.",
    type: "image",
  },
  {
    lat: 50.74139998727746,
    lng: 0.2024791129238201,
    thumbnail: "./data/output_ims/9a Sunset at Beachy head.jpg",
    name: "Sunset at Beachy Head",
    description:
      "Access to the shore at Beachy Head is via the steps at Birling Gap. Here the ribbed sand at low tide creates little pools where the reflections of the cliff dazzle the eye. Close up the immensity of the cliffs accentuate the way England ends abruptly at the Channel.",
    type: "image",
  },
  {
    lat: 50.74139998727746,
    lng: 0.2024791129238201,
    thumbnail: "./data/output_ims/9d Below Beachy head from Birling Gap.jpg",
    name: "Beachy Head",
    description:
      "Access to the shore at Beachy Head is via the steps at Birling Gap. Here the ribbed sand at low tide creates little pools where the reflections of the cliff dazzle the eye. Close up the immensity of the cliffs accentuate the way England ends abruptly at the Channel.",
    type: "image",
  },
  {
    lat: 50.742681645067876,
    lng: 0.20089935201097597,
    thumbnail: "./data/output_ims/Seven Sisters Biling Gap.jpg",
    name: "Seven Sisters",
    description:
      "Looking westwards the Seven Sisters area of outstanding Natural beauty reach to the peak at Seaford Head. The thin green layer of grass holds the chalky cliffs together.",
    type: "image",
  },
  {
    lat: 50.7592411608055,
    lng: 0.1424446954544768,
    thumbnail: "./data/output_ims/9c Seven Sisters from Coastguard Cottages, Seaford (2).jpg",
    name: "Seven Sisters from Coastgaurd Cottages",
    description:
      "This iconic view of the Seven Sisters chalk cliffs is inspired by the railway posters of a century ago. I cycled down the bridleway to the coastguard cottages and the immensity of the cliffs is accentuated by the cold grey of the grassy downs.",
    type: "image",
  },
  {
    lat: 50.73701291554296,
    lng: 0.2425275287972158,
    thumbnail: "./data/output_ims/10   Beachy Head watercolour.jpg",
    name: "Beachy Head",
    description:
      "Above the white cliffs the glimpse of the lighthouse way below makes me tread very carefully. These cliffs are immense.",
    type: "image",
  },
  {
    lat: 50.821470900536404,
    lng: -0.1498546321722829,
    thumbnail: "./data/output_ims/10a Brighton old Pier  watercolour.jpg",
    name: "Brighton Old Pier",
    description:
      "The ruins of this ghostly pier are evocative of the golden age of English seaside holidays. I love the way the birds flock around the remains as if waiting for the entertainment to start.",
    type: "image",
  },
  {
    lat: 50.83317512577117,
    lng: -0.2738716206090908,
    thumbnail: "./data/output_ims/11  Shoreham church  sketchbook.jpg",
    name: "Shoreham Church",
    description:
      "The remains of the great abbey, founded by Bishop Odo in the early years after the Norman Conquest, it makes an impressive parish church in the white stone of Normandy.",
    type: "image",
  },
  {
    lat: 50.83655628881285,
    lng: -0.7795002064478485,
    thumbnail: "./data/output_ims/11a  Chichester Cathedral  acrylic.jpg",
    name: "Chichester Cathedral",
    description:
      "Silhouetted in the late afternoon sunshine, Chichester Cathedral is a good place to stop for some reflection.",
    type: "image",
  },
  {
    lat: 50.8290957210144,
    lng: -0.8524670206748325,
    thumbnail: "./data/output_ims/12  Bosham sketchbook.jpg",
    name: "Bosham Harbour",
    description:
      "There’s lots of history surrounding Bosham in Chichester harbour. It is associated with King Cnut and King Harold. I spent a few hours here when friends arrived to cheer me on.",
    type: "image",
  },
  {
    lat: 50.82701625926197,
    lng: -0.8540018230847966,
    thumbnail: "./data/output_ims/12 a Bosham watercolour.jpg",
    name: "Bosham",
    description:
      "The long boardwalk across the marshes shows how far the tide changes. The light on the distant rooftops glisten in the sunshine.",
    type: "image",
  },
  {
    lat: 50.79521598743737,
    lng: -1.1168371866612699,
    thumbnail: "./data/output_ims/12 B Gosport.jpg",
    name: "Gosport",
    description:
      "The narrow entrance to Portsmouth harbour is marked by the graceful famous Spinnaker Tower.  The waters are crossed by the famous green Gosport ferries.",
    type: "image",
  },
  {
    lat: 50.7248732737919,
    lng: -1.2260534360746373,
    thumbnail: "./data/output_ims/13 Wootton bridge Isle of Wight  sketchbook.jpg",
    name: "Wootton Bridge, Isle of Wight",
    description:
      "Before heading off across the island, I enjoyed the boats lying on the flat sands with the tide out.",
    type: "image",
  },
  {
    lat: 50.687333359516686,
    lng: -1.3146950798951038,
    thumbnail: "./data/output_ims/14  Carisbrooke castle entrance Isle of Wight  sketchbook.jpg",
    name: "Carisbrooke Castle, Newport, Isle of Wight",
    description:
      "Joseph Turner painted this view of the entrance to Carisbrooke Castle and I searched for the spot where he had stood. It’s changed very little since King Charles I was imprisoned here after the English Civil War.",
    type: "image",
  },
  {
    lat: 50.66141503162787,
    lng: -1.579501861902258,
    thumbnail: "./data/output_ims/14a The Needles, Isle of Wight.jpg",
    name: "The Needles, Isle of Wight",
    description:
      "It’s a difficult place to find this view of the iconic Needles at the end of the Isle of Wight. But worth persevering. There’s a definite feeling of England falls off a cliff into the sea.",
    type: "image",
  },
  {
    lat: 50.6647005990254,
    lng: -1.478133161213828,
    thumbnail: "./data/output_ims/14b Tennyson Down Isle of Wight.jpg",
    name: "The Needles, Isle of Wight",
    description:
      "These soaring cliffs on the South Coast of the Isle of Wight are one of the most famous, majestic and iconic views of the island. I love the way they leave the seagulls flying far beneath.",
    type: "image",
  },
  {
    lat: 50.69470023666239,
    lng: -1.9317224453164548,
    thumbnail: "./data/output_ims/14c Poole Harbour.jpg",
    name: "Poole Harbour",
    description:
      "Poole harbour is one of the World’s largest natural harbours and a favourite place for sailing, paddleboarding and shell fish. Nearby is Sandbanks, among the most expensive real estate in the country.",
    type: "image",
  },
  {
    lat: 50.71484238189792,
    lng: -1.8815160973329006,
    thumbnail: "./data/output_ims/14d Bournemouth Pier.jpg",
    name: "Bournemouth  Pier",
    description:
      "The shared cycle and footpath by the Bournemouth shore curves around the bay framed by beach huts. It never ceases to inspire.",
    type: "image",
  },
  {
    lat: 50.638300107457304,
    lng: -2.052900434201641,
    thumbnail: "./data/output_ims/15 Corfe Castle from  Challow Farmhouse sketchbook.jpg",
    name: "Corfe Castle from Challow Farmhouse",
    description:
      "The delightful woodmans hut is available to stay in. It was here that I found Turner’s view of Corfe Castle through the bare trees. Turner stayed here on a sketching trip. He would walk 20 to 25 miles a day with his sketchbooks getting views that he would later work up in his studio.",
    type: "image",
  },
  {
    lat: 50.6393798112311,
    lng: -2.055413307297587,
    thumbnail: "./data/output_ims/15a Corfe Castle  acrylic.jpg",
    name: "Corfe Castle",
    description:
      "The ancient massive castle ruins at Corfe dwarf the little houses of the village. It’s always been a  strategic gateway to this region. In Saxon times the teenage King Edward was murdered here by his step mother.",
    type: "image",
  },
  {
    lat: 50.632038888203375,
    lng: -1.9335085740524316,
    thumbnail: "./data/output_ims/15b Old Harry Rocks.jpg",
    name: "Old Harry Rocks",
    description:
      "Difficult to get to these jagged outcrops on the Purbeck coast, which echo the Needles on the Isle of Wight.",
    type: "image",
  },
  {
    lat: 50.709413205593286,
    lng: -2.7604135279940314,
    thumbnail: "./data/output_ims/16  West Bay Dorset sketchbook.jpg",
    name: "West Bay, Dorset (sketchbook)",
    description:
      "These two sketches are opposite views across the beach and under the cliffs.",
    type: "image",
  },
  {
    lat: 50.709413205593286,
    lng: -2.7604135279940314,
    thumbnail: "./data/output_ims/17  West Bay Dorset sketchbook.jpg",
    name: "West Bay, Dorset (sketchbook)",
    description:
      "These two sketches are opposite views across the beach and under the cliffs.",
    type: "image",
  },
  {
    lat: 50.709413205593286,
    lng: -2.7604135279940314,
    thumbnail: "./data/output_ims/17a West Bay.jpg",
    name: "West Bay, Dorset (Acrylic)",
    description:
      "The watercolour sketches were prep for the larger acrylic. Strange to think that this view is constantly changing. There are at least three rockfalls every year. It’s one of the most dangerous and revealing coasts in the country. There are dinosaur fossils under every footstep.",
    type: "image",
  },
  {
    lat: 50.709413205593286,
    lng: -2.7604135279940314,
    thumbnail: "./data/output_ims/17b West Bay watercolour.jpg",
    name: "West Bay, Dorset",
    description:
      "The watercolour sketches were prep for the larger acrylic. Strange to think that this view is constantly changing. There are at least three rockfalls every year. It’s one of the most dangerous and revealing coasts in the country. There are dinosaur fossils under every footstep.",
    type: "image",
  },
  {
    lat: 50.61267464849019,
    lng: -2.4535473589978527,
    thumbnail: "./data/output_ims/18  Weymouth helter skelter sketchbook.jpg",
    name: "Weymouth Helter Skelter",
    description:
      "Sunday morning as the clocks go forward the old helter skelter reminded me of a painting by Stanley Spencer.",
    type: "image",
  },
  {
    lat: 50.673918462744524,
    lng: -2.623631736802438,
    thumbnail: "./data/output_ims/Abbotsbury Hill Dorset.jpg",
    name: "Abbotsbury Hill",
    description:
      "From the Beacon at the top of this strenuous cycle climb is the view out along the Jurassic coast and Chesil beach. Great place to enjoy a homity pie.",
    type: "image",
  },
  {
    lat: 50.384735055762675,
    lng: -3.6116278870305623,
    thumbnail: "./data/output_ims/19  River Dart  Dittisham sketchbook.jpg",
    name: "River Dart, Dittisham",
    description:
      "The mossy walls lend colour to the grey early spring landscape. I stopped here for a reflection on scale. The scale of my adventure. The changes I see at each turn of the pedal.",
    type: "image",
  },
  {
    lat: 50.35007899474239,
    lng: -3.569584731425302,
    thumbnail: "./data/output_ims/20  Dartmouth from Kingswear sketchbook.jpg",
    name: "Dartmouth and Kingswear across the River Dart",
    description:
      "These two quick sketches in watercolour and watercolour pencils highlight the valley of the Dart, the marina, naval college and railway that make this such an intriguing destination.",
    type: "image",
  },
  {
    lat: 50.35007899474239,
    lng: -3.569584731425302,
    thumbnail: "./data/output_ims/21 River Dart from Kingswear sketchbook.jpg",
    name: "Dartmouth and Kingswear across the River Dart",
    description:
      "These two quick sketches in watercolour and watercolour pencils highlight the valley of the Dart, the marina, naval college and railway that make this such an intriguing destination.",
    type: "image",
  },
  {
    lat: 50.348719569809624,
    lng: -3.5729120600961943,
    thumbnail: "./data/output_ims/Kingston Dartmouth Railway.jpg",
    name: "Kingswear Station",
    description:
      "At the end of the line (by the water’s edge) is Kingswear railway station that harks back to the golden age of steam trains. The silhouette of the Great Western locomotive against the smoke and steam echoes to days of grand travel. I’ve included my bike as a nod to today’s adventure getting around the country.",
    type: "image",
  },
  {
    lat: 50.54547236559506,
    lng: -3.5103028014844733,
    thumbnail: "./data/output_ims/22  River Teign  at Shaldon from the bridge sketchbook.jpg",
    name: "On the Bridge Across the River Teign",
    description:
      "Weirdly the cliffs are blue in this morning light, as I cycled across the sandstone valley of South Devon. I stood on the bridge from Teignmouth to Shaldon, as the cars hurried by.",
    type: "image",
  },
  {
    lat: 50.36467652689309,
    lng: -4.141283145623644,
    thumbnail: "./data/output_ims/23  Smeaton's Tower Plymouth.jpg",
    name: "Smeaton’s Tower, Plymouth Hoe Park",
    description:
      "The candy stripes of this iconic lighthouse make this one of the most recognized and beloved views of Devon. I can imagine Sir Francis Drake playing bowls here as he watched the Spanish Armada out at sea.",
    type: "image",
  },
  {
    lat: 50.36632680288477,
    lng: -4.134234332231702,
    thumbnail: "./data/output_ims/24 Plymouth Barbican sketchbook.jpg",
    name: "Rainclouds on the Barbican",
    description:
      "On the upper floor of the Mayflower Museum there’s a good view of the Mayflower steps surrounded by the fluttering flags and people gathered to enjoy the spring sunshine before the rain comes our way.",
    type: "image",
  },
  {
    lat: 50.364695380908124,
    lng: -4.167102009095107,
    thumbnail: "./data/output_ims/24a Royal William Yard Plymouth.jpg",
    name: "Royal William Yard  ",
    description:
      "There’s so much activity throughout the Plymouth Naval base. The Royal William Yard is full of naval vessels, flags, tugs there’s always something to catch the eye.",
    type: "image",
  },
  {
    lat: 50.35127245397796,
    lng: -4.452090129105217,
    thumbnail: "./data/output_ims/24b The catch comes home.jpg",
    name: "The Catch Comes Home",
    description:
      "The fishing boats coming back successfully into Looe harbour are back lit by the evening sunlight. The special quality of the Cornish light turns the deep sea an iridescent turquoise.",
    type: "image",
  },
  {
    lat: 50.268544438774335,
    lng: -4.78337985790968,
    thumbnail: "./data/output_ims/25 Mevagissey harbour sketchbook.jpg",
    name: "Mevagissey Harbour",
    description:
      "After dinner at the Ship Inn, I stepped out in the early evening light to enjoy the harbour. I enjoyed a conversation with locals who had relocated here and as I completed this watercolour a fly stuck to the paper as the wind blew the page shut. It’s still there!",
    type: "image",
  },
  {
    lat: 50.268544438774335,
    lng: -4.78337985790968,
    thumbnail: "./data/output_ims/25a Bringing Home the catch Mevagissey acrylic.jpg",
    name: "Bringing Home the Catch",
    description:
      "Turning to face the sea wall, I watched the fishing boats returning with the days catch. This acrylic piece was completed back in my hotel room as the sun set.",
    type: "image",
  },
  {
    lat: 50.10377924398462,
    lng:  -5.1378460639446315,
    thumbnail: "./data/output_ims/26  Budock Vean garden resort sketchbook.jpg",
    name: "Budock Vean Garden Resort",
    description:
      "Down by the resort’s private beach I was intrigued by the boat house on stilts amongst the trees. The light was throwing up interesting shadows, then someone approached for a chat and the I got no further.",
    type: "image",
  },
  {
    lat: 49.959549947438255,
    lng:  -5.206638767284213,
    thumbnail: "./data/output_ims/The Lizard Point.jpg",
    name: "The Lizard Point",
    description:
      "Britain’s most southerly point. This is how we see the land fall away into the sea in such dramatic circumstances.",
    type: "image",
  },
  {
    lat: 50.123149881802036,
    lng:  -5.472858887435763,
    thumbnail: "./data/output_ims/27  St Michael's mount sketchbook.jpg",
    name: "St Michael’s Mount",
    description:
      "While waiting for the tide to drop so that we could cross to the mount I did this sketch across a page and a half of my sketchbook.",
    type: "image",
  },
  {
    lat: 50.123149881802036,
    lng:  -5.472858887435763,
    thumbnail: "./data/output_ims/27a St Michaels mount.jpg",
    name: "St Michael’s Mount",
    description:
      "I worked this piece up in acrylics using palette knife and quick brush strokes. ",
    type: "image",
  },
  {
    lat: 50.06274273983651,
    lng:  -5.5648891675989045,
    thumbnail: "./data/output_ims/27b Lamorna Cove.jpg",
    name: "Lamorna Cove",
    description:
      "The turn off to the beach is easily missed – the Lamorna Wink pub is so appealing. This was a favourite spot for artist Alfred Munnings and the Lamorna artists of the early 20th century. On this early spring day, the white spinifex covered the hillside and blue sky matched the blue Cornish water.",
    type: "image",
  },
  {
    lat: 50.065106019974166,
    lng:  -5.588966018460037,
    thumbnail: "./data/output_ims/28  merry maiden stone circle sketchbook.jpg",
    name: "Merry Maidens Stone Circle",
    description:
      "It doesn’t have the size of Stonehenge or the dramatic setting of Keswick, but the Merry Maidens have a distinctive name and form a perfect circle in the middle of the sheep field.",
    type: "image",
  },
  {
    lat: 50.210824389350535,
    lng:  -5.477901730016496,
    thumbnail: "./data/output_ims/28a St Ives  acrylic.jpg",
    name: "St Ives",
    description:
      "There’s a quality to the light in St Ives that is apparent in every season. On this early April day, I caught a glimpse of the crowds that will be heading this way throughout the year.",
    type: "image",
  },
  {
    lat: 50.52744121248265,
    lng:  -5.023648514360081,
    thumbnail: "./data/output_ims/Constantine Bay.jpg",
    name: "Constantine Bay",
    description:
      "It’s a magical cove that is popular with surfers every day. I enjoyed sitting at the end of the bay watching the sea deliver its never-ending delights.",
    type: "image",
  },
  {
    lat: 50.4147326456122,
    lng:  -5.100167908683574,
    thumbnail: "./data/output_ims/28c Riding the surf.jpg",
    name: "Riding the surf",
    description:
      "The North coast of Cornwall is a surfing magnet. Watching the surfer’s on Newquay’s Fistral Beach you see the perpetual efforts of making the most of every wave.",
    type: "image",
  },
  {
    lat: 50.59415866072486,
    lng:  -4.821572292536699,
    thumbnail: "./data/output_ims/29 Port Gaverne Port Isaac watercolour.jpg",
    name: "Port Gaverne/Port Isaac",
    description:
      "It’s not an easy place to stop. I climbed out of Port Isaac through Port Gaverne and saw this chasm by the side of the road.",
    type: "image",
  },
  {
    lat: 50.69036168600296,
    lng:  -4.694956986327064,
    thumbnail: "./data/output_ims/30 Boscastle bridge sketchbook.jpg",
    name: "Boscastle Bridge",
    description:
      "This curving foot bridge caught my eye as I watched the tourists wandering around the National Trust harbour at Boscastle.",
    type: "image",
  },
  {
    lat: 50.83218438478753,
    lng:  -4.554875689347438,
    thumbnail: "./data/output_ims/30a surfer.jpg",
    name: "The Surfer",
    description:
      "Expectation is sometimes a thrilling as the achievement. Across the wide expanse of sand the surfer marches determinedly towards the waves….",
    type: "image",
  },
  {
    lat: 50.59213845300802,
    lng:  -4.831991882555633,
    thumbnail: "./data/output_ims/31 Port Isaac sketchbook.jpg",
    name: "Port Isaac",
    description:
      "The piles of Lobster pots dwarf the visitors. I like the fact the man in the middle was braving the April winds to wear shorts. On the right is the edge of the chain mountain. Piles of chains next to the lobster pots reminds us this is a working harbour.",
    type: "image",
  },
  {
    lat: 50.77087339364447,
    lng:  -4.579146823406668,
    thumbnail: "./data/output_ims/Misty Day along the cost.jpg",
    name: "Misty Coast Milook",
    description:
      "It’s the sharp dramatic drop at the start of the Widemouth ridge. On the day I pedalled this hairpin route the mist had descended and cast an eerie spell along the beach.",
    type: "image",
  },
  {
    lat: 50.87643206792714,
    lng:  -4.557809435278737,
    thumbnail: "./data/output_ims/31b Wellcombe Mouth Hartland watercolour.jpg",
    name: "Wellcombe Mouth",
    description:
      "The ridges of rock look like teeth in the mouth to Duckpool pond. The Hartland peninsula has a magic about it.",
    type: "image",
  },
  {
    lat: 50.99811478344029,
    lng:  -4.398132903441831,
    thumbnail: "./data/output_ims/31c Clovelly Devon watercolour.jpg",
    name: "Clovelly",
    description:
      "Only accessible by foot and the locals bring their shopping in by sled! The village clings impossibly to the cliff edge and it feels like stepping back into a distant era.",
    type: "image",
  },
  {
    lat: 51.020262891723846,
    lng:  -4.5233513129738485,
    thumbnail: "./data/output_ims/31d Hartland point.jpg",
    name: "Hartland Point",
    description:
      "To see the edge of England at Hartland jutting out into the Bristol Channel is to be reminded again that this is an evolving challenging coastline.",
    type: "image",
  },
  {
    lat: 51.02360791475116,
    lng:  -4.196777858089686,
    thumbnail: "./data/output_ims/32  Bideford sketchbook.jpg",
    name: "Bideford",
    description:
      "Across the mudflats of the river Torridge at low tide are a row of boats. I sketched this in watercolour pencils after stopping to take a phone call.",
    type: "image",
  },
  {
    lat: 51.049763113952444,
    lng:  -4.179124777783356,
    thumbnail: "./data/output_ims/33  Instow  sketchbook.jpg",
    name: "Instow",
    description:
      "The old railway station at Instow covered two pages of my sketchbook in pen and ink. It’s a popular spot to stop and star on the Tarka trail.",
    type: "image",
  },
  {
    lat: 51.11958146505602,
    lng:  -4.2275153861016035,
    thumbnail: "./data/output_ims/33 b Saunton sands, Devon watercolour.jpg",
    name: "Saunton Sands",
    description:
      "Looking across the broad sandy beach I made an outdoor studio on the layby wall as the road bends around towards Ilfracombe.",
    type: "image",
  },
  {
    lat: 51.20905621344413,
    lng:  -4.114518930639736,
    thumbnail: "./data/output_ims/34  Ilfracombe  sketchbook.jpg",
    name: "Ilfracombe",
    description:
      "Looking down onto Ilfracombe harbour and the huge statue of Verity. I sketched this in pen and ink.",
    type: "image",
  },
  {
    lat: 51.2317808479724,
    lng:  -3.83113244295644,
    thumbnail: "./data/output_ims/35  Lynmouth and Lynton sketchbook.jpg",
    name: "Lynton and Lynmouth",
    description:
      "The water powered funicular is one of those quaint eccentric things of Victorian Britain that still works every day and is possibly one of the oldest employers in the twin towns. My view in watercolour and pencil is from the harbour wall with the Rhenich Tower in the foreground.",
    type: "image",
  },
  {
    lat: 51.215903172084346,
    lng:  -3.730856529970445,
    thumbnail: "./data/output_ims/35a Oare Lorna Doone country.jpg",
    name: "Lorna Doone Country",
    description:
      "Exmoor holds secrets and the old bridge over Badgeworthy water appears in the story of Lorna Doone.",
    type: "image",
  },
  {
    lat: 51.231488291251,
    lng:  -3.000787918547647,
    thumbnail: "./data/output_ims/36 Burnham on sea pier.jpg",
    name: "Burnham-on-Sea Pier",
    description:
      "It’s the shortest pier in the country and makes a lovely pen and ink sketch with the strange wooden lighthouse in the distance.",
    type: "image",
  },
  {
    lat: 51.45613827502513,
    lng:  -2.62589170801918,
    thumbnail: "./data/output_ims/37 Clifton supsension bridge sketchbook.jpg",
    name: "Clifton Suspension Bridge, Bristol",
    description:
      "Climbing up in the Clifton observatory park there’s this view of Brunel’s masterpiece with the strong shadows on the nearside. I did a second painting in acrylics from the same view. They are quite different.",
    type: "image",
  },
  {
    lat: 51.45613827502513,
    lng:  -2.62589170801918,
    thumbnail: "./data/output_ims/Clifton Suspension Bridge.jpg",
    name: "Clifton Suspension Bridge, Bristol (acrylic)",
    description:
      "Climbing up in the Clifton observatory park there’s this view of Brunel’s masterpiece with the strong shadows on the nearside.",
    type: "image",
  },

  // North West England paintings
  {
    lat: 53.41540467114124,
    lng: -3.122387114724037,
    thumbnail: "./data/output_ims/01 Wallassey beach Wirral sketchbook.jpg",
    name: "Wallasey beach, Wirral",
    description:
      "The Wirral coastal path is a stunning cycle/walkway around the spout of Cheshire’s teapot. The skies are bigger, and the sands spread forever where the Mersey feeds into the Irish sea.",
    type: "image",
  },
  {
    lat: 53.44073784502523,
    lng: -3.0516534795513692,
    thumbnail: "./data/output_ims/New Brighton and Merseyside.jpg",
    name: "New Brighton Merseyside",
    description:
      "New Brighton Lighthouse and the Fort Perch Rock mark the entrance to the docks along Merseyside. Nearby is the Floral Pavilion where I’ve brought my show in the past.",
    type: "image",
  },
  {
    lat: 53.3972980719925,
    lng: -3.010159473337263,
    thumbnail: "./data/output_ims/03 Liverpool skyline sketchbook.jpg",
    name: "Liverpool Skyline",
    description:
      "Nothing can compete with the Liverpool skyline. A couple of cathedrals, the Albert Dock, Liverpool One, and of course the Liver Buildings.",
    type: "image",
  },
  {
    lat: 53.48410362445672,
    lng: -3.04958913258975,
    thumbnail: "./data/output_ims/04 Crosby men Another Place.jpg",
    name: "Crosby, Another Place",
    description:
      "Another Place - Antony Gormley’s iron men buried in the sand are one of the great features of this coast. They look different at every tide and in every season. There’s something eternal about them in the ever-shifting sands.",
    type: "image",
  },
  {
    lat: 53.73605253323254, 
    lng: -2.9531043660106078,
    thumbnail: "./data/output_ims/05 Lytham Windmill watercolour.jpg",
    name: "Lytham Windmill",
    description:
      "Coming around the Fylde coast, the windmill looms into view and the wind from Ireland always catches you unawares. This is the home of George Formby and Les Dawson, and older than both, is the iconic windmill.",
    type: "image",
  },
  {
    lat: 53.81585015669032, 
    lng: -3.0573170314131475,
    thumbnail: "./data/output_ims/Blackpool.jpg",
    name: "Blackpool",
    description:
      "You can see Blackpool Tower from over 40 miles away north or south  along the Lancashire coast, and my favourite viewpoint is right in front of the iron red tower.",
    type: "image",
  },
  {
    lat: 53.92857237422178,
    lng: -2.9973642176203357,
    thumbnail: "./data/output_ims/07 Fleetwood Knott End ferry sketchbook.jpg",
    name: "Knott End Ferry, Fleetwood",
    description:
      "This was a favourite holiday place for LS Lowry in the 1950s; and was home for my mother’s family a century ago. The Knott End ferry is an institution in the area and utterly dependant on the tides since they stopped dredging the River Wyre.",
    type: "image",
  },
  {
    lat: 54.15658853670332,
    lng: -2.829820408854996,
    thumbnail: "./data/output_ims/7a Arthur's seat, Silverdale.jpg",
    name: "The 'Arthur's Seat' of Silverdale",
    description:
      "This Area of Outstanding Natural Beauty in Silverdale offers views across to Arnside Knott.",
    type: "image",
  },
  {
    lat: 54.202238735627446,
    lng: -2.8353800321023606,
    thumbnail: "./data/output_ims/08a Arnside prom sketchbook.jpg",
    name: "Arnside",
    description:
      "Sit on the sands by the shortest stone pier in England and enjoy a picnic lunch from the nearby bakery. Arnside offers so much. This is where Arthur Ransome’s sailing boat Kittiwake formed the inspiration for Swallows and Amazons.",
    type: "image",
  },
  {
    lat: 54.202238735627446,
    lng: -2.8353800321023606,
    thumbnail: "./data/output_ims/Arnside Prom.jpg",
    name: "Arnside Prom",
    description:
      " I went to school in Arnside and the walk along the promenade around Ashmeadow house offers this glimpse of the mighty railway viaduct and pretty seaside village.",
    type: "image",
  },
  {
    lat: 54.184333657779625,
    lng: -2.8313531875238316,
    thumbnail: "./data/output_ims/09 Arnside Tower sketchbook.jpg",
    name: "Arnside Tower (sketchbook)",
    description:
      "Along the back road to Far Arnside is the medieval Arnside Tower built to protect in times of war with the Scots. I sat on the stone wall to sketch the old stones then walked around to include the Knott and walkers in my watercolour.",
    type: "image",
  },
  {
    lat: 54.184333657779625,
    lng: -2.8313531875238316,
    thumbnail: "./data/output_ims/Arnside Tower.jpg",
    name: "Arnside Tower",
    description:
      "Along the back road to Far Arnside is the medieval Arnside Tower built to protect in times of war with the Scots. I sat on the stone wall to sketch the old stones then walked around to include the Knott and walkers in my watercolour.",
    type: "image",
  },
  {
    lat: 54.65481761359375,
    lng: -2.717073640518984,
    thumbnail: "./data/output_ims/Brougham Castle.jpg",
    name: "Brougham Castle, Penrith",
    description:
      "One of three castles that JMW Turner would have sketched in a single 25 mile walking day back in the 1800s.  (Penrith, Lowther and Brougham). This castle is glimpsed by traffic on the A66 as it speeds past. Its sandstone walls hold the story of England’s foundation….",
    type: "image",
  },
  {
    lat: 54.354234943000954,
    lng: -2.9311646531321927,
    thumbnail: "./data/output_ims/11 Windermere ferry.jpg",
    name: "Windermere Ferry",
    description:
      "England’s longest lake produces it’s own micro climate. Thick swirling mists roll in from the fells and the ferry is glimpsed through the rain as it makes it way across the deep cold waters.",
    type: "image",
  },
  {
    lat: 54.32808598643645,
    lng: -2.9611131212683124,
    thumbnail: "./data/output_ims/11a Lake District Bluebells.jpg",
    name: "Windermere Bluebells",
    description:
      "The rich green of the new trees can’t obscure the lovely purple bluebells that cover the woodland floor in late spring.",
    type: "image",
  },
  {
    lat: 54.20073487017397,
    lng: -2.952339588619838,
    thumbnail: "./data/output_ims/12 Cartmel Priory sketchbook.jpg",
    name: "Cartmel Priory (sketchbook)",
    description:
      "One of my favourite churches in the Lake District, this cathedral of the fells was founded by one of the greatest knights of the Middle Ages, William Marshall. whose initials are all around the doorway.",
    type: "image",
  },
  {
    lat: 54.07349094617299,
    lng: -3.1742161427746853,
    thumbnail: "./data/output_ims/13 Piel Island Barrow sketchbook.jpg",
    name: "Piel Island, Barrow",
    description:
      "Getting from Roa to Piel Island is an adventure. The ferryman lives in the pub and operates when he feels like it. There’s no harm in waiting on the bench looking at what there is to see across the water – a castle and a pub!",
    type: "image",
  },
  {
    lat: 54.13681391362737,
    lng: -3.198436092837361,
    thumbnail: "./data/output_ims/13a Furness Abbey.jpg",
    name: "Furness Abbey",
    description:
      "One of the ancient wealthy abbeys of England that were closed on the orders of Henry VIII. It’s smooth sandstone walls reach to the heavens in this sacred spot. A poignant place to pause, ponder and paint.",
    type: "image",
  },
  {
    lat: 54.350771849572894,
    lng: -3.4043310025730666,
    thumbnail: "./data/output_ims/14 Ravenglass Roman ruins sketchbook.jpg",
    name: "Ravenglass Roman Ruins",
    description:
      "Along an empty lane behind the Ravenglass and Eskdale railway are some unusually well preserved Roman ruins. This area of Cumbria has been an important settlement for millenia.",
    type: "image",
  },
  {
    lat: 54.4411469647346,
    lng: -3.519500208803932,
    thumbnail: "./data/output_ims/15 Beckermet bridge, Cumbria sketchbook.jpg",
    name: "Beckermet Bridge, Cumbria",
    description:
      "Beyond Sellafield is the delightful village of Beckermet with a little chapel and an impressive railway bridge. There’s no railway anymore but the bridge was built to last – and it has.",
    type: "image",
  },
  {
    lat: 54.870365708193155,
    lng: -3.393252314663525,
    thumbnail: "./data/output_ims/16 Solway Firth sunset Silloth.jpg",
    name: "Solway Firth Sunset, Silloth",
    description:
      "Silloth is a purpose-built holiday resort from the time when railways brought holiday makers to the area. It’s worth it too. This Area of Outstanding Natural Beauty looks across the mighty Solway Firth to the mountains of Galloway. A perfect place to watch (and paint) a majestic sunset.",
    type: "image",
  },
  {
    lat: 54.903354113748165,
    lng: -2.9345656216773346,
    thumbnail: "./data/output_ims/17 Carlisle Eden Bridge sketchbook.jpg",
    name: "Eden Bridge, Carlisle (sketchbook)",
    description:
      "I was looking for the view of Carlisle that JMW Turner created on his tour of the Borders. His view of Eden Bridge and Carlisle Castle doesn’t exist – it never has. The two can’t be seen together in this way. But it’s worth enjoying the view of the mighty sandstone bridge and Carlisle. ",
    type: "image",
  },

  // Wales paintings

  {
    lat: 51.64444618786353,
    lng: -2.6737892519147115,
    thumbnail: "./data/output_ims/01 Chepstow castle.jpg",
    name: "Chepstow Castle",
    description:
      "One of my favourite castles in Wales, this view greets you as you approach the great walls. Chepstow boasts the glorious original medieval door!",
    type: "image",
  },
  {
    lat: 51.645629,
    lng: -2.675459,
    thumbnail: "./data/output_ims/02 Chepstow castle sketchbook.jpg",
    name: "Chepstow from Below (sketchbook)",
    description:
      "The River Wye carves a rugged cliff on which the castle stands majestic. I went in search of Joseph Turner’s view of the castle, which is always different to the one we’d expect.",
    type: "image",
  },
  {
    lat: 51.57036851684637,
    lng: -2.9842011406290685,
    thumbnail: "./data/output_ims/03 Newport Transporter bridge sketchbook.jpg",
    name: "Newport Transporter Bridge",
    description:
      "The transporter bridges of Newport and Middlesbrough are among our iconic British crossings. I climbed the tower on the east side crossing and sketched this aspect as the tower rocked in the breeze.",
    type: "image",
  },
  {
    lat: 51.42943472649254,
    lng: -3.1702979399145232,
    thumbnail: "./data/output_ims/Penarth Beach.jpg",
    name: "Penarth Beach",
    description:
      "In the Cardiff National Gallery of Wales are a number of impressionist paintings by Alfred Sisley including his work on penarth beach. I cycled the cliff edge that revealed Sisley’s view to me.",
    type: "image",
  },
  {
    lat: 51.56796516296472,
    lng: -4.006342443526616,
    thumbnail: "./data/output_ims/Donkey Rock Rotherstade Bay.jpg",
    name: "Donkey Rock, Rotherslade beach, Mumbles",
    description:
      "At sunset the colours on this startling rock shimmer on the Gower peninsula. Sisley painted in the same situation over a century ago. I’m delighted to be able to follow in his footsteps.",
    type: "image",
  },
  {
    lat: 51.73873344638697,
    lng: -4.302714235001118,
    thumbnail: "./data/output_ims/06 Kidwelly castle sketchbook.jpg",
    name: "Kidwelly Castle",
    description:
      "It’s easy to pass this castle without a second glance. Unless you live on the other side of the meadow. 200 years ago, Joseph Turner visited this ruin, and he would have loved this aspect.",
    type: "image",
  },
  {
    lat: 51.737485100169934,
    lng: -4.304788985286203,
    thumbnail: "./data/output_ims/07 Kidwelly castle.jpg",
    name: "Kidwelly Castle from the Orchard",
    description:
      "The orchard next to the allotments is where Turner found his view of the castle. He added a swirl of stormy weather. I found my striking view on the edge of the allotments close to where Turner stood.",
    type: "image",
  },
  {
    lat: 51.76066761900072,
    lng: -4.372623160358165,
    thumbnail: "./data/output_ims/Llansteffan from Terryside.jpg",
    name: "Llansteffan from Ferryside",
    description:
      "In the evening sunlight I shared a beer and a driftwood firepit with Captain Bob as he recited Dylan Thomas’s Under Milk Wood. Across the River Towy is the ancient castle and village of Llansteffan where Dylan often visited.",
    type: "image",
  },
  {
    lat: 51.76907418302826,
    lng: -4.4628482851807805,
    thumbnail: "./data/output_ims/09 Laugharne Castle oil.jpg",
    name: "Laugharne Castle",
    description:
      "Inspired by Turner’s swirling skies I painted this majestic Castle close to the boathouse where Dylan Thomas wrote his beloved texts.",
    type: "image",
  },
  {
    lat: 51.673691980547304,
    lng: -4.701796831809092,
    thumbnail: "./data/output_ims/10 Tenby oil.jpg",
    name: "Tenby",
    description:
      "Nothing compares to the pretty painted houses clinging to the ridges above the Tenby harbour. There are two great beaches in Tenby. I was mesmerized by the north beach.",
    type: "image",
  },
  {
    lat: 51.677133419222656,
    lng: -4.918287422546959,
    thumbnail: "./data/output_ims/11b Pembroke castle sketchbook.jpg",
    name: "Pembroke Castle (sketchbook)",
    description:
      "I followed the path around the Pembroke Castle moat looking for Turner’s view of the great castle birthplace of Henry Tudor. Even the castle’s managers weren’t sure where he had stood. In the end it was in the middle of the bridge – the most obvious place!",
    type: "image",
  },
  {
    lat: 51.677133419222656,
    lng: -4.918287422546959,
    thumbnail: "./data/output_ims/11d Pembroke castle acrylic.jpg",
    name: "Pembroke Castle",
    description:
      "The same view of Pembroke Castle in Acrylic.",
    type: "image",
  },
  {
    lat: 51.772582531774795,
    lng: -5.108680804841094,
    thumbnail: "./data/output_ims/12 Little Haven cottages, sketchbook.jpg",
    name: "Little Haven Cottages (sketchbook)",
    description:
      "Along St Bride’s Road in this tiny Welsh coastal village are the small fishing cottages that appear to be barely tall enough to stand up in!",
    type: "image",
  },
  {
    lat: 51.85741012710442,
    lng: -5.1279426649603534,
    thumbnail: "./data/output_ims/13 Newgale sunset watercolour.jpg",
    name: "Newgale Sunset",
    description:
      "Sitting on the shingle bank in front of the Duke of Edinburgh pub, I painted the sun going down behind St David’s peninsula.",
    type: "image",
  },
  {
    lat: 51.88155769011442,
    lng: -5.267524365601955,
    thumbnail: "./data/output_ims/13a St Davids Cathedral.jpg",
    name: "St David's Cathedral",
    description:
      "It’s the famous cathedral in Britain’s smallest city. Built on a slope I found my viewpoint on the wall of the car park looking down on the grey stone marvel where I was welcomed by the Dean.",
    type: "image",
  },
  {
    lat: 51.88266257502809,
    lng: -5.2699946575733865,
    thumbnail: "./data/output_ims/13b St David's Cathedral sketch (1).jpg",
    name: "St David's Cathedral (sketch)",
    description:
      "I asked the staff in the Cathdral for their favourite view and this was recommended. Alongside the old Bishop’s palace looking down the rough lane the bare trees shortly to burst into spring blossom. I’ll work this sketch up.",
    type: "image",
  },
  {
    lat: 52.243127252927,
    lng: -4.261035758956715,
    thumbnail: "./data/output_ims/14 Aberaeron harbour sketchbook.jpg",
    name: "Aberaeron Harbour",
    description:
      "This delightful town is famous for its multi coloured houses. Down by the harbour I made this sketch.",
    type: "image",
  },
  {
    lat: 52.408627,
    lng:  -4.089352,
    thumbnail: "./data/output_ims/15 Aberystwyth sketchbook.jpg",
    name: "Aberystwyth (sketchbook)",
    description:
      "Beneath the castle grounds the sweep of the great central Wales bay takes over. There’s the pier, the impressive old college and on the opposite hillside the funicular. Aberystwyth is one of the great Welsh coastal towns. I love it.",
    type: "image",
  },
  {
    lat: 52.408627,
    lng: -4.089352,
    thumbnail: "./data/output_ims/Aberystwyth.jpg",
    name: "Aberystwyth (watercolour)",
    description:
      "Beneath the castle grounds the sweep of the great central Wales bay takes over. There’s the pier, the impressive old college and on the opposite hillside the funicular. Aberystwyth is one of the great Welsh coastal towns. I love it.",
    type: "image",
  },
  {
    lat: 52.55298034887173,
    lng: -3.9310035973297666 ,
    thumbnail: "./data/output_ims/16 Misty River, Mid Wales.jpg",
    name: "Misty River Dyfi Mid Wales",
    description:
      "The river cuts Wales in two and the mist rolling in from Snowdonia makes a stunning view to capture in watercolours. It’s a breathtaking moment just before Machynlleth.",
    type: "image",
  },
  {
    lat: 52.57892100152867,
    lng: -3.966070504538961,
    thumbnail: "./data/output_ims/16a Top of Route 82 above the golden valley sketch.jpg",
    name: "Top of Route 82 before the Golden Valley ",
    description:
      "A little used road (NCN 82) was recommended and I followed it up to a quiet bend overlooking the valley I had circumnavigated. The bare ancient tree caught my attention after a strenuous climb and I sketched it while taking a breather.",
    type: "image",
  },
  {
    lat: 52.58376224953823,
    lng: -4.088628355555737,
    thumbnail: "./data/output_ims/17 Talyllyn Railway sketchbook.jpg",
    name: "Tal-y-llyn Railway",
    description:
      "This is one of the original heritage railways in the coastal village of Tywyn. It was supported by Rev Awdry who wrote the Thomas the Tank Engine books and I sketched this steaming loco before it headed off on it’s popular round trip.",
    type: "image",
  },
  {
    lat: 52.68127776729377,
    lng: -4.068394961237404,
    thumbnail: "./data/output_ims/Barmouth Mawddach.jpg",
    name: "Barmouth Mawddach Estuary",
    description:
      "I found the narrowest of laybys to stop and carefully capture this view of the great mountains of Snowdonia and sweeping estuary. The train came along and passed below me. I put it into the painting.",
    type: "image",
  },
  {
    lat: 52.857545202054176,
    lng: -4.110439834911442,
    thumbnail: "./data/output_ims/19a Harlech castle.jpg",
    name: "Harlech Castle ",
    description:
      "There’s a rocky outcrop where JWM Turner found his iconic viewpoint of the great 13th Century castle. I was delighted to discover the exact same rock to stand and admire the breathtaking viewpoint. First I sketched it in pen and ink and then worked it up into this acrylic piece.",
    type: "image",
  },
  {
    lat: 52.857545202054176,
    lng: -4.110439834911442,
    thumbnail: "./data/output_ims/19 Harlech castle sketchbook.jpg",
    name: "Harlech Castle (sketchbook) ",
    description:
      "There’s a rocky outcrop where JWM Turner found his iconic viewpoint of the great 13th Century castle. I was delighted to discover the exact same rock to stand and admire the breathtaking viewpoint. First I sketched it in pen and ink and then worked it up into this acrylic piece.",
    type: "image",
  },
  {
    lat: 52.89531913342947,
    lng: -4.081031912801215,
    thumbnail: "./data/output_ims/19b Harlech Castle from the north sketchbook.jpg",
    name: "Harlech Castle from the North",
    description:
      " This is an unlikely glimpse of the castle near Tygwyn station close to Inys. JMW Turner painted this among his series of Welsh castles and like Turner I brought the castle forward in my sketch so that it overshadows the sheep in the foreground.",
    type: "image",
  },
  {
    lat: 52.915247739285505,
    lng: -4.239646710636673,
    thumbnail: "./data/output_ims/20 Criccieth Castle sketchbook.jpg",
    name: "Criccieth Castle (sketch)",
    description:
      "On a headland along the Llyn peninsula Criccieth castle looms over the town and narrow beach.  I found this view from the parkland and liked the dark foreboding silhouette.",
    type: "image",
  },
  {
    lat: 52.915247739285505,
    lng: -4.239646710636673,
    thumbnail: "./data/output_ims/20a Criccieth Castle watercolour.jpg",
    name: "Criccieth Castle (watercolour)",
    description:
      "On a headland along the Llyn peninsula Criccieth castle looms over the town and narrow beach.  I found this view from the parkland and liked the dark foreboding silhouette.",
    type: "image",
  },
  {
    lat: 52.93650317361433,
    lng: -4.531867745490717,
    thumbnail: "./data/output_ims/21a Nerfyn Bay sketchbook.jpg",
    name: "Nerfyn Beach",
    description:
      "High up on the Llyn coastal path I found this majestic scene looking northwards towards Anglesey. It’s hard to believe that at one stage this could have been the deep water harbour for the Irish shipping trade rather than Holyhead. But shipping, railway and traffic leaves this part of the Welsh coast  in a delightful timewarp.",
    type: "image",
  },
  {
    lat: 52.93650317361433,
    lng: -4.531867745490717,
    thumbnail: "./data/output_ims/21b Ty Coch Inn, Lyn Peninsula sketchbook.jpg",
    name: "Nerfyn Beach",
    description:
      "High up on the Llyn coastal path I found this majestic scene looking northwards towards Anglesey. It’s hard to believe that at one stage this could have been the deep water harbour for the Irish shipping trade rather than Holyhead. But shipping, railway and traffic leaves this part of the Welsh coast  in a delightful timewarp.",
    type: "image",
  },
  {
    lat: 52.943401840365986,
    lng: -4.567805137044796,
    thumbnail: "./data/output_ims/21b Ty Coch Inn, Lyn Peninsula sketchbook.jpg",
    name: "Ty Coch Inn",
    description:
      "Its one of the most difficult pubs to reach and one of the World’s top 10 beach bars. Wales has a utter gem here on the sand, only reached on foot(or bike) through the golf course. It’s wonderfully popular and to sit with your feet in the sea sipping something special looking at the mountains around you is one of life’s greatest pleasure.",
    type: "image",
  },
  {
    lat: 53.13849812209426,
    lng: -4.279218528679001,
    thumbnail: "./data/output_ims/22 Carnaervon Castle sketchbook (2).jpg",
    name: "Caernarfon Castle",
    description:
      "From every angle EdwardI’s masterpiece at Carnaervon looks wonderful. It’s candy striped walls are brought to life in the late afternoon sunlight.",
    type: "image",
  },
  {
    lat: 53.13610827442822,
    lng: -4.270794039164968,
    thumbnail: "./data/output_ims/23 Carnaervon Castle.jpg",
    name: "Caernarfon Castle",
    description:
      "It’s a viewpoint missed by many visitors. I came to this along the Welsh Highland railway as it enters the harbour where the old warehouses have been demolished. The castle is silhouetted against the evening sunset and its’ rippling reflection in the seawater shimmers.",
    type: "image",
  },
  {
    lat: 53.13952204176353,
    lng: -4.278236543430887,
    thumbnail: "./data/output_ims/23a Carnaervon Castle sketchbook.jpg",
    name: "Caernarfon (sketchbook)",
    description:
      "There are many craggy views of the castle and town walls. This is one of those through the gateway by the Anglesey Hotel.",
    type: "image",
  },
  {
    lat: 53.221880301759676,
    lng: -4.163006827677189,
    thumbnail: "./data/output_ims/Menai Susspension Bridge.jpg",
    name: "Menai Suspension Bridge",
    description:
      "Thomas Telford is a hero of the engineering age. He built hundreds of roads, bridges and canals across the country. I’m travelling so many of them on this circumnavigation. In 1826 the Menai Suspension bridge was opened. The first suspension bridge in the World and far higher than many thought possible (to allow sailing ships to still travel through these waters). From the roadway in the Menai Bridge township it soars into the sky and takes my breath away.",
    type: "image",
  },
  {
    lat: 53.22269854282324,
    lng: -4.183226644250803,
    thumbnail: "./data/output_ims/25 Menai straits oil.jpg",
    name: "Menai Straits (oil)",
    description:
      "From the layby you can see both the Menai and Britannia bridges and the fast flowing waters of the treacherous Menai Straits. I love the way Snowdonia frames the view.",
    type: "image",
  },
  {
    lat: 53.30686361093711,
    lng: -4.695994574836112,
    thumbnail: "./data/output_ims/26 South Stack Lighthouse, Holy island, Anglesey.jpg",
    name: "South Stack Lighthouse Holy Island, Anglesey",
    description:
      "This lighthouse on the edge of the Irish sea is clinging to the edge of a pinprick island, on a tiny island, by a modest island, part of a small island off the coast of Europe. The sun drops to the golden sea and the South Stack lighthouse reveals its splendour. It’s not easy to reach. But I did it.",
    type: "image",
  },
  {
    lat: 53.280216372986736,
    lng: -4.622598372776889,
    thumbnail: "./data/output_ims/27 Pyscho House Anglesey watercolour.jpg",
    name: "Pyscho House, Anglesey",
    description:
      "We all notice things along the way. Here in Treaddur Bay is something that looks like the house in the film Pyscho. It’s aapeared in lots of TV dramas because of that.",
    type: "image",
  },
  {
    lat: 53.287584733845115,
    lng: -4.650092288460159,
    thumbnail: "./data/output_ims/28 Dog on the beach Anglesey watercolour.jpg",
    name: "Dog on the Beach, Anglesey",
    description:
      "This could be any beach with a dog running on it. It speaks to us about the freedom and exuberation that comes from running across the pristine sands….",
    type: "image",
  },
  {
    lat: 53.251339778021,
    lng: -4.60785812654116,
    thumbnail: "./data/output_ims/28a stormy beach.jpg",
    name: "Stormy Beach",
    description:
      "The power of the sea is clearest on a stormy day with the foam flecks across the rocks and sky.",
    type: "image",
  },
  {
    lat: 53.26419655971345,
    lng: -4.089669663938819,
    thumbnail: "./data/output_ims/Beaumaris Castle Anglesea.jpg",
    name: "Beaumaris Castle",
    description:
      "Put up in a fraction of the time it might take to build something these days – Beaumaris is the castle that was built to impress and became obsolete before it was finished. By the moat this entrance is framed under the autumnal tree.",
    type: "image",
  },
  {
    lat: 53.28512878047394,
    lng: -3.830623780474226,
    thumbnail: "./data/output_ims/30 Conwy Castle watercolour.jpg",
    name: "Conwy Castle",
    description:
      "There are stunning views of Edward I’s castle along the river Conwy. This is probably the most recognized and I was surprised it doesn’t appear in Turner’s collection of work from his visits here.",
    type: "image",
  },
  {
    lat: 53.27852664795307,
    lng: -3.822307176455561,
    thumbnail: "./data/output_ims/31 Conwy Castle sketchbook.jpg",
    name: "Conwy Castle (pen & ink)",
    description:
      "This unlikely aspect of Conwy Castle is the one made famous by Joseph Turner. I found the rocky part of the coast where he had stood and was delighted to discover all is the same (except for the railway bridge that was completed after Turner’s visit in 1798).",
    type: "image",
  },
  {
    lat: 53.283467369002345,
    lng: -3.817674502942919,
    thumbnail: "./data/output_ims/32 Conway castle sunset.jpg",
    name: "Conwy Sunset (watercolour)",
    description:
      "There is a glorious Conwy atmosphere under the moody Snowdonia skies.",
    type: "image",
  },
  {
    lat: 53.33664665706446,
    lng: -3.8318498051084324,
    thumbnail: "./data/output_ims/33 Great Orme, Llandudno sketchbook.jpg",
    name: "Great orme & llandudno (sketchbook)",
    description:
      "The four mile ride around the Great Orme reveals all sorts of stirring scenes to paint. As the road climbs up from the pier I turned to admire the rock strata and the light on Victorian Llandudno.",
    type: "image",
  },
  {
    lat: 53.32797137552257,
    lng: -3.8306761417441275,
    thumbnail: "./data/output_ims/34 Llandudno from the Bryn Y Mor   sketchbook.jpg",
    name: "Llandudno from the Bryn Y Mor (sketch)",
    description:
      "From the lounge of the Bryn Y More guest house I watched the rain clouds clear and the sunlight sparkle on the wet rooves of the town.",
    type: "image",
  },
  {
    lat: 53.338297493930746,
    lng: -3.847560155656404,
    thumbnail: "./data/output_ims/35 Great Orme sketchbook.jpg",
    name: "Great Orme (sketch)",
    description:
      "There are many ways to enjoy the Great Orme mountain including riding the funicular up to the café at the top. I chose to pedal around the jagged rocky cliffs. Here the sun cast long shadows out into the sea which glistened in the sunlight.",
    type: "image",
  },
  {
    lat: 53.338297493930746,
    lng: -3.847560155656404,
    thumbnail: "./data/output_ims/35a Great Orme, llandudno acrylic.jpg",
    name: "Great Orme (acrylic)",
    description:
      "There are many ways to enjoy the Great Orme mountain including riding the funicular up to the café at the top. I chose to pedal around the jagged rocky cliffs. Here the sun cast long shadows out into the sea which glistened in the sunlight.",
    type: "image",
  },
  {
    lat: 53.21131362097341,
    lng: -3.9959966694304527,
    thumbnail: "./data/output_ims/36 Aber falls, Llanfairfechan.jpg",
    name: "Aber Falls, Llanfairfechan (watercolour)",
    description:
      "This is popular beauty spot waits until you are at very end of the rough and winding track before revealing it’s full impact.",
    type: "image",
  },
  {
    lat: 53.30536572693886,
    lng: -3.2360386282862725,
    thumbnail: "./data/output_ims/37 Duke of Lancaster ship Mostyn sketchbook.jpg",
    name: "Duke of Lancaster Ship, Mostyn ",
    description:
      "It’s one of those oddities that attracts the curious. Back in the 1980’s this old ship was a nightclub along the North Wales coast.",
    type: "image",
  },

  // Scotland paintings
  {
    lat: 54.97574510733922,
    lng: -3.5229566699865194,
    thumbnail: "./data/output_ims/01 Caerlaverock castle sketchbook.jpg",
    name: "Caerlaverock Castle (sketchbook)",
    description:
      "Complete with moat, this is the sight that greets you at Caerlaverock, this stunning and unusual castle. ",
    type: "image",
  },
  {
    lat: 54.97525629831756, 
    lng: -3.5245473739544555,     
    thumbnail: "./data/output_ims/03 Caerlaverock Castle.jpg", 
    name: "Caerlaverock Castle, Galloway", 
    description: 
      "This is the only three-sided castle in Europe and it was built to defend the southern reaches of Galloway and the entrance to the Nith valley. The three sides make it unique in so many ways, and like Joseph Turner I was determined to explore and paint it. ", 
    type: "image", 
  }, 
  {
    lat: 55.002434907407256,
    lng: -3.5742942845043792, 
    thumbnail: "./data/output_ims/04 Nith estuary, Galloway.jpg ", 
    name: "Nith Estuary, Galloway ", 
    description: 
      "The River Nith runs through Dumfries into a wide bay at Glencaple before the Solway Firth. The weather is always determined by what’s happening on the Eildon hills opposite. ", 
    type: "image", 
  }, 
  {
    lat: 54.837270420421966, 
    lng: -4.053722637786504, 
    thumbnail: "./data/output_ims/05 Kirkcudbright castle.jpg ", 
    name: "Kirkcudbright Castle", 
    description: 
      "As the sun sinks over the Solway Firth, Kirkcudbright Castle is illuminated in festive glory. I love the shadows cast by the nearby terraces. ", 
    type: "image",
  }, 
  {
    lat: 54.839229336149266,
    lng: -4.051605925740956, 
    thumbnail: "./data/output_ims/05b Kirkcudbright Castle sketchbook.jpg ", 
    name: "Kirkcudbright on the River ", 
    description: 
      "By the bridge to the artists town I stopped to sketch the wharf, castle and cluster of cottages that make Kirkcudbright such an attractive town.", 
    type: "image", 
  }, 
  {
    lat: 54.98044556404078, 
    lng: -3.6180857007517337, 
    thumbnail: "./data/output_ims/06a Sweetheart Abbey, Galloway sketchbook.jpg ",
    name: "Sweetheart Abbey (sketchbook)", 
    description: 
      "These ruins in the village of New Abbey have a delightful love story attached. From the graveyard, in the drizzle, with crows circling overhead it has a distinctive appearance…",
      type: "image", 
  }, 
  {
    lat: 54.98044556404078, 
    lng: -3.6180857007517337, 
    thumbnail: "./data/output_ims/sweetheart Abbey Galloway watercolour.jpg ",
    name: "Sweetheart Abbey (watercolour) ", 
    description: 
      "These ruins in the village of New Abbey have a delightful love story attached. From the graveyard, in the drizzle, with crows circling overhead it has a distinctive appearance…",
      type: "image", 
  }, 
  {
    lat: 54.87315104565013,
    lng: -4.235925690602714,
    thumbnail: "./data/output_ims/07b Skyreburn Bridge acrylic.jpg ", 
    name: "Skyreburn Bridge", 
    description: 
      "My dad found this scene and painted it on a holiday in 1966. Over 50 years later, after much searching and scrambling, I discovered the exact rock he’d stood on and created my painting of this view. Both pieces are in the Kirkcudbright Art Gallery.", 
    type: "image", 
  },
  {
    lat: 54.89342165814072,
    lng: -4.302975753666268,
    thumbnail: "./data/output_ims/08 Galloway coast from the old military road.jpg ", 
    name: "Galloway Coast on Old Military Road", 
    description: 
      "The road is little used (except by cyclists), but the view of the Wigtown peninsula from the summit is worth the effort.", 
    type: "image", 
  },
  {
    lat: 54.86436828851663,
    lng: -4.094407112035654,
    thumbnail: "./data/output_ims/09 sping colours roadside Galloway.jpg ", 
    name: "Spring Colours on the Roadside", 
    description: 
      "My route is decorated every mile with verge-side splendour. I am astounded by the variety.", 
    type: "image", 
  },
  {
    lat: 54.93463481828211,
    lng: -4.4565063077596365,
    thumbnail: "./data/output_ims/10 River Cree Wigtownshire.jpg ", 
    name: "River Cree, Wigtownshire", 
    description: 
      "Sometimes it makes a difference to look back over where I’ve come from. The purple mountains I pedalled through frame the reeds by the soft river in this secret part of the lowlands.", 
    type: "image", 
  },
  {
    lat: 54.87814621993683,
    lng: -4.820422011541478,
    thumbnail: "./data/output_ims/11 Glenluce railway bridge Galloway.jpg ", 
    name: "Glenluce Railway Bridge", 
    description: 
      "Much of the old railway network in Galloway has been swept away, and though the Stranraer line clings onto hope, this Glenluce viaduct carries no trains. The reflections add to the impressive scale of the engineering.", 
    type: "image", 
  },
  {
    lat: 54.89065937149273,
    lng: -4.830797331223794,
    thumbnail: "./data/output_ims/12 Glenluce Abbey sketchbook.jpg ", 
    name: "Glenluce Abbey (sketchbook)", 
    description: 
      "On the old St Ninian pilgrimage route taken by Robert the Bruce in 1320, Glenluce Abbey was an important establishment. Now it’s a quiet little ruin among the fields of sheep.", 
    type: "image", 
  },
  {
    lat: 54.84190248037354,
    lng: -5.117140857484062,
    thumbnail: "./data/output_ims/13a Portpatrick, Galloway sketchbook.jpg ",
    name: "Portpatrick (sketchbook)",
    description:
      "Portpatrick is a gem on the Mull of Galloway. It’s easy to see why people flock here to embrace the links to Ireland just across the water.", 
    type: "image", 
  },
  {
    lat: 54.84190248037354,
    lng: -5.117140857484062,
    thumbnail: "./data/output_ims/Portpatrick harbour watercolour.jpg ",
    name: "Portpatrick (watercolour)",
    description:
      "Portpatrick is a gem on the Mull of Galloway. It’s easy to see why people flock here to embrace the links to Ireland just across the water.", 
    type: "image", 
  },
  {
    lat: 55.40655811334931, 
    lng: -4.759676095902461,
    thumbnail: "./data/output_ims/14 Dunure castle waterc olour.jpg ",
    name: "Dunure Castle - a Game of Thrones Set Location",
    description:
      "Near to the Electric Braes optical illusion is the ‘seen to be believed’ Dunure Castle. Used recently as a location in Game of Thrones, it has a rugged permanence on the cliff with Paddy’s Milestone (Craig Ailsa) in the bay beyond.", 
    type: "image", 
  }, 
  {
    lat: 55.57671246003989, 
    lng: -5.138217103900762,
    thumbnail: "./data/output_ims/15a Goats Head mountain Arran sketchbook.jpg ",
    name: "Goatfell, Isle of Arran",
    description:
      "Coming off the ferry at Brodick, Goatfell mountain fills the vista across the bay. On a misty day there’s an air of trepidation and excitement as you aim to cross the island.", 
    type: "image", 
  },
  {
    lat: 55.673214727864625, 
    lng: -5.192999920148656,
    thumbnail: "./data/output_ims/16 Lochranza Arran.jpg ",
    name: "Lochranza",
    description:
      "Arran is often described as Scotland in miniature and the cascading North Sannox burn  is a favourite place to stop and catch your breath.", 
    type: "image", 
  },
  {
    lat: 55.70260246209679, 
    lng: -5.287151783592828,
    thumbnail: "./data/output_ims/17 Lochranza Arran watercolour.jpg ",
    name: "Lochranza Castle",
    description:
      "In the bay, Lochranza Castle seems to guard against the rain clouds coming across from the Mull of Kintyre. It’s a place of shelter for small and tall ships.", 
    type: "image", 
  },
  {
    lat: 55.86413288513772,   
    lng: -5.409280893399056,
    thumbnail: "./data/output_ims/18 Tarbert castle watercolour.jpg ",
    name: "Tarbert Castle",
    description:
      "In fine Spring sunshine, the bluebells carpet the rocks around the ruined castle. Here Robert the Bruce contemplated the scale of the challenges he faced and overcame.", 
    type: "image", 
  },
  {
    lat: 55.865972188475105,   
    lng: -5.413247403536947,
    thumbnail: "./data/output_ims/19 Tarbert sketchbook.jpg ",
    name: "Tarbert Harbour",
    description:
      "The pretty coloured houses of Tarbert line the edge of the harbour, where the boats line up to add even more shades. Tarbert is a delight.", 
    type: "image", 
  },
  {
    lat: 55.86585419220411,    
    lng: -5.413510256965655,
    thumbnail: "./data/output_ims/20 Tarbert.jpg ",
    name: "Tarbert",
    description:
      "In all directions Tarbert is a joy. The unusual church tower dominates the row of homes beneath the wooded hills and boats rest in the sheltered harbour.", 
    type: "image", 
  },
  {
    lat: 55.90300581739592,     
    lng: -5.421322752715185,
    thumbnail: "./data/output_ims/21 cornflowers and poppies.jpg ",
    name: "Cornflowers and Poppies",
    description:
      "The exuberance of colours in the fields of poppies and cornflowers under big skies make the Lochsides of Argyll a wonderful place to see the seasons.", 
    type: "image", 
  },
  {
    lat: 56.23708376005947,      
    lng: -5.073585297392012,
    thumbnail: "./data/output_ims/23 Inverary Castle sketchbook.jpg ",
    name: "Inverary Castle",
    description:
      "Inverary was restored in the 50s and features in the mini-series ‘A Great British Scandal’. In late spring the garden is ablaze with shrubs in full bloom. I made this sketch of the shapes and shadows on Inverary.", 
    type: "image", 
  },
  {
    lat: 56.23099920967702,     
    lng: -5.071221941481651,
    thumbnail: "./data/output_ims/24 Rain over Inverary.jpg ",
    name: "Be Prepared",
    description:
      "From the little harbour ferries used to work across Loch Fyne. I like the many shades of grey that come in the space of a few minutes as the weather changes.", 
    type: "image", 
  },
  {
    lat: 56.23130075074084,     
    lng: -5.071559536148691,
    thumbnail: "./data/output_ims/25 Red boat Inverary (2).jpg ",
    name: "The Red Boat",
    description:
      "A feature of Inverary harbour is the red boat that shows defiance against the dark mountains around.", 
    type: "image", 
  },
  {
    lat: 56.23130075074084,     
    lng: -5.071559536148691,
    thumbnail: "./data/output_ims/25a Red boat  rainy Inverary sketchbbok.jpg ",
    name: "The Red Boat across the Cove",
    description:
      "A feature of Inverary harbour is the red boat that shows defiance against the dark mountains around.", 
    type: "image", 
  },
  {
    lat: 56.225435909085405,
    lng: -4.856255920572089,
    thumbnail: "./data/output_ims/27 Rest and Be Thankful and military road, Argyll & Bute sketchbook.jpg ",
    name: "Rest and Be Thankful",
    description:
      "The old military road runs down the valley under The Cobbler mountain. Here soldiers in the 18th century carved a stone next to their great work - “Rest and be Thankful”.", 
    type: "image", 
  },
  {
    lat: 56.43952868958664, 
    lng: -5.232330283543838,
    thumbnail: "./data/output_ims/28 Taynuilt sunset Loch Bonawe watercolour.jpg ",
    name: "Sunset at Kelly’s Pier",
    description:
      "Loch Etive is narrowest at Taynuilt and Bonawe. Here the summer sunsets are long, late, and reflected in the deep cool waters of the Loch.", 
    type: "image", 
  },
  {
    lat: 56.45753111422421, 
    lng: -5.396963021013302,
    thumbnail: "./data/output_ims/29 Connel Bridge, Oban sketchbook.jpg ",
    name: "Connel Bridge (sketchbook)",
    description:
      "This magnificent bridge used to carry the railway from Oban to Glencoe. Now it links the town with the nearby airport.", 
    type: "image", 
  },
  {
    lat: 56.409478829618145, 
    lng: -5.481760534387728,
    thumbnail: "./data/output_ims/30 Pulpit Hill Oban sketchbook.jpg ",
    name: "Pulpit Hill, Oban",
    description:
      "Oban curves around it’s natural harbour and is ringed by great viewpoints including Pulpit Hill. From here you look down on the Calmac ferries that link Oban with the Hebridean islands.", 
    type: "image", 
  },
  {
    lat: 56.42313462662632, 
    lng: -5.4833389023730845,
    thumbnail: "./data/output_ims/31 Dog Stone, Oban sketchbook.jpg ",
    name: "Dog Stone, Oban",
    description:
      "This huge rock with trees growing from it’s summit is a curious landmark, with the nearby castle of Dunolie adding to the legends that are associated with it.", 
    type: "image", 
  },
  {
    lat: 56.411520515434034,  
    lng: -5.522111389094017,
    thumbnail: "./data/output_ims/31 Ferry to Mull.jpg ",
    name: "Ferry in Oban Sound",
    description:
      "From the island of Kerrera you see the ferries coming and going across to Mull and beyond. The square rocks on the shore make natural defences.", 
    type: "image", 
  },
  {
    lat: 56.30651384099111,  
    lng: -6.366623348604927,
    thumbnail: "./data/output_ims/32 Fionnphort sunset  Mull sketchbook.jpg ",
    name: "Secret Sunset",
    description:
      "The bays and sheltered inlets at the tip of the Isle of Mull are the favourite places of open water swimmers.", 
    type: "image", 
  },
  {
    lat: 56.33450938514632,  
    lng: -6.39001465659898,
    thumbnail: "./data/output_ims/33 St Columba's Abbey, Iona.jpg ",
    name: "St Columba’s Abbey, Iona",
    description:
      "Surrounded by sheep and foxgloves, the rugged abbey of St Columba on Iona has been a place of pilgrimage for centuries. It blends into the soft Hebridean sky, awaiting the pilgrim.", 
    type: "image", 
  },
  {
    lat: 56.430952090245256,   
    lng: -6.341784784002928,
    thumbnail: "./data/output_ims/34 Staffa Hebrides - Fingals Cave.jpg ",
    name: "Isle of Staffa",
    description:
      "When Turner visited 200 years ago, he painted Staffa shrouded in smoke from the tourist steam ship. I’ve chosen my view of Fingal’s Cave on the edge of Staffa, and the small tourist boat approaching in awe.", 
    type: "image", 
  },
  {
    lat: 56.325235605919474,
    lng: -6.366315594360764,
    thumbnail: "./data/output_ims/36 Iona sunset watercolour.jpg ",
    name: "Iona Sunset",
    description:
      "From the beach at Fionnphort, the island of Iona is wreathed in a sunset halo, the sea a liquid pool of reflected colour. The majesty of the Hebrides lasts till the very close of day.", 
    type: "image", 
  },
  {
    lat: 56.682596212215024,
    lng: -5.981425069036241,
    thumbnail: "./data/output_ims/37 Ardnaurchan Kilchoan sketchbook.jpg ",
    name: "Bay of Pledges (sketchbook)",
    description:
      "The viewpoint on the Ardnamurchan road reveals a blowy wild landscape above the Bay of Pledges.", 
    type: "image", 
  },
  {
    lat: 56.74313008693078,
    lng: -5.7938834001516,
    thumbnail: "./data/output_ims/37a Ardnamurchan watercolour.jpg ",
    name: "Ardnamurchan Peninsula",
    description:
      "The A road carries little traffic and people walking their dogs stop to chat along the way. In Spring the rhododendrons cover the Loch side and bring a sparkle of colour to the rain-washed mountains.", 
    type: "image", 
  },
  {
    lat: 57.07325105289188,
    lng: -5.890116749833079,
    thumbnail: "./data/output_ims/38 Mallaig mountains from Skye sketchbook.jpg ",
    name: "Mallaig",
    description:
      "From the ferry at Armadale the road clings to the coast. Across the water Mallaig is the end of the line and the landscape is wild and weather worn.", 
    type: "image", 
  },
  {
    lat: 57.2726202492331,
    lng: -5.728035012960934,
    thumbnail: "./data/output_ims/39 Castle Maol Kyleakin, Skye sketchbook.jpg ",
    name: "Kyleakin Castle (sketchbook)",
    description:
      "The bridge from Skye has left Kyleakin a pretty undisturbed backwater. The ferry to Kyle of Lochalsh used to leave from beneath the castle ruins. It’s worth the diversion to find this piece of magic.", 
    type: "image", 
  },
  {
    lat: 57.56538037447106,
    lng: -5.361431312579913,
    thumbnail: "./data/output_ims/40 Torridon Glen Highlands watercolour.jpg ",
    name: "Torridon Glen Mountain Stream",
    description:
      "Shafts of watercolour sunlight cascade down the glen to sparkle on the cool mountain stream hurrying to the sea.", 
    type: "image", 
  },
  {
    lat: 57.530958431502526,
    lng: -5.520138967272629,
    thumbnail: "./data/output_ims/41 misty Torridon Glen sketchbook.jpg ",
    name: "Misty Ben Alligin sketch",
    description:
      "Above the tiny village of Torridon looms the mighty Ben Alligin range of mountains. The mist closing in makes them all the more mysterious in my sketchbook.", 
    type: "image", 
  },
  {
    lat: 57.54965456683928,
    lng: -5.4617210508974825,
    thumbnail: "./data/output_ims/42 Torridon Glen Highlands sketchbook.jpg ",
    name: "Torridon Glen",
    description:
      "The single-track road winds through this lonely steep valley. Hauntingly beautiful.", 
    type: "image", 
  },
  {
    lat: 57.39621791406012,
    lng: -5.602326797286393,
    thumbnail: "./data/output_ims/43 Bealach Na Ba Applecross watercolour.jpg ",
    name: "Bealach Na Blaaah!",
    description:
      "The Applecross challenge is not to be undertaken lightly. You ride to the top of these deep blue peaks for the views of heaven – on a clear day.", 
    type: "image", 
  },
  {
    lat: 57.52325522901771,
    lng: -5.634000661057779,
    thumbnail: "./data/output_ims/44 Shieldaig road, Highlands sketchbook.jpg ",
    name: "Shieldaig (sketchbook)",
    description:
      "There’s a lunar landscape among the jagged rocks and lochs of this lonely stretch.", 
    type: "image", 
  },
  {
    lat: 57.86425718746701,
    lng: -5.542886625814675,
    thumbnail: "./data/output_ims/45 Gruinard Island Highlands watercolour.jpg ",
    name: "Gruinard Island",
    description:
      "It’s clear of Anthrax so they say. The uninhabited mysterious island of Gruinard draws your eye and the imagination….", 
    type: "image", 
  },
  {
    lat: 57.75574513545546,
    lng: -5.021059468138175,
    thumbnail: "./data/output_ims/46 Corrieshalloch Gorge sketchbook.jpg ",
    name: "Corrieshalloch Gorge",
    description:
      "Everyone spoke of the Corrieshalloch gorge  because you can’t miss it as you pedal down the pass towards Ullapool. However, it’s when you walk down the track to footbridge and are confronted by the Falls of Measach that your mouth opens in amazement. Your breath is taken away by the stunning drop beneath your feet.", 
    type: "image", 
  },
  {
    lat: 58.06328868146514,
    lng: -5.265837203947105,
    thumbnail: "./data/output_ims/47 Highland range above Lochinver.jpg ",
    name: "Highland Range above Lochinver",
    description:
      "Around the bends of this empty road the range of volcano alley looms large. It sets the mind racing and the brave choose to climb each and every Munro.", 
    type: "image", 
  },
  {
    lat: 58.04717965376545,
    lng: -5.279727228953638,
    thumbnail: "./data/output_ims/48 Lochinver mountains on the wee daft road watercolour.jpg ",
    name: "The Wee Daft Road",
    description:
      "Nothing can be more appealing than the wee daft road that hugs the gorse verged lochside beneath the volcanic plugs of Stac Pollaidh.", 
    type: "image", 
  },
  {
    lat: 58.257449017688366,
    lng: -5.027133884199624,
    thumbnail: "./data/output_ims/49 Kylesku bridge sketchbook.jpg ",
    name: "Kylesku sketch",
    description:
      "The pedal across the windy squealing Kylesku Bridge caused me to stop and catch my breath.", 
    type: "image", 
  },
  {
    lat: 58.257449017688366,
    lng: -5.027133884199624,
    thumbnail: "./data/output_ims/50 Sluiven above Kylesku bridge Highlands sketchbook.jpg ",
    name: "The Suilven Range",
    description:
      "It’s the wildest most remote part of the North Coast 500 and these mountains formed from long dead volcanos have a grim majesty.", 
    type: "image", 
  },
  {
    lat: 58.62593760466964,
    lng: -4.9988619000647,
    thumbnail: "./data/output_ims/51 Cape Wrath sketchbook.jpg ",
    name: "Beneath Cape Wrath",
    description:
      "These are the tallest cliffs in mainland Britain and looking down from the lighthouse at Cape Wrath I am reminded of their remoteness.", 
    type: "image", 
  },
  {
    lat: 58.61228907111877,
    lng: -4.985157411483326,
    thumbnail: "./data/output_ims/52 Cape Wrath watercolour.jpg ",
    name: "Cape Wrath Stacks",
    description:
      "At the very tip of Britain are the tallest cliffs on the mainland. The access is limited along a rugged track and the North Sea disappears into the great swirling mists. This is not a place for the faint hearted.", 
    type: "image", 
  },
  {
    lat: 58.501426023635226,
    lng: -4.56230914937613,
    thumbnail: "./data/output_ims/54 Moine House, Tongue Highlands sketchbook.jpg ",
    name: "Moine House",
    description:
      "It’s a spooky ruin now, but once upon a time this was one of the few places to stay along the great north road between Durness and Bettyhill.", 
    type: "image", 
  },
  {
    lat: 58.670960002262795,
    lng: -3.377241202779344,
    thumbnail: "./data/output_ims/Dunnet Head Caithness Longest Day.jpg ",
    name: "Dunnet Head, Longest Day",
    description:
      "I came here to the most northerly point to watch the sun go down across the Pentland Firth. Puffins flew below me; orcas are often seen here. The old Man of Hoy on the Orkneys beckon….", 
    type: "image", 
  },
  {
    lat: 58.670960002262795,
    lng: -3.377241202779344,
    thumbnail: "./data/output_ims/56 Dunnet Head sketchbook.jpg ",
    name: "Dunnet Head Cliffs",
    description:
      "The way the land ends abruptly on these monumental cliffs always fascinates me. Everything has a beginning and an end, and some endings are more dramatic than others.", 
    type: "image", 
  },
  {
    lat: 58.441101250336786,
    lng: -3.0938850996550933,
    thumbnail: "./data/output_ims/57 Wick sunset from Mackay Hotel.jpg ",
    name: "Wick Sunset",
    description:
      "", 
    type: "image", 
  },
  {
    lat: 58.441101250336786,
    lng: -3.0938850996550933,
    thumbnail: "./data/output_ims/57a Wick Sunset westwards Mackay Hotel.jpg ",
    name: "Wick Sunset (westwards)",
    description:
      "", 
    type: "image", 
  },
  {
    lat: 58.439531006295034,
    lng: -3.087051072125499,
    thumbnail: "./data/output_ims/58 Black Steps, Wick.jpg ",
    name: "Black Steps, Wick",
    description:
      "Artist LS Lowry came to Wick on holiday and stayed with his aunt. He chose to paint these black steps and his work has become a byword for observation. Looking the other way, he’d have seen the herring boats in the harbour but these steps (leading who knows where) appealed to his sense of curiosity.", 
    type: "image", 
  },
  {
    lat: 58.29846928347029,
    lng: -3.2913978509728024,
    thumbnail: "./data/output_ims/59 Lybster Harbour sketchbook.jpg ",
    name: "Lybster Harbour Sketch",
    description:
      "It’s a steep drop down from the village of Lybster to the purpose-built harbour. In times gone past the herring fleets used this. Now it waits for the artist…", 
    type: "image", 
  },
  {
    lat: 58.116607371094446,
    lng: -3.6550385614990044,
    thumbnail: "./data/output_ims/60 Helmsdale, Sutherland.jpg ",
    name: "Helmsdale",
    description:
      "The grand clock tower is one of the many landmarks around this pretty village.", 
    type: "image", 
  },
  {
    lat: 57.34495762674927,
    lng: -1.9922594499273483,
    thumbnail: "./data/output_ims/60a Road to Newburgh  sketchbook.jpg ",
    name: "Road to Newburgh",
    description:
      "It’s a simple road leading by the waterside around the corner to a floral village. I painted my feeling of anticipation on an ordinary road. Everything is new and different.", 
    type: "image", 
  },
  {
    lat: 57.6839020914535,
    lng: -4.036898678686479,
    thumbnail: "./data/output_ims/61 Cromarty Bay watercolour.jpg ",
    name: "Cromarty Bay",
    description:
      "The collection of giant oil platforms and wind turbine sleeves fascinates us. The juxtaposition of old and new technologies. These oil platforms are barely half a century old and are redundant.", 
    type: "image", 
  },
  {
    lat: 57.57375009395336,
    lng: -4.0940227744459134,
    thumbnail: "./data/output_ims/62 Chanonry point sunset sketchbook.jpg ",
    name: "Chanonry Point Sunset",
    description:
      "It’s a peaceful magical point on the Moray Firth. People gather here to watch for dolphins.", 
    type: "image", 
  },
  {
    lat: 57.931161275849405,
    lng: -4.040626536717027,
    thumbnail: "./data/output_ims/62a Skelbo castle sketchbook.jpg ",
    name: "Skelbo Castle",
    description:
      "A few ragged ruins by Loch Fleet have the perfect view of seals basking on the shore. This castle has almost played important parts in history, but in the end their ideal place is as romantic ruins.", 
    type: "image", 
  },
  {
    lat: 57.58123461684326,
    lng: -4.130769904900694,
    thumbnail: "./data/output_ims/63 Fortruse Abbey sketchbook.jpg ",
    name: "Fortuse Abbey",
    description:
      "The red sandstone arches and walls survive from the golden age of ecclesiastical power and importance. Scotland’s reformation may have closed the abbeys but the ruins still speak to us.", 
    type: "image", 
  },
  {
    lat: 57.982783985809654,
    lng: -3.9462229819526304,
    thumbnail: "./data/output_ims/64 Dunrobin castle sketchbook.jpg ",
    name: "Dunrobin Castle",
    description:
      "The Duke of Sutherland’s fairytale castle on the east coast. The avenue of trees down from the Duke’s personal railway station frames the palace perfectly.", 
    type: "image", 
  },
  {
    lat: 57.692739242089,
    lng: -2.9151783832896037,
    thumbnail: "./data/output_ims/64a Findochty Castle sketchbook.jpg ",
    name: "Findochty Castle Sketch",
    description:
      "Outside this charming village with the harbourside white statue of the wee Mannie are these ruins. The remains of an ancient castle and old shepherd’s hut.", 
    type: "image", 
  },
  {
    lat: 57.70530999667417,
    lng: -2.8520655534027477,
    thumbnail: "./data/output_ims/65b Bowfiddle rock watercolour.jpg ",
    name: "Bowfiddle Rock",
    description:
      "It’s one of those natural wonders that always surprises. It’s easy to see where it gets its name.", 
    type: "image", 
  },
  {
    lat: 57.67614942734232,
    lng: -2.324795592381012,
    thumbnail: "./data/output_ims/66 Crovie Aberdeenshire watercolour.jpg ",
    name: "Crovie",
    description:
      "This village clings to base of the cliff and is accessible by one single track along the front of the houses. It’s picture postcard stuff and it’s real. It would be easy to cycle past. Thanks for the tip!", 
    type: "image", 
  },
  {
    lat: 57.67101033052072,
    lng: -2.1930985142856314,
    thumbnail: "./data/output_ims/67 Aberdour beach sketchbook.jpg ",
    name: "Aberdour Beach Sketch",
    description:
      "The cliffs have changed to red sandstone, and this is a beach rarely visited except by those who have made the discovery….", 
    type: "image", 
  },
  {
    lat: 57.41499178967815,
    lng: -1.8330374458480985,
    thumbnail: "./data/output_ims/67a Slains castle, sketchbook.jpg ",
    name: "Slains Castle",
    description:
      "There’s something spooky and ominous about these tall walls and narrow walkways through Slain’s castle. It’s easy to see how Bram Stoker got his inspiration for Dracula from such places.", 
    type: "image", 
  },
  {
    lat: 56.945368089771456,
    lng: -2.199600667771123,
    thumbnail: "./data/output_ims/68 Dunottar Castle watercolour.jpg ",
    name: "Dunnottar Castle",
    description:
      "Turner came here 200 years ago and was fascinated to see something so precarious. Dunnottar survives and enthralls everyone who makes the pilgrimage.", 
    type: "image", 
  },
  {
    lat: 56.75101941593214,
    lng: -2.451831970718282,
    thumbnail: "./data/output_ims/69 Montrose bridge watercolour.jpg ",
    name: "Montrose Bridge",
    description:
      "Two bridges. The old railway bridge is now a cycleway, and the road bridge sweeps majestically across the River North Esk.", 
    type: "image", 
  },
  {
    lat: 56.56236364878751,
    lng: -2.582803276252985,
    thumbnail: "./data/output_ims/70 Arbroath Abbey ssketchbook.jpg ",
    name: "Arbroath Abbey",
    description:
      "It’s a setting that resonates with Scots. The Arbroath declaration has survived through the centuries, and this is where it was written.", 
    type: "image", 
  },
  {
    lat: 56.560485750639224,
    lng: -2.5560137284606315,
    thumbnail: "./data/output_ims/71 Rugged  Red cliffs Arbroath.jpg ",
    name: "Red Rocks Arbroath",
    description:
      "The Deil’s Heid is a famous landmark along the sandstone cliffs of Arbroath. I love the gulls wheeling in the thermals and the views out to the Bell rock lighthouse.", 
    type: "image", 
  },
  {
    lat: 56.34098345164207,
    lng: -2.7880170861454774,
    thumbnail: "./data/output_ims/72 St Andrew's castle  sketchbook.jpg ",
    name: "St Andrews Castle",
    description:
      "Among the reasons to visit St Andrews are golf, Chariots of Fire and fine food. This little cliff top path leads to a view of the old castle that I love.", 
    type: "image", 
  },
  {
    lat: 56.20925783480722,
    lng: -2.756192582055729,
    thumbnail: "./data/output_ims/73 St Monans windmill Fife sketchbook.jpg ",
    name: "St Monan’s windmill ",
    description:
      "St Monan’s in the Kingdom of Fife looks across to the Bass Rock. Although the breeze has long since ceased turning the sails on this iconic windmill the summer blooms beckon…", 
    type: "image", 
  },
  {
    lat: 55.99014938399419,
    lng: -3.3958139875966733,
    thumbnail: "./data/output_ims/76 Forth Bridge watercolour.jpg ",
    name: "Forth Bridge",
    description:
      "Among Britain’s World Class bridges the Forth rail crossing is second to none.", 
    type: "image", 
  },
  {
    lat: 56.00463364958898,
    lng: -2.5240141188367584,
    thumbnail: "./data/output_ims/77 Dunbar watercolour.jpg ",
    name: "Dunbar",
    description:
      "The Bass Rock dominates the Lothian coastline. Sunny Dunny has a brilliant view – it earns it’s nickname most days – except today!", 
    type: "image", 
  },
  {
    lat: 55.89949732131193,
    lng: -2.1317247058642024,
    thumbnail: "./data/output_ims/78 St Abbs watercolour.jpg ",
    name: "St Abbs",
    description:
      "Coastal fishing villages resonate with us, and one that boasts lobsters has got to be special. St Abbs is special.", 
    type: "image", 
  },
  {
    lat: 56.18176347324841,
    lng: -4.768994587613737,
    thumbnail: "./data/output_ims/79 Loch Long.jpg ",
    name: "Loch Long",
    description:
      "Heading down the well named Loch Long the three Lochs Way is a tempting track to follow. The immensity of Scotland’s Lochs and mountains becomes apparent.", 
    type: "image", 
  },
  {
    lat: 56.24298815173375,
    lng: -4.68564168260541,
    thumbnail: "./data/output_ims/80 Loch Lomond.jpg ",
    name: "Loch Lomond",
    description:
      "Take the high road or low road, or even take to the water. At Inversnaid the old oak tree stands stark and sculptured near the impressive waterfalls.", 
    type: "image", 
  },
  {
    lat: 56.23227579174802,
    lng: -4.402145114774509,
    thumbnail: "./data/output_ims/81 Ben Venue.jpg ",
    name: "Ben Venue",
    description:
      "This wonderful blue peak is one of the tallest of the 240+ Munros. By the side of Loch Katrine it beckons the adventurous.", 
    type: "image", 
  },
  {
    lat:  56.34461776323976,
    lng: -4.470891033011613,
    thumbnail: "./data/output_ims/82 Loch Voil.jpg ",
    name: "Loch Voil",
    description:
      "Its remoteness in the Trossachs makes it one of the most appealing dead end roads. From Monachyle Mohr there’s a view through the open gate onto the surrounding mountains that funnel the weather down the loch.", 
    type: "image", 
  },
  {
    lat:  56.407745071552725,
    lng: -4.3168222068072195,
    thumbnail: "./data/output_ims/83 Glen ogle Viaduct.jpg ",
    name: "Glen Ogle Viaduct",
    description:
      "Mistaken by many as the Harry Potter Glenfinnan viaduct. Glen Ogle is made of Stone – while the other is concrete. Secondly and most importantly, you can cycle and walk across Glen Ogle high up on the old Stirling to Oban railway line now repurposed as cycle route 7. It’s stunning!", 
    type: "image", 
  },
  {
    lat:  56.35494481429689,
    lng: -4.402850909981449,
    thumbnail: "./data/output_ims/84 Highland Coo.jpg ",
    name: "Highland Coo",
    description:
      "I love the way Highland Coos are often free to graze and roam without fences. Their curling horns and long shaggy hair over their eyes makes an iconic aspect of native Scottish creatures.", 
    type: "image", 
  },
  {
    lat:  56.823894858489375,
    lng: -4.712256888476113,
    thumbnail: "./data/output_ims/85 Rannoch Moor.jpg ",
    name: "Rannoch Moor",
    description:
      "Beyond the remoteness of the Corrour summit the railway floats on the boggy peat of Rannoch Moor. The long snow-covered escarpments beckon the explorer in us.", 
    type: "image", 
  },
  {
    lat:  56.664523691633455,
    lng: -5.037675790317979,
    thumbnail: "./data/output_ims/86 Glencoe.jpg ",
    name: "Glencoe",
    description:
      "By the shores of the loch the sides of the mountains rise above in a threatening and ominous manner. It’s a hauntingly beautiful but melancholy place.", 
    type: "image", 
  },
  {
    lat:  56.70054219044529,
    lng: -5.192689626943315,
    thumbnail: "./data/output_ims/87 Glenachulish.jpg ",
    name: "Glenachulish",
    description:
      "In my sketchbook I watched the sun go down from my window in North Ballachulish. In the morning the sun rose radiant over the slopes and lit up the tiny iron bridge crossing. This aspect in the evening and in the morning reflects the many moods of Scotland’s mountains.", 
    type: "image", 
  },
  {
    lat:  56.70054219044529,
    lng: -5.192689626943315,
    thumbnail: "./data/output_ims/87a Glenachulish.jpg ",
    name: "Glenachulish",
    description:
      "In my sketchbook I watched the sun go down from my window in North Ballachulish. In the morning the sun rose radiant over the slopes and lit up the tiny iron bridge crossing. This aspect in the evening and in the morning reflects the many moods of Scotland’s mountains.", 
    type: "image", 
  },
  {
    lat:  56.46276026149185,
    lng: -4.319923363095501,
    thumbnail: "./data/output_ims/88 Falls of Dochart.jpg ",
    name: "Falls of Dochart",
    description:
      "At Killin the river races to Loch Tay over the cauldron of rocks by the bridge. Heavy rains accentuate the urgency of these waters gown the glen.", 
    type: "image", 
  },
  {
    lat:  56.72152832818181,
    lng: -5.2359214382749935,
    thumbnail: "./data/output_ims/89 Corran ferry.jpg ",
    name: "Corran Ferry",
    description:
      "The favourite way to Ardnamurchan is via the Corran ferry. Across to the remote peninsula that is so often mistakenly overlooked in the rush to get to and from Fort William.", 
    type: "image", 
  },
  {
    lat:  56.44436125742632,
    lng: -5.2288022109120895,
    thumbnail: "./data/output_ims/90 Loch Etive.jpg ",
    name: "Loch Etive",
    description:
      "Head down to Kelly’s pier near Taynuilt and there’s the narrow isthmus on Loch Etive. In years gone by steamers plied up and down this loch bringing tourists to gaze in amazement at the Highlands.", 
    type: "image", 
  },
  {
    lat:  56.23027185017544,
    lng: -5.072423210085139,
    thumbnail: "./data/output_ims/91 Inveraray morning.jpg ",
    name: "Inveraray morning",
    description:
      "Gazing from my window in Inveraray I’m staring at the top of Loch Fyne before (or after) the rains…In the foreground the camellias bloom around the doorway.", 
    type: "image", 
  },
  {
    lat:  56.40011585692003,
    lng: -5.02459293267398,
    thumbnail: "./data/output_ims/92 Kilchurn Castle, Loch Awe.jpg ",
    name: "Kilchurn Castle",
    description:
      "Scottish castles on the distinctive Lochs are part of the iconic landscape.  Here it sits under the snow covered mountains reminding me that this cycle ride and this country is tough.", 
    type: "image", 
  },
  


  //East of England Images
  {
    lat: 55.77472761203442,
    lng: -2.0151146124830537,
    thumbnail: "./data/output_ims/01 Berwick bridges.jpg ",
    name: "Berwick Bridges",
    description:
      "Finding the place where Joseph Turner sketched Berwick 200 years ago shows me how much the town has changed with the arrival of the railway and new road bridges. They add a monumental drama to the skyline of the most northerly town in England.", 
    type: "image", 
  },
  {
    lat: 55.77472761203442,
    lng: -2.0151146124830537,
    thumbnail: "./data/output_ims/01a Berwick bridges (2).jpg ",
    name: "Berwick Bridges",
    description:
      "Finding the place where Joseph Turner sketched Berwick 200 years ago shows me how much the town has changed with the arrival of the railway and new road bridges. They add a monumental drama to the skyline of the most northerly town in England.", 
    type: "image", 
  },
  {
    lat: 55.771034577107606,
    lng: -2.0064278622864458,
    thumbnail: "./data/output_ims/02 Berwick Upon Tweed sketchbook.jpg ",
    name: "Berwick-upon-Tweed",
    description:
      "A sight that inspired LS Lowry on his frequent holidays to Berwick. He was drawn here by the light; the great grey expanse of the North Sea and the melancholy drama of the old dark stone buildings. It’s not the church at the end of the street. It’s the townhall framed in summer bunting.", 
    type: "image", 
  },
  {
    lat: 55.771034577107606,
    lng: -2.0064278622864458,
    thumbnail: "./data/output_ims/02a Berwick Upon Tweed.jpg ",
    name: "Berwick-upon-Tweed",
    description:
      "A sight that inspired LS Lowry on his frequent holidays to Berwick. He was drawn here by the light; the great grey expanse of the North Sea and the melancholy drama of the old dark stone buildings. It’s not the church at the end of the street. It’s the townhall framed in summer bunting.", 
    type: "image", 
  },
  {
    lat: 55.608575775278666,
    lng: -1.7141577614194838,
    thumbnail: "./data/output_ims/03 Bamburgh Castle watercolour.jpg ",
    name: "Bamburgh Castle",
    description:
      "The evening light catches the rich red sandstone of this glorious castle that dominates the  Northumbrian coast.", 
    type: "image", 
  },
  {
    lat: 55.588396380650224,
    lng: -1.667457539514903,
    thumbnail: "./data/output_ims/04 Cycling the shore oil.jpg ",
    name: "Cycling the Shore",
    description:
      "Challenged to ride along the beach I went a little further into the gentle surf. There’s a freedom on these wheels along this seaside.", 
    type: "image", 
  },
  {
    lat: 55.670293163792195,
    lng: -1.7950450905560609,
    thumbnail: "./data/output_ims/05 Lindisfarne Castle watercolour.jpg ",
    name: "Lindisfarne Castle",
    description:
      "Holy Island’s old castle perches on a rocky outcrop. It gazes at its big neighbour across the water in Bamburgh.", 
    type: "image", 
  },
  {
    lat: 55.670293163792195,
    lng: -1.7950450905560609,
    thumbnail: "./data/output_ims/Lindisfarne castle sketch.jpg ",
    name: "Lindisfarne Castle",
    description:
      "Holy Island’s old castle perches on a rocky outcrop. It gazes at its big neighbour across the water in Bamburgh.", 
    type: "image", 
  },
  {
    lat: 55.669219414045415,
    lng: -1.8011178061370974,
    thumbnail: "./data/output_ims/06 Lindisfarne Abbey watercolour.jpg ",
    name: "Lindisfarne Priory",
    description:
      "Once upon a time this was one of the great medieval pilgrimage sites. Now, Lindisfarne Priory is just a ruin. A ruin with a powerful presence that everyone feels as they wander among the well-kept fragments of wall and chapel.", 
    type: "image", 
  },
  {
    lat: 55.39485977146297,
    lng: -1.6074592767317386,
    thumbnail: "./data/output_ims/07 Alnmouth.jpg ",
    name: "Alnmouth",
    description:
      "It’s easy to miss the gentle curves of the Aln valley as my wheels take me down the road. I stop to take in the sweep of the river and out comes the sketchbook.", 
    type: "image", 
  },
  {
    lat: 55.13374240449667,
    lng: -1.5629654459644953,
    thumbnail: "./data/output_ims/07a Blyth railway viaduct - sketchbook.jpg ",
    name: "Blyth Viaduct (sketchbook)",
    description:
      "The graceful ironwork of Bedlington railway bridge reminds me of the heavy industry background of Northumberland.  Now the county is a centre for wind turbines and renewables and the heritage of the ironworks is a proud and long-lasting boast.", 
    type: "image", 
  },
  {
    lat: 55.344946941501775,
    lng: -1.611838835092889,
    thumbnail: "./data/output_ims/08 Warkworth Castle watercolour.jpg ",
    name: "Warkworth Castle (watercolour)",
    description:
      "It’s without a doubt the best-preserved medieval castle in the North. Film crews flock here to include it in their movies, Robin Hood, Harry Potter, Elizabeth I among them. And of course, it’s the home of Shakespeare’s hot headed rebel Harry Hotspur of the Percy family.", 
    type: "image", 
  },
  {
    lat: 55.344946941501775,
    lng: -1.611838835092889,
    thumbnail: "./data/output_ims/08a Warkworth castle sketchbook.jpg ",
    name: "Warkworth Castle (sketchbook)",
    description:
      "It’s without a doubt the best-preserved medieval castle in the North. Film crews flock here to include it in their movies, Robin Hood, Harry Potter, Elizabeth I among them. And of course, it’s the home of Shakespeare’s hot headed rebel Harry Hotspur of the Percy family.", 
    type: "image", 
  },
  {
    lat: 54.82344746243044,
    lng: -1.3202980627982348,
    thumbnail: "./data/output_ims/09 Nose's Point Seaham.jpg ",
    name: "Nose's Point, Seaham",
    description:
      "The Durham coast has some special places that are easily missed. Nose’s Point near Seaham is one of those. Locals know its charms and like to keep it secret!", 
    type: "image", 
  },
  {
    lat: 55.07003441832109,
    lng: -1.4515004408694385,
    thumbnail: "./data/output_ims/10 St Mary's Island (2).jpg ",
    name: "St Mary's Island",
    description:
      "If this island looks familiar, it is. American artist Winslow Homer was a resident here and used the island as a model regularly in his paintings of New England.  The charm of this island is its daily separation from Whitely Bay by the tide. Like Lindisfarne, we love the idea of being at the mercy of the tides.", 
    type: "image", 
  },
  {
    lat: 55.04841340890475,
    lng: -1.447037225395475,
    thumbnail: "./data/output_ims/11 Spanish City, Whitley Bay sketchbook.jpg ",
    name: "Spanish City, Whitley Bay",
    description:
      "It turns up in songs and writings and popular local folklore. The Spanish City of Whitley Bay is the most popular and beloved of the seaside places in Northumberland. Fancy a drink? Meet you at the Spanish city!", 
    type: "image", 
  },
  {
    lat: 55.49199580225999,
    lng: -1.6009842526647962,
    thumbnail: "./data/output_ims/12 Dunstanburgh castle watercolour.jpg ",
    name: "Dunstanburgh Castle",
    description:
      "The rugged ruins of this monolith dominate the coastline north of Caister. The haunting empty windows give glimpses to a celebrated history.", 
    type: "image", 
  },
  {
    lat: 54.97703899073859,
    lng: -1.3772782737766125,
    thumbnail: "./data/output_ims/13 Marsden Rock, South Shields Watercolour.jpg ",
    name: "Marsden Rock",
    description:
      "Access is via a steep rung of metal steps next to the grotto and it leads past nesting birds in the spectacular cliffs. It’s hard to believe that tourists used to climb this rock, via ladders lashed together, as recently as the 1980s.", 
    type: "image", 
  },
  {
    lat: 55.01741361754837,
    lng: -1.4169591736877154,
    thumbnail: "./data/output_ims/13a Tynemouth Priory.jpg ",
    name: "Tynemouth Priory",
    description:
      "The entrance to the Tyne has been a strategic fortress since Roman times with fortifications in use even during the Second World War. 700 years ago, King Edward II made a daring escape down the cliffs from here. I painted Tynemouth with the air of mystery that exudes from every stone.", 
    type: "image", 
  },
  {
    lat: 54.62077609492656,
    lng: -1.0753169981571375,
    thumbnail: "./data/output_ims/14 Redcar.jpg ",
    name: "Redcar",
    description:
      "You won't see this view anymore. The steel works were demolished a few weeks after I cycled past. This dinosaur of heavy industry formed the backbone of Teesside employment. The rejuvenation programme will bring something new though many locals will miss this iconic plant and the image it represents of Teesside industry.", 
    type: "image", 
  },
  {
    lat: 54.58533494348238,
    lng: -1.2254966061363837,
    thumbnail: "./data/output_ims/14a Transporter Bridge 2.jpg ",
    name: "The Transporter Bridge",
    description:
      "Remember Jimmy Nail trying to sell the Transporter Bridge to the Americans in the fictional TV series Crocodile shoes? It’s the emblem of Middlesbrough – the defining recognisable creation on the mighty River Tyne. I love the graceful pillars reaching to heavens and I’m one of the lucky ones to have climbed to the top and gazed at the surrounding grandeur of Teesside.", 
    type: "image", 
  },
  {
    lat: 54.5584945197422,
    lng: -0.7892208325139075,
    thumbnail: "./data/output_ims/15 Staithes sunset watercolour.jpg ",
    name: "Staithes Harbour",
    description:
      "On a beautiful summer evening the sun sets behind the cliffs of Staithes and the red sandstone glows with different shades. This is a little village that has attracted artists through the ages. Not many have cycled around the country to find themselves here for the evening.  With a spot in the harbour to paint, it’s a pleasure to chat with locals.", 
    type: "image", 
  },
  {
    lat: 54.489146352807175,
    lng: -0.6158979672260871,
    thumbnail: "./data/output_ims/16a Whitby (2).jpg ",
    name: "Whitby",
    description:
      "One of several places that lays claim to inspiring Bram Stoker’s Dracula stories. Whitby’s skyline is dominated by the old ruined abbey, while down below  the harbour is where Captain Cook learned to sail.", 
    type: "image", 
  },
  {
    lat: 54.42964099082357,
    lng: -0.5324360971502046,
    thumbnail: "./data/output_ims/17 Robin Hood's Bay sketchbook.jpg ",
    name: "Robin Hood's Bay",
    description:
      "Just off the Cinder Track, the old Railway line is a steep hill down to Robin Hood’s Bay. This is the end of the walker’s coast to coast route and traditionally you take off your boots and put your feet in the water. The tide was racing in and I tried not to get everything wet!", 
    type: "image", 
  },
  {
    lat: 54.29042788462927,
    lng: -0.4032307458398965,
    thumbnail: "./data/output_ims/18 Scarborough North Bay.jpg ",
    name: "Scarborough (North Bay)",
    description:
      "Scarborough boasts attractive beaches along two great bays separated by the headland with the castle.", 
    type: "image", 
  },
  {
    lat: 54.27960862664165,
    lng: -0.3983720052734308,
    thumbnail: "./data/output_ims/19 Scarborough south beach watercolour.jpg ",
    name: "Scarborough (South Bay)",
    description:
      "From the Spa bridge there’s a view across the busy south beach ringed by the town. The Grand Hotel dominates the skyline and Scarborough is proud of its tourist heritage.", 
    type: "image", 
  },
  {
    lat: 54.28733167682049,
    lng: -0.3897500684469226,
    thumbnail: "./data/output_ims/19a Scarborough Castle sketchbook.jpg ",
    name: "Scarborough Castle",
    description:
      "Within the walls of the ruined castle is the huge keep that I started to sketch before the rain dampened the paper and the sky.", 
    type: "image", 
  },
  {
    lat: 54.21225294153748,
    lng: -0.28221776307280927,
    thumbnail: "./data/output_ims/20 Filey beach rainclouds watercolour.jpg ",
    name: "Filey Beach",
    description:
      "The town names along the Yorkshire coast are often shortened to Brid, Scar, and Bev; but Filey keeps its full name. It’s a wonderful bay for the sailing dinghies even as the rain clouds break.", 
    type: "image", 
  },
  {
    lat: 54.150759936836494,
    lng: -0.17070359025058762,
    thumbnail: "./data/output_ims/21 Bempton Cliffs watercolour.jpg ",
    name: "Bempton Cliffs",
    description:
      "The noise of the nesting birds in these cliffs is arresting. Millions choose to make this their home as the limestone drops into the crashing sea. Flamborough peninsula has so much to explore.", 
    type: "image", 
  },
  {
    lat: 54.150759936836494,
    lng: -0.17070359025058762,
    thumbnail: "./data/output_ims/21a Bempton cliffs drawing.jpg ",
    name: "Bempton Cliffs",
    description:
      "The noise of the nesting birds in these cliffs is arresting. Millions choose to make this their home as the limestone drops into the crashing sea. Flamborough peninsula has so much to explore.", 
    type: "image", 
  },
  {
    lat: 53.76581241292097,
    lng: -0.009071904387495673,
    thumbnail: "./data/output_ims/22 End of the road, erosion.jpg",
    name: "End of the road - Erosion",
    description:
      "All along East Yorkshire, Lincolnshire, and East Anglian coastlines the never-ending erosion is taking place. Here the road ends abruptly as the tarmac falls away to the beach below. Every high tide another few metres is eaten away. It’s a terrifying vision of the power of nature.", 
    type: "image", 
  },
  {
    lat: 53.62022860549084,
    lng: 0.1414377809875917,
    thumbnail: "./data/output_ims/23 Spurn Point.jpg",
    name: "Spurn Point",
    description:
      "Massive concrete emplacements were put here in the Second World War to protect the entrance to the Humber estuary. They are still here while the sand dunes are washed away. But the tides keep taking and depositing all along the spurn strip. It’s an amazing place to visit at the very end of the road.", 
    type: "image", 
  },
  {
    lat: 53.714308794606,
    lng: -0.45054549259606413,
    thumbnail: "./data/output_ims/24 Humber Bridge from north side.jpg",
    name: "Humber Bridge from Hessle",
    description:
      "There are visions of the mighty Humber bridge from both banks. On the north side my favourite sight is below the carriageway looking up at its exposed belly.", 
    type: "image", 
  },
  {
    lat: 53.69734050882105,
    lng: -0.44449345790678885,
    thumbnail: "./data/output_ims/25 Humber bridge sketchbook.jpg",
    name: "Humber Bridge from Barton (sketchbook)",
    description:
      "From Barton there’s a park with ice cream and facilities to add to the enjoyment of the Humber bridge. This is my sketchbook piece.", 
    type: "image", 
  },
  {
    lat: 53.697279374014094,
    lng: -0.4449573806930688,
    thumbnail: "./data/output_ims/26 Humber Bridge oil.jpg",
    name: "Humber Bridge in oils",
    description:
      "There are immense shimmering skies above the enormous brown reflecting waters of the Humber estuary. Crossing it is the delicate Humber bridge, one foot in the river, the other on the north shore. Yorkshire and Lincolnshire brought together in a masterpiece.", 
    type: "image", 
  },
  {
    lat:  53.625132909314544,
    lng: -0.1914062660963809,
    thumbnail: "./data/output_ims/27 Immingham Docks watercolour.jpg",
    name: "Immingham Docks",
    description:
      "My cycle path leads through the docks where container ships from around the World are unloaded. The scale of these ships takes my breath away.", 
    type: "image", 
  },
  {
    lat:  53.56069320405721,
    lng: -0.027181946809019145,
    thumbnail: "./data/output_ims/28 Cleethorpes Pier watercolour.jpg",
    name: "Cleethorpes Pier",
    description:
      "The lights on the pier create a magic atmosphere each evening, and yes there really are delicious fish & chips to be had here.", 
    type: "image", 
  },
  {
    lat:  52.977071879395695,
    lng: -0.024514722267243442,
    thumbnail: "./data/output_ims/29 Boston Stump - sketchbook.jpg",
    name: "Boston Stump",
    description:
      "On the town bridge we stare along the river Witham to the footbridge and huge church tower. The Boston Stump is visible for miles: from across the Wash at Hunstanton and remembered by the Pilgrim Fathers when they built a new Boston in America. This is one of the tallest medieval churches in Britain.", 
    type: "image", 
  },
  {
    lat:  53.220295174947424,
    lng: -0.652966901936116,
    thumbnail: "./data/output_ims/Donnington Hall sketchbook.jpg",
    name: "Doddington Hall, Lincoln",
    description:
      "This Stately home built in the days of Elizabeth I is still lived in by the same family.", 
    type: "image", 
  },
  {
    lat:  53.23308027560907,
    lng: -0.532476450302197,
    thumbnail: "./data/output_ims/29c Lincoln Pottergate Gate.jpg",
    name: "Pottergate, Lincoln",
    description:
      "This is one of the ancient entrances to the city of Lincoln. It’s been the site of battles through the centuries and cyclists pedal past it oblivious…", 
    type: "image", 
  },
  {
    lat:  52.76527591620325,
    lng: 0.1933826814136844,
    thumbnail: "./data/output_ims/30 Sutton Bridge.jpg",
    name: "Sutton Bridge",
    description:
      "It’s the last crossing of the Nene before it empties into the Wash. Everyone crossing the Fens from Lincolnshire to Norfolk passes this way and it’s only when by the riverside that you see that it’s an attractive swing bridge.", 
    type: "image", 
  },
  {
    lat:  52.75351982729611,
    lng: 0.3924972306419432,
    thumbnail: "./data/output_ims/31 Kings Lynn Quay.jpg",
    name: "Kings Lynn Quay",
    description:
      "By the side of the Great Ouse, the town of Kings Lynn has been an important trading place for centuries. I like the cobbled streets and gabled frontage of the customs house.", 
    type: "image", 
  },
  {
    lat:  52.89382377757748,
    lng: 0.8749242688323184,
    thumbnail: "./data/output_ims/32 Walsingham Abbey sketchbook.jpg",
    name: "Walsingham Abbey",
    description:
      "All that remains of this great old pilgrimage site is the tall east end of the old abbey. Once as important as Canterbury, Walsingham has revived as a destination for pilgrims through other places of spirituality in the village.", 
    type: "image", 
  },
  {
    lat:  52.94353873977457,
    lng: 0.4875207478527486,
    thumbnail: "./data/output_ims/33a Hunstanton Cliffs watercolour.jpg",
    name: "Hunstanton Cliffs",
    description:
      "The candy stripes of Hunstanton are well known to generations of holidaymakers who stand in awe at the red and white layers of rock. Then they go in search of treasures in the rock pool along the shore!", 
    type: "image", 
  },
  {
    lat:  52.94889087579741,
    lng: 0.4928515694073641,
    thumbnail: "./data/output_ims/33b Hunstanton ruins.jpg",
    name: "Hunstanton Ruins",
    description:
      "The ruins of St Edmund’s chapel in Hunstanton perfectly frame the view of the old squat lighthouse.", 
    type: "image", 
  },
  {
    lat:  52.93237882783633,
    lng: 1.3016509421359657,
    thumbnail: "./data/output_ims/34 Cromer pier - sketchbook.jpg",
    name: "Cromer Pier (sketchbook)",
    description:
      "In the centre of Cromer is the famous pier that has recently undergone a renovation of its entrance and walkways. Perfect place to try crabbing…", 
    type: "image", 
  },
  {
    lat:  52.93237882783633,
    lng: 1.3016509421359657,
    thumbnail: "./data/output_ims/34a Cromer pier watercolour.jpg",
    name: "Cromer Pier (watercolour)",
    description:
      "In the centre of Cromer is the famous pier that has recently undergone a renovation of its entrance and walkways. Perfect place to try crabbing…", 
    type: "image", 
  },
  {
    lat:  52.845709485330204,
    lng: 1.4844456122091643,
    thumbnail: "./data/output_ims/35 Broomholm Pirory sketchbook.jpg",
    name: "Broomholm Priory",
    description:
      "It was an important place before the dissolution of the Monasteries and the Ministry of Defence saw its potential again during the Second World War. There are machine gun posts built into the walls.", 
    type: "image", 
  },
  {
    lat:  52.6670315118959,
    lng: 1.7270777854005603,
    thumbnail: "./data/output_ims/36 Caistor On  Sea sand dunes.jpg",
    name: "Caister-on-Sea Sand Dunes",
    description:
      "This coast is eroding fast into the North Sea. At Caister the high sand dunes look formidable. Let's hope they are.", 
    type: "image", 
  },
  {
    lat:  52.60196578110616,
    lng: 1.736338969175589,
    thumbnail: "./data/output_ims/37 Great Yarmouth sketchbook.jpg",
    name: "Great Yarmouth sketchbook",
    description:
      "Sometimes paintings will start as nothing more than a few lines on a page…", 
    type: "image", 
  },
  {
    lat:  52.568114731131445,
    lng: 1.7311267270489605,
    thumbnail: "./data/output_ims/38a Gorelston sketchbook.jpg",
    name: "Gorleston Beach (sketchbook)",
    description:
      "This delightful beach has paddling pools and ice creams vans and a huge expanse of pristine sands.", 
    type: "image", 
  },
  {
    lat:  52.568114731131445,
    lng: 1.7311267270489605,
    thumbnail: "./data/output_ims/38 Gorleston Beach watercolour.jpg",
    name: "Gorleston Beach (watercolour)",
    description:
      "This delightful beach has paddling pools and ice creams vans and a huge expanse of pristine sands.", 
    type: "image", 
  },
  {
    lat:  52.74197268220688,
    lng: 1.638871433020718,
    thumbnail: "./data/output_ims/39 Horsey windmill sketchbook.jpg",
    name: "Horsey Windmill (sketchbook)",
    description:
      "At the edge of the Norfolk broads is the Horsey windpump. The windmills of Norfolk have been a feature of the landscape for eons and it’s wonderful to find them still here and working.", 
    type: "image", 
  },
  {
    lat:  52.74197268220688,
    lng: 1.638871433020718,
    thumbnail: "./data/output_ims/39a Horsey windmill watercolour.jpg",
    name: "Horsey Windmill (watercolour)",
    description:
      "At the edge of the Norfolk broads is the Horsey windpump. The windmills of Norfolk have been a feature of the landscape for eons and it’s wonderful to find them still here and working.", 
    type: "image", 
  },
  {
    lat:  52.95428939581139,
    lng: 1.0422207101599126,
    thumbnail: "./data/output_ims/40 Windmill Cley Next the sea watercolour.jpg",
    name: "Big Skies",
    description:
      "It’s obvious why Norfolk is home to more windmills than anywhere else in Britain. The big skies of East Anglia. At Cley next the sea, the windmill is almost a mile from the sea, but the wind is always within reach.", 
    type: "image", 
  },
  {
    lat:  52.95428939581139,
    lng: 1.0422207101599126,
    thumbnail: "./data/output_ims/41 Big skies.jpg",
    name: "Big Skies",
    description:
      "It’s obvious why Norfolk is home to more windmills than anywhere else in Britain. The big skies of East Anglia. At Cley next the sea, the windmill is almost a mile from the sea, but the wind is always within reach.", 
    type: "image", 
  },
  {
    lat:  52.5589670975412,
    lng: 1.5735786764988302,
    thumbnail: "./data/output_ims/42 Calm before the storm.jpg",
    name: "Calm before the Storm",
    description:
      "Throughout the Norfolk Broads the rivers host impressive sailing boats. I like the way this one is sailing into some weather in a timeless manner.", 
    type: "image", 
  },
  {
    lat:  52.5958837200881,
    lng: 1.649019850513335,
    thumbnail: "./data/output_ims/43 Norfolk broads.jpg",
    name: "Norfolk Broads",
    description:
      "I‘ve always loved the work of Edward Seago, an East Anglian painter with an eye for the treasures of his region. He inspired this painting of a big sail under bigger skies by the homely windmill along the Norfolk broads.", 
    type: "image", 
  },
  {
    lat:  52.957446655537964,
    lng: 0.8505981314352222,
    thumbnail: "./data/output_ims/44 Wells next the sea.jpg",
    name: "Wells-next-the-Sea (sketchbook)",
    description:
      "A quirky feature of this little fishing village is the gantry to lift cargo from the quay to the warehouse. It hasn’t been used for years but it still gives us a feeling of endeavour.", 
    type: "image", 
  },
  {
    lat:  52.957446655537964,
    lng: 0.8505981314352222,
    thumbnail: "./data/output_ims/44a Wells Next the sea watercolour.jpg",
    name: "Wells-next-the-Sea (watercolour)",
    description:
      "A quirky feature of this little fishing village is the gantry to lift cargo from the quay to the warehouse. It hasn’t been used for years but it still gives us a feeling of endeavour.", 
    type: "image", 
  },
  {
    lat:  53.731035808644386,
    lng: 0.027809813920718622,
    thumbnail: "./data/output_ims/45 Withernsea lighthouse sketchbook (2).jpg",
    name: "Withernsea Lighthouse",
    description:
      "It’s the oddest thing to come across a lighthouse in the middle of the town. It’s at the far end of the street some way from the sea and that’s what makes this East Yorkshire village a place to bring a smile!", 
    type: "image", 
  },
 {
    lat:  52.31853841887882,
    lng: 1.6655163251979064,
    thumbnail: "./data/output_ims/46 Southwold boats watercolour.jpg",
    name: "Southwold Boats",
    description:
      "Along the waterway in Southwold are all the fishing boats and seafood shops and it’s great place to people watch.", 
    type: "image", 
  },
  {
    lat:  52.31818227995877,
    lng: 1.6641558880817933,
    thumbnail: "./data/output_ims/46a Southwold from Walberswick watercolour.jpg",
    name: "Southwold from Walberswick",
    description:
      "Walberswick presents a lovely view of the Suffolk village of Southwold. All the boats along the river are matched by the people crabbing on the side.", 
    type: "image", 
  },
  {
    lat:  51.94002674603498,
    lng: 1.3199296880251306,
    thumbnail: "./data/output_ims/47 Felixstowe docks.jpg",
    name: "Felixstowe Docks",
    description:
      "At Landguard Fort people gather for the ferry to Harwich just to watch the busy activity at Britain’s largest docks. Felixstowe brings in everything and it loads and unloads like clockwork.", 
    type: "image", 
  },
  {
    lat:  51.930318860744364,
    lng: 1.2751097216944238,
    thumbnail: "./data/output_ims/48 Dover Court lighthouse Harwich.jpg",
    name: "Dovercourt Lighthouse, Harwich",
    description:
      "Metal legged lighthouses along the shore. There’s an alien appearance about them which makes them appealing.", 
    type: "image", 
  },
  {
    lat:  51.7755919337715,
    lng: 0.90270282713353,
    thumbnail: "./data/output_ims/49 Mersea Island houseboats.jpg",
    name: "Mersea Island Houseboats",
    description:
      "It’s an unusual way to walk up someone’s path to knock on the door! I love the way people choose to life of a houseboat that rises and falls with the tide. Brilliant.", 
    type: "image", 
  },
  {
    lat:  51.727763200220345,
    lng: 0.6895228714492163,
    thumbnail: "./data/output_ims/50 Maldon sunset sketchbook.jpg",
    name: "Maldon Sunset",
    description:
      "Mid-summer there’s a fine sunset in Essex along the river Chalmer.", 
    type: "image", 
  },
  {
    lat:  51.727763200220345,
    lng: 0.6895228714492163,
    thumbnail: "./data/output_ims/51 Maldon sunset - sketchbook.jpg",
    name: "Maldon Sunset",
    description:
      "Mid-summer there’s a fine sunset in Essex along the river Chelmer.", 
    type: "image", 
  },
  {
    lat: 51.72792009060597,
    lng: 0.6893747176984898,
    thumbnail: "./data/output_ims/52 Maldon Quay watercolour.jpg",
    name: "Maldon Quay",
    description:
      "The Quay is full of Thames barges and this old steam tug. It’s a heritage dream.", 
    type: "image", 
  },
  {
    lat: 52.143283861589694,
    lng: 1.5995174401942998,
    thumbnail: "./data/output_ims/53 Suffold skies Aldeburgh watercolour.jpg",
    name: "Suffolk Skies, Aldeburgh",
    description:
      "On the shingle beach near Orford Ness there’s a good place to watch the sailing boats on the river Alde. It looks almost as if they are sailing on land.", 
    type: "image", 
  },
  {
    lat: 52.16517263489549,
    lng: 1.4963111536098095,
    thumbnail: "./data/output_ims/54 Snape Maltings - sketchbook.jpg",
    name: "Snape Maltings (sketchbook)",
    description:
      "Here the horizon is covered by the reeds of the salt marshes. Boats disappear and their sails can be seen poking out of the top of the rushes. Snape Maltings is a popular place to visit all year round.", 
    type: "image", 
  },
  {
    lat: 52.16517263489549,
    lng: 1.4963111536098095,
    thumbnail: "./data/output_ims/55 Snape Maltings watercolour.jpg",
    name: "Snape Maltings (watercolour)",
    description:
      "Here the horizon is covered by the reeds of the salt marshes. Boats disappear and their sails can be seen poking out of the top of the rushes. Snape Maltings is a popular place to visit all year round.", 
    type: "image", 
  },
  {
    lat: 51.5298832198621,
    lng: 0.7370149728589056,
    thumbnail: "./data/output_ims/56 Southend beach sketchbook.jpg",
    name: "Southend Beach",
    description:
      "Dominating the view is the longest pier in Britain. The train to end takes almost 10 minutes. I sketched this ready for a studio attempt in due course.", 
    type: "image", 
  },
  {
    lat: 51.54072466670435,
    lng: 0.6465652611608536,
    thumbnail: "./data/output_ims/57 Cockle boats Leigh on Sea watercolour.jpg",
    name: "Cockle Boats, Leigh-on-Sea",
    description:
      "Leigh is known as the cockle capital of the Thames estuary. They are delicious. By the harbour are lots of fine seafood places. I can’t cycle past without stocking up!", 
    type: "image", 
  },
  {
    lat: 52.55926582893334,
    lng: 1.5671497454485164,
    thumbnail: "./data/output_ims/60 Norfolk Broads.jpg",
    name: "Norfolk Broads",
    description:
      "Water, boats, big skies = heaven!", 
    type: "image", 
  },
  {
    lat: 51.500546048786426,
    lng: -0.1273191928347359,
    thumbnail: "./data/output_ims/61 Big Ben.jpg",
    name: "Big Ben",
    description:
      "I marked the final day of my circumnavigation at Parliament Square. After a moment by Edward the Confessor’s tomb and blessing in Westminster Abbey, I sat on a bench and sketched this view of Britain’s most famous building. And that’s your lot! Go back to the beginning and start again!",
    type: "image", 
  },
  {
    lat: 51.38848332949205,
    lng: 0.7434721183979305,
    thumbnail: "./data/output_ims/3b Isle of Sheppey Bridge.jpg",
    name: "Isle of Sheppey Crossing",
    description:
      "In the midst of the wide expanse of salt marsh along the river Swale is the enormous Sheppey Crossing sweeping high above the grazing cattle. Behind the graceful curve of the modern road bridge are the towers of the old crossing.",
    type: "image", 
  },


  //Additional images sent later
  {
    lat: 51.383898510212525,
    lng: 1.4419404264001203,
    thumbnail: "./data/output_ims/Botany Bay,.jpg",
    name: "Botany Bay, Broadstairs",
    description:
      "This was a favourite place for Turner to paint. The rugged white cliffs on the very edge of the Kent coast where the landscape turns a corner brings it’s own weather and light effects. I love the way these cliffs are clinging on against the effect of the sea. The single figure reminds us of the scale of Englands rocky defences.",
    type: "image", 
  },
  {
    lat: 50.92717715497494,
    lng: 0.9742019840621627,
    thumbnail: "./data/output_ims/6c Romney Hythe and Dymchurch railway watercolour.jpg",
    name: "Romney Hythe & Dymchurch Railway",
    description:
      "It’s a stunning steam powered narrow gauge railway and it runs along the desert heathland of the Dungeness peninsula. Here is the glorious crimson steam locomotive coming into sight of the power station. The only clue to it’s size is the figure in the cab.",
    type: "image", 
  },
  {
    lat: 50.71322833063931,
    lng: -4.03393181483644,
    thumbnail: "./data/output_ims/Dartmoor - sketchbook.jpg",
    name: "Dartmoor (sketchbook)",
    description:
      "It’s impossible to cycle across  Meldon viaduct without stopping to admire and sketch the grandeur of Dartmoor. This little sketch will be worked up in my studio.",
    type: "image", 
  },
  {
    lat: 50.603390603615615,
    lng: -4.162611560345282,
    thumbnail: "./data/output_ims/Brentor Church sketchbook.jpg",
    name: "Brentor Church (sketchbook)",
    description:
      "The ancient pilgrim chapel on top of the escarpment draws the traveller to view of Dartmoor. I preferred to sketch the church then paint it overlooking the sweeping skyline. Pilgrims have been drawn to this magical place for centuries.",
    type: "image", 
  },
  {
    lat: 50.603390603615615,
    lng: -4.162611560345282,
    thumbnail: "./data/output_ims/Brentor church.jpg",
    name: "Brentor Church (watercolour)",
    description:
      "The ancient pilgrim chapel on top of the escarpment draws the traveller to view of Dartmoor. I preferred to sketch the church then paint it overlooking the sweeping skyline. Pilgrims have been drawn to this magical place for centuries.",
    type: "image", 
  },
  {
    lat: 51.024975655910815,
    lng: -4.197193290348578,
    thumbnail: "./data/output_ims/32a Bideford skies.jpg",
    name: "Bideford Skies",
    description:
      "Along the River Torridge the Devon skies seem to swirl and dance in contrast to the calm water near Bideford.",
    type: "image", 
  },
  {
    lat: 51.35641683479127,
    lng: -2.994309108139501,
    thumbnail: "./data/output_ims/36a Old Pier, Weston Super Mare.jpg",
    name: "Old Pier Weston Super Mare",
    description:
      "Birnbeck Pier is a glorious old ruined pier jutting into the Bristol Channel. It’s awaiting massive investment to be rebuilt perhaps one day. In the meantime, locals love the ragged remaining timbers from its glory days.",
    type: "image", 
  },
  {
    lat: 51.066918816180745,
    lng: -2.9171277456722877,
    thumbnail: "./data/output_ims/36b Burrow Mump sketchbook.jpg",
    name: "Burrow Mump",
    description:
      "It’s an ancient chapel on an older mound in the mysterious Somerset levels.  By the River Parrott is a little spot where I was able to stop and sketch this intriguing place.",
    type: "image", 
  },
  {
    lat: 53.18382889912713,
    lng: -4.211642413197325,
    thumbnail: "./data/output_ims/Menai sunset.jpg",
    name: "Menai Sunset",
    description:
      "That stretch of water that makes it an island off an island appeals to the imagination. At sundown the distant gentle slopes of Anglesey dip into the straits and the island itself id mirrored in the sandy low tide.",
    type: "image", 
  },
  {
    lat: 53.40143330646097,
    lng: -2.9937817301691774,
    thumbnail: "./data/output_ims/Albert Dock Liverpool - sketchbook.jpg",
    name: "Albert Dock Liverpool",
    description:
      "I imagine the cries of wonder and admiration if people from a century ago could see the face of Liverpool dockland today. I find the skyline utterly enthralling and inspirational.",
    type: "image", 
  },
  {
    lat: 53.483505120019984,
    lng: -3.049069118826612,
    thumbnail: "./data/output_ims/Another Place, Crosbie Beach.jpg",
    name: "Crosby, Another Place",
    description:
      "Every day and every tide brings a different view of Anthony Gormley’s masterpiece.",
    type: "image", 
  },
  {
    lat: 56.21520308547855,
    lng: -4.879078336913239,
    thumbnail: "./data/output_ims/Waterfall, Hells Glen.jpg",
    name: "Waterfall, Hells Glen",
    description:
      "The Goil Burn cascades down the rocky glen into Loch Goil. This back road through the heather and moorland trees to Rest & be Thankful is a little travelled favourite road of those in the know.",
    type: "image", 
  },
  {
    lat: 56.18037283015155,
    lng: -4.770655802373426,
    thumbnail: "./data/output_ims/Loch Long shadows.jpg",
    name: "Loch Long Shadows",
    description:
      "This track is not for the faint hearted. High above the railway line and the shore road it offers glimpses of the distant illusive Loch Goilhead peninsula. The winding track in front beckons you down to safety…",
    type: "image", 
  },
  {
    lat: 56.225907290478055,
    lng: -4.855985026282929,
    thumbnail: "./data/output_ims/26 Rest and be Thankful bridge sketchbook.jpg",
    name: "Rest & Be Thankful",
    description:
      "The colourful rocks and heather on the flanks of the Cobbler range are cut in two by the road. Standing here admiring the view down to Loch long it's impossible not to rest and be thankful….",
    type: "image", 
  },
  {
    lat: 50.748597055547215,
    lng: -1.2945443169147588,
    thumbnail: "./data/output_ims/Red Squirrel Way.jpg",
    name: "Red Squirrel Way",
    description:
      "This walking and cycling track through the Isle of Wight is a great way to explore it’s treats.  It’s an old disused railway line that follows the river Medina through the middle of the island.",
    type: "image", 
  },
  {
    lat: 56.66451874992463,
    lng: -5.03788770012736,
    thumbnail: "./data/output_ims/Glencoe with Highland Coos.jpg",
    name: "Glencoe and Highland Coos",
    description:
      "The warmth of the Highland Coos munching and glancing in our direction eases the oppressive nature of the overhanging rocky cliffs. Now Glencoe is somewhere to admire without feeling threatened.",
    type: "image", 
  },
  {
    lat: 51.50786641351901,
    lng: -0.1001129784899138,
    thumbnail: "./data/output_ims/St Paul's and Millenium bridge.jpg",
    name: "St Pauls & Millenium Bridge",
    description:
      "The old and new along the Thames are encapsulated in the gracefulness of the Millennium footbridge leading to St Paul’s Cathedral. This is where my cycle circumnavigation was marked by the Dean and chapter.",
    type: "image", 
  },
  {
    lat: 56.225907290478055,
    lng: -4.855985026282929,
    thumbnail: "./data/output_ims/Rest & Be thankful.jpg",
    name: "Rest & be Thankful",
    description:
      "The colourful rocks and heather on the flanks of the Cobbler range are cut in two by the road. Standing here admiring the view down to Loch long it’s impossible not to rest and be thankful….",
    type: "image", 
  },
  {
    lat: 56.245285537297235,
    lng: -4.85135701452068,
    thumbnail: "./data/output_ims/26 Butter bridge sketchbook.jpg",
    name: "Butter Bridge (sketchbook)",
    description:
      "This graceful stone bridge was built around the same time as the Rest & Be Thankful military road. It’s been bypassed now by the A83 and is only used by the occasional walker and cyclist. The advantage is stopping easily to admire the timeless view.",
    type: "image", 
  },
  {
    lat: 56.449972950282,
    lng: -2.9179591746048223,
    thumbnail: "./data/output_ims/93 across the Tay from Newport.jpg",
    name: "Across the Tay",
    description:
      "This is a favourite view of the Tay bridge as it runs down from Newport into Dundee. There’s a special artist’s light along the Tay estuary that always draws me to the oil paints.",
    type: "image", 
  },
  {
    lat: 56.46964109295456,
    lng: -2.9894208607540436,
    thumbnail: "./data/output_ims/94 Taybridge.jpg",
    name: "Taybridge",
    description:
      "I’ve seen this mighty river Tay at its source in the Trossachs and now from Dundee’s Law the curving rail bridge makes its way across into Fife.",
    type: "image", 
  },
  {
    lat: 56.4521176230474,
    lng: -2.8826192187497974,
    thumbnail: "./data/output_ims/95 broughty ferry sunset.jpg",
    name: "Broughty Ferry Sunset",
    description:
      "Scottish skies have a magic in every season. Broughty Ferry gleams in the late evening sunset.",
    type: "image", 
  },
  {
    lat: 56.464605635365075,
    lng: -3.0122226598972524,
    thumbnail: "./data/output_ims/96 Dundee Observatory.jpg",
    name: "Dundee Observatory",
    description:
      "Visiting the Dundee Observatory is a delight. It’s one of Britain’s great scientific observatories supported by the city council. An evening looking at the stars and the solar system through this magnificent telescope is a thrill.",
    type: "image", 
  },
  {
    lat: 56.442934686822156,
    lng: -2.9409777941540316,
    thumbnail: "./data/output_ims/97 Dundee sunset.jpg",
    name: "Dundee Sunset",
    description:
      "From Newport on Tay the lights of Dundee city beneath the Law and the great road bridge are reflected in the mighty river Tay. Awesome.",
    type: "image", 
  },

  //Ferries around the coast pictures
  {
    lat: 50.79587576616524,
    lng: -1.0250547839691364,
    thumbnail: "./data/output_ims/01 Hayling Island.jpg",
    name: "Hayling Island",
    description:
      "First of dozens of ferries around the coast of Britain from the Ferryboat Inn",
    type: "image", 
  },
  {
    lat: 50.79648753955507,
    lng: -1.0301666666893385,
    thumbnail: "./data/output_ims/02 Hayling Island (2).jpg",
    name: "Hayling Island",
    description:
      "This little ferry is a lifeline for the Hayling Island community and its connection with Portsmouth",
    type: "image", 
  },
  {
    lat: 50.79692203740051,
    lng: -1.1092316315536495,
    thumbnail: "./data/output_ims/03 Portsmouth ferry.jpg",
    name: "Portsmouth Ferry",
    description:
      "The ferry links Gosport and Portsmouth and everywhere we are reminded of the importance of the harbour to the local economy.",
    type: "image", 
  },
  {
    lat: 50.79483847699485,
    lng: -1.1168015932383522,
    thumbnail: "./data/output_ims/04 Gosport ferry.jpg",
    name: "Gosport Ferry",
    description:
      "I’m back again to the Spinnaker Tower for my next watery ride to Ryde….",
    type: "image", 
  },
  {
    lat: 50.79297509408664,
    lng: -1.1068334831016216,
    thumbnail: "./data/output_ims/06 Wightlink  Portsmouth - Ryde.jpg",
    name: "Wightlink to Ryde",
    description:
      "A short cycle around to the old town of Southsea to the busy Wightlink to the Isle of Wight.",
    type: "image", 
  },
  {
    lat: 50.706529358051114,
    lng: -1.5006295636491234,
    thumbnail: "./data/output_ims/07 Wightlink Yarmouth - Lymington.jpg",
    name: "Wightlink from Yarmouth – Lymington",
    description:
      "It’s the shortest crossing from the Isle of Wight and brings me to the New Forest.",
    type: "image", 
  },
  {
    lat: 50.73000894667883,
    lng: -1.7812684412716138,
    thumbnail: "./data/output_ims/10 Christchurch ferry.jpg",
    name: "Christchurch Wick Ferry",
    description:
      "It’s a tiny foot ferry across the river Stour in Christchurch. The first of three Wicks in each of the three countries.",
    type: "image", 
  },
  {
    lat: 50.68299364958688,
    lng: -1.9487608778802679,
    thumbnail: "./data/output_ims/13 Sandbanks ferry.jpg",
    name: "Sandbanks Ferry",
    description:
      "The giant chain is a clue to how the Sandbanks ferry service copes with the strong tides that sweep in and out of Poole harbour.",
    type: "image", 
  },
  {
    lat: 50.61710934007852,
    lng: -3.423864289246437,
    thumbnail: "./data/output_ims/15 Starcross ferry.jpg",
    name: "Starcross Ferry",
    description:
      "The charming Starcross ferry relies on tourists so it’s seasonal. Sadly, I’m a week early to take advantage and cut out the 25 mile detour.",
    type: "image", 
  },
  {
    lat: 50.38232088947933,
    lng: -3.591181415614807,
    thumbnail: "./data/output_ims/17 Tarts on the Dart.jpg",
    name: "Tarts on the Dart",
    description:
      "The smaller of the River Dart ferries (The Tarts on the Dart) runs across to Dittisham whenever you are ready…",
    type: "image", 
  },
  {
    lat: 50.34857819273281,
    lng: -3.573351870909542,
    thumbnail: "./data/output_ims/19 Dartmouth.jpg",
    name: "Kingswear – Dartmouth",
    description:
      "One of four ferries keeping the villages connected along the river dart. This is the largest of the regular services.",
    type: "image", 
  },
  {
    lat: 50.23499505899806,
    lng: -3.7639830958811475,
    thumbnail: "./data/output_ims/22 Salcombe.jpg",
    name: "Salcombe",
    description:
      "Finding the landing on the east shore is a challenge. What a delight to make this crossing.",
    type: "image", 
  },
  {
    lat: 50.360638832041275,
    lng: -4.17456023498233,
    thumbnail: "./data/output_ims/18 Plymouth Cremyll.jpg",
    name: "Plymouth to Cremyll",
    description:
      "From the Royal William Yard this little ferry brings you to the Cornish coast. It’s the smaller cousin of the bigger Torpoint connection.",
    type: "image", 
  },
  {
    lat: 50.33971572590924,
    lng: -4.630693589253792,
    thumbnail: "./data/output_ims/24 Fowey.jpg",
    name: "Fowey Bodinnick",
    description:
      "Fowey is blessed with two ferries. This is the car transport across the Fowey valley.",
    type: "image", 
  },
  {
    lat: 50.100005515558735,
    lng: -5.128800480849474,
    thumbnail: "./data/output_ims/26 Helford.jpg",
    name: "Helford River",
    description:
      "The Helford Passage is always windy and the little foot ferry often has to do wide sweeps to bring the boat safely in to shore.",
    type: "image", 
  },
  {
    lat: 50.54258398754416,
    lng: -4.93612071365847,
    thumbnail: "./data/output_ims/28 Padstow - Rock.jpg",
    name: "Padstow – Rock",
    description:
      "One of the busiest ferries around our shores, this is another vital link between the harbour of Padstow and the brewery at Rock.",
    type: "image", 
  },
  {
    lat: 51.76905451332062,
    lng: -4.37004364170132,
    thumbnail: "./data/output_ims/29 Ferryside.jpg",
    name: "Ferryside to Laugharne",
    description:
      "The ferry runs occasionally. On my visit I got a lift from the lifeboat station around the bay to Laugharne which saved me 40 miles of cycling through the hills of Carmarthenshire.",
    type: "image", 
  },
  {
    lat: 53.40975300875892,
    lng: -3.0160335966205487,
    thumbnail: "./data/output_ims/31 Mersey.jpg",
    name: "Mersey",
    description:
      "I love the dazzle ships and the soundtrack to the ferry across the Mersey. My bike fitted well in to the colour scheme.",
    type: "image", 
  },
  {
    lat: 53.92756462413107,
    lng: -3.0066777483718297,
    thumbnail: "./data/output_ims/32 Wyre ferry.jpg",
    name: "Knott End Wyre Ferry",
    description:
      "Since they stopped dredging the channel of the river Wyre the ferry has become utterly reliant on the tides which have an amazing drop. I’m on the last ferry of the day. In half an hour it wont be able to dock…",
    type: "image", 
  },
  {
    lat: 54.354146702418106,
    lng: -2.9310624523269273,
    thumbnail: "./data/output_ims/37 Windermere.jpg",
    name: "Windermere",
    description:
      "This is another of the reliable Victorian inventions – the chain link ferry. It crosses England’s longest lake and brings the Lake District within reach of everyone.",
    type: "image", 
  },
  {
    lat: 54.073536094882925,
    lng: -3.1743664391504596,
    thumbnail: "./data/output_ims/38 Peal island.jpg",
    name: "Piel Island",
    description:
      "This is a ferry that runs if he feels like it. The ferryman was having a happy time in the pub so I enjoyed the view instead….",
    type: "image", 
  },
  {
    lat: 55.640093948953925,
    lng: -4.823808681836019,
    thumbnail: "./data/output_ims/39 Ardrossan.jpg",
    name: "Ardrossan – Brodick",
    description:
      "Its one of the Cal Mac ferry centres linking Arran and Campbelltown on the Mull of Kintyre. Today I was linked only to Arran – so that’s where I’m headed.",
    type: "image", 
  },
  {
    lat: 55.70821692192696,
    lng: -5.301754557923378,
    thumbnail: "./data/output_ims/40 Arran - Lochranza.jpg",
    name: "Arran Lochranza",
    description:
      "Many ferries are reliant on the tides. Today I waited three hours for the tide to bring me from Lochranza to the Kintyre shore.",
    type: "image", 
  },
  {
    lat: 56.41592715280528,
    lng: -5.474004027779114,
    thumbnail: "./data/output_ims/42 Oban.jpg",
    name: "Oban",
    description:
      "I took a small dinghy with Christophe our to the St Hilda Adventure boat.",
    type: "image", 
  },
  {
    lat: 56.41860028013113,
    lng: -5.497042066347237,
    thumbnail: "./data/output_ims/44 St Hilda.jpg",
    name: "St Hilda Adventure",
    description:
      "We sailed around the Isle of Kerrara before docking at Dunstaffnage Marina. What a delight!",
    type: "image", 
  },
  {
    lat: 56.41157961306506,
    lng: -5.47729643535487,
    thumbnail: "./data/output_ims/46 Oban - Mull.jpg",
    name: "Oban – Mull",
    description:
      "The Cal Mac ferries are used to bikes travelling and have roped ready to lash our wheels to the vessel.",
    type: "image", 
  },
  {
    lat: 56.47127894211906,
    lng: -5.70511479961177,
    thumbnail: "./data/output_ims/47 Oban Mull.jpg",
    name: "Craignure Mull",
    description:
      "It’s not far across to the Inner Hebrides but the weather is often different in a very few short miles.",
    type: "image", 
  },
  {
    lat: 56.326128849342965,
    lng: -6.370511482901298,
    thumbnail: "./data/output_ims/48 Mull - Iona.jpg",
    name: "Mull to Iona",
    description:
      "On Ffionfort slipway the boats are waiting to take people to Iona, Staffa and around the bay to see the wildlife…",
    type: "image", 
  },
  {
    lat: 56.43278050805662,
    lng: -6.3393028316147095,
    thumbnail: "./data/output_ims/50 Staffa.jpg",
    name: "Staffa",
    description:
      "Landing on Staffa to visit Fingal’s Cave is an adventure in itself….",
    type: "image", 
  },
  {
    lat: 56.330426076068086,
    lng: -6.391510972543937,
    thumbnail: "./data/output_ims/51 Iona - Mull.jpg",
    name: "Iona – Mull",
    description:
      "The Hebrides are always affected by the weather and so is the ferry service. The call came out –‘last ferry today there’s a storm coming in!’",
    type: "image", 
  },
  {
    lat: 56.62346147098648,
    lng: -6.062980929317404,
    thumbnail: "./data/output_ims/52 Tobermory.jpg",
    name: "Tobermory - Kilchoan",
    description:
      "It’s a sheltered harbour at the pretty town of Tobermory. Once around the headland the Atlantic winds blow in….",
    type: "image", 
  },
  {
    lat: 57.00736905820776,
    lng: -5.826682355162128,
    thumbnail: "./data/output_ims/55 Mallaig - Skye.jpg",
    name: "Mallaig to Armadale",
    description:
      "Here’s your chance to sing over the sea to Skye and follow the route Bonnie prince Charlie took (sort of) back in 1746",
    type: "image", 
  },
  {
    lat: 58.552958809222055,
    lng: -4.789436448243993,
    thumbnail: "./data/output_ims/57 Cape Wrath.jpg",
    name: "Cape Wrath",
    description:
      "Hopeful or foolhardy? The ferry to Cape Wrath is utterly weather dependant. I loved the experience even as the spray flew over the boat.",
    type: "image", 
  },
  {
    lat: 57.69248807535883,
    lng: -4.0204035360654,
    thumbnail: "./data/output_ims/59 Nigg Cromarty.jpg",
    name: "Nigg – Cromarty",
    description:
      "This ferry takes me through the graveyard of oil rigs. It’s an exciting eerie trip….",
    type: "image", 
  },
  {
    lat: 52.08036392919519,
    lng: 1.4908481527081947,
    thumbnail: "./data/output_ims/69 Butley.jpg",
    name: "Butley",
    description:
      "Suffolk is criss crossed with estuaries and the Butley ferry is an irregular little crossing run by thoughtful volunteers. Many thanks!",
    type: "image", 
  },
  {
    lat: 51.99064015192625,
    lng: 1.3944506240587164,
    thumbnail: "./data/output_ims/62 Bawdsey.jpg",
    name: "Bawdsey",
    description:
      "To cross the river Deben, you wave the flag and the ferry appears from somewhere! Any excuse to wave a flag I’m happy!",
    type: "image", 
  },
  {
    lat: 51.93993249230161,
    lng: 1.3197859570101709,
    thumbnail: "./data/output_ims/65 Felixstowe - Harwich.jpg",
    name: "Felixstowe – Harwich",
    description:
      "The Harwich ferry has to land on shingle at the Landguard Fort, so it carries its own landing stage. This was a challenge loading the bike, but I did it!",
    type: "image", 
  },
  {
    lat: 51.80253909052998,
    lng: 1.0195038657916318,
    thumbnail: "./data/output_ims/67 Brightlingsea - Mersea.jpg",
    name: "Brightlingsea – Mersea",
    description:
      "Across the shingle at St Clear I pushed the bike and waited… The Brighlingsea – Mersea ferry lands wherever he feels comfortable and expect to get your tyres wet!",
    type: "image", 
  },
  {
    lat: 51.62901510649723,
    lng: 0.8034010627128311,
    thumbnail: "./data/output_ims/68 Burnham on Crouch.jpg",
    name: "Burnham on Crouch",
    description:
      "The landing stage is safely within the yacht marina and the short ride across the river keeps you clear of the mudflats.",
    type: "image", 
  },

  //Hebridean Way Images
  {
    lat: 56.95558372969362,
    lng: -7.487467374906396,
    thumbnail: "./data/output_ims/WI01 Castlebay sunset.jpg",
    name: "Castlebay",
    description:
      "Sun going down on the castle in the bay – you can see where the name of Barras town comes from. The skies of the Western Isles are among the finest in Britain.",
    type: "image", 
  },
  {
    lat: 56.95558372969362,
    lng: -7.487467374906396,
    thumbnail: "./data/output_ims/WI-02 Castlebay from hotel.jpg",
    name: "Castlebay from the Hotel",
    description:
      "Looking out of my hotel window on Barra the tall semi tropical trees frame the view down to the lifeboat in the harbour.",
    type: "image", 
  },
  {
    lat: 56.96526474590775,
    lng: -7.462501373317494,
    thumbnail: "./data/output_ims/WI-03 Lady of the Isle Barra.jpg",
    name: "Lady of the Isles",
    description:
      "High up on the soaring mountain of Heavel on the Isle of Barra is the pilgrimage destination of villagers through the ages.  Our lady of the Isles is a tough climb with stunning views across the glistening waters of the Minch.",
    type: "image", 
  },
  {
    lat: 57.23828047134311,
    lng: -7.389180509796706,
    thumbnail: "./data/output_ims/WI-04  South Uist.jpg",
    name: "South Uist",
    description:
      "The mountain range of South Uist divides the island down its spine. I find the cycle along its road inspirational as the heather climbs to the sky.",
    type: "image", 
  },
  {
    lat: 58.19563399854914,
    lng: -6.7240999689728875,
    thumbnail: "./data/output_ims/WI05-Callanish stones.jpg",
    name: "Callanish Stones",
    description:
      "There are dozens of neolithic stones in the vicinity of Callanish. Clearly this place resonated with ancient tribes people who lived here.",
    type: "image", 
  },
  {
    lat: 58.19761578145862,
    lng: -6.745090936775556,
    thumbnail: "./data/output_ims/WI06- Callanish stones.jpg",
    name: "Callanish Stones",
    description:
      "Its almost impossible to count the number of standing stones or to work out what they mean. Everyone’s interpretation is valid.",
    type: "image", 
  },
  {
    lat: 58.269315215786825,
    lng: -6.791777467444369,
    thumbnail: "./data/output_ims/WI07-Carloway Broch.jpg",
    name: "Carloway Broch",
    description:
      "These ancient stone dwellings were the defensive castles of the olden days.",
    type: "image", 
  },
  {
    lat: 57.27532073378772,
    lng: -5.511119222544747,
    thumbnail: "./data/output_ims/WI08-Eilean Donan Castle.jpg",
    name: "Eilean Donan Castle",
    description:
      "To find this lookout requires a bit of local knowledge or some exploring. It’s worth persevering to see one of Scotlands most iconic castle.",
    type: "image", 
  },
  {
    lat: 57.93212287507085,
    lng: -6.863633669906785,
    thumbnail: "./data/output_ims/WI09-scented hills of Harris.jpg",
    name: "Scented Hills of Harris",
    description:
      "This little lane to the tennis courtgives a stunning vista of the sharp crags of Harris. It’s a little taste of what’s to come on my bike  and the stunted tree reminds me this is a island where they grow wind.",
    type: "image", 
  },
  {
    lat: 58.19761578145862,
    lng: -6.745090936775556,
    thumbnail: "./data/output_ims/WI10-Callanish Stones.jpg",
    name: "Callanish Stones",
    description:
      "Mysterious, magical and ancient. The Callanish stones of Lewis are at least as old as Stonehenge.",
    type: "image", 
  },
  {
    lat: 57.638844747990774,
    lng: -7.374670522040418,
    thumbnail: "./data/output_ims/WI-11 Thatched croft of Uist.jpg",
    name: "Thatched croft of Uist",
    description:
      "The crofts of the Western isles are thatched in straw or peat. They are a timeless reminder of what it takes to work these isles.",
    type: "image", 
  },
  {
    lat: 57.864150106551016,
    lng: -6.978476060459655,
    thumbnail: "./data/output_ims/WI-12- Luskentyre Beach.jpg",
    name: "Luskentyre Beach",
    description:
      "The beaches of Harris are acclaimed as the best in the World. Sitting among the sand dunes I’m looking at a view of heaven",
    type: "image", 
  },
  {
    lat: 57.90335846984618,
    lng: -6.819067014976259,
    thumbnail: "./data/output_ims/WI-13-Tarbert old pier.jpg",
    name: "Tarbert Old Pier",
    description:
      "The washing hanging above the old pier reminds us this is a place where people live and work.",
    type: "image", 
  },
  {
    lat: 57.86175880503734,
    lng: -6.985707293842768,
    thumbnail: "./data/output_ims/WI14- Harris beacch.jpg",
    name: "Harris Beach",
    description:
      "Every Harris beach speaks to us differently. The fact that sheep are grazing oblivious of their surroundings brings a smile to my face.",
    type: "image", 
  },

  //Scotland YouTube videos
  {
    lat: 54.993776791360766,
    lng: -3.43150761010229,
    thumbnail: "https://img.youtube.com/vi/UUmJjXRP8e8/mqdefault.jpg",
    id: "UUmJjXRP8e8",
    type: "video",
  },
  {
    lat: 54.97601141615924,
    lng: -3.524246836076914,
    thumbnail: "https://img.youtube.com/vi/Xhc3drQU1xA/mqdefault.jpg",
    id: "Xhc3drQU1xA",
    type: "video",
  },
  {
    lat: 54.98052629117246,
    lng: -3.6184773459579738,
    thumbnail: "https://img.youtube.com/vi/sxNldHyfSG4/mqdefault.jpg",
    id: "sxNldHyfSG4",
    type: "video",
  },
  {
    lat: 54.83607442441553,
    lng: -4.050019726331688,
    thumbnail: "https://img.youtube.com/vi/6yVYton8fwI/mqdefault.jpg",
    id: "6yVYton8fwI",
    type: "video",
  },
  {
    lat: 54.89936956689282,
    lng: -3.936751465546297,
    thumbnail: "https://img.youtube.com/vi/uxyD7w8WKc4/mqdefault.jpg",
    id: "uxyD7w8WKc4",
    type: "video",
  },
  {
    lat: 54.83515523714038,
    lng: -4.051852330864647,
    thumbnail: "https://img.youtube.com/vi/15OboTI69Ys/mqdefault.jpg",
    id: "15OboTI69Ys",
    type: "video",
  },
  {
    lat: 54.873116145029606,
    lng: -4.235918368542018,
    thumbnail: "https://img.youtube.com/vi/pQi4PejbrCs/mqdefault.jpg",
    id: "pQi4PejbrCs",
    type: "video",
  },
  {
    lat: 54.84073432335824,
    lng: -5.117487438488056,
    thumbnail: "https://img.youtube.com/vi/MHE2uHxQIsM/mqdefault.jpg",
    id: "MHE2uHxQIsM",
    type: "video",
  },
  {
    lat: 54.85047712646366,
    lng: -4.7817498447239135,
    thumbnail: "https://img.youtube.com/vi/aHEnrIMZzwU/mqdefault.jpg",
    id: "aHEnrIMZzwU",
    type: "video",
  },
  {
    lat: 54.89794966870569,
    lng: -5.014620968789057,
    thumbnail: "https://img.youtube.com/vi/Dzu-eduChs8/mqdefault.jpg",
    id: "Dzu-eduChs8",
    type: "video",
  },
  {
    lat: 54.90164071142201,
    lng: -5.0123446113039245,
    thumbnail: "https://img.youtube.com/vi/K3Z26VAdiXg/mqdefault.jpg",
    id: "K3Z26VAdiXg",
    type: "video",
  },
  {
    lat: 54.91293804668246,
    lng: -4.995870360680483,
    thumbnail: "https://img.youtube.com/vi/805gDIlUbHw/mqdefault.jpg",
    id: "805gDIlUbHw",
    type: "video",
  },
  {
    lat: 54.923307492639005,
    lng: -4.885080354149299,
    thumbnail: "https://img.youtube.com/vi/13behHfSiy8/mqdefault.jpg",
    id: "13behHfSiy8",
    type: "video",
  },
  {
    lat: 54.825079908336605,
    lng: -4.652413278248116,
    thumbnail: "https://img.youtube.com/vi/zIkHwGa0l4U/mqdefault.jpg",
    id: "zIkHwGa0l4U",
    type: "video",
  },
  {
    lat: 55.10047500729871,
    lng: -4.771593351980599,
    thumbnail: "https://img.youtube.com/vi/dmXvz-LujAM/mqdefault.jpg",
    id: "dmXvz-LujAM",
    type: "video",
  },
  {
    lat: 55.11416825471859,
    lng: -4.797331866013584,
    thumbnail: "https://img.youtube.com/vi/N5fO0_MPHgY/mqdefault.jpg",
    id: "N5fO0_MPHgY",
    type: "video",
  },
  {
    lat: 55.461372120740336,
    lng: -4.64010990975307,
    thumbnail: "https://img.youtube.com/vi/P3ZBQTuBDrw/mqdefault.jpg",
    id: "P3ZBQTuBDrw",
    type: "video",
  },
  {
    lat: 55.457954609022366,
    lng: -4.626048614076376,
    thumbnail: "https://img.youtube.com/vi/bi_Kblir9YI/mqdefault.jpg",
    id: "bi_Kblir9YI",
    type: "video",
  },
  {
    lat: 55.50874500225334,
    lng: -4.611901808775176,
    thumbnail: "https://img.youtube.com/vi/9oFWPL4g2XE/mqdefault.jpg",
    id: "9oFWPL4g2XE",
    type: "video",
  },
  {
    lat: 55.67860509525629,
    lng: -5.214597203510592,
    thumbnail: "https://img.youtube.com/vi/VHrWYknMquI/mqdefault.jpg",
    id: "VHrWYknMquI",
    type: "video",
  },
  {
    lat: 55.7761388965756,
    lng: -5.4170206800873215,
    thumbnail: "https://img.youtube.com/vi/G3PW7dEXJ0c/mqdefault.jpg",
    id: "G3PW7dEXJ0c",
    type: "video",
  },
  {
    lat: 55.863232592692775,
    lng: -5.413700496282319,
    thumbnail: "https://img.youtube.com/vi/XJlUhxnwsYI/mqdefault.jpg",
    id: "XJlUhxnwsYI",
    type: "video",
  },
  {
    lat: 55.86435742498698,
    lng: -5.408881870122762,
    thumbnail: "https://img.youtube.com/vi/T2dRFlaBC40/mqdefault.jpg",
    id: "T2dRFlaBC40",
    type: "video",
  },
  {
    lat: 56.095311291861265,
    lng: -5.288735255256701,
    thumbnail: "https://img.youtube.com/vi/Xm1Tvc33WEE/mqdefault.jpg",
    id: "Xm1Tvc33WEE",
    type: "video",
  },
  {
    lat: 56.219942752951,
    lng: -5.087028819440374,
    thumbnail: "https://img.youtube.com/vi/8Lhm4FgG_eU/mqdefault.jpg",
    id: "8Lhm4FgG_eU",
    type: "video",
  },
  {
    lat: 56.2303778368746,
    lng: -5.072909787275203,
    thumbnail: "https://img.youtube.com/vi/KliD2zC9wEs/mqdefault.jpg",
    id: "KliD2zC9wEs",
    type: "video",
  },
  {
    lat: 56.2542866074927,
    lng: -4.938819240429911,
    thumbnail: "https://img.youtube.com/vi/XvY_kkGlQTU/mqdefault.jpg",
    id: "XvY_kkGlQTU",
    type: "video",
  },
  {
    lat: 56.26160312522878,
    lng: -4.930764666397185,
    thumbnail: "https://img.youtube.com/vi/OyDHgICrb70/mqdefault.jpg",
    id: "OyDHgICrb70",
    type: "video",
  },
  {
    lat: 56.22577882486842,
    lng: -4.857320985738912,
    thumbnail: "https://img.youtube.com/vi/rRMnEDC0RJM/mqdefault.jpg",
    id: "rRMnEDC0RJM",
    type: "video",
  },
  {
    lat: 56.00397443204145,
    lng: -4.741193014749657,
    thumbnail: "https://img.youtube.com/vi/_HZeFBqs1q0/mqdefault.jpg",
    id: "_HZeFBqs1q0",
    type: "video",
  },
  {
    lat: 55.88633391985477,
    lng: -4.369680734016177,
    thumbnail: "https://img.youtube.com/vi/lcunjMqZfzw/mqdefault.jpg",
    id: "lcunjMqZfzw",
    type: "video",
  },
  {
    lat: 51.501052267867024,
    lng: -0.12925362303377008,
    thumbnail: "https://img.youtube.com/vi/sDtGEo5mapY/mqdefault.jpg",
    id: "sDtGEo5mapY",
    type: "video",
  },
  {
    lat: 55.86205517708112,
    lng: -4.251485945245172,
    thumbnail: "https://img.youtube.com/vi/EAI7Q2zp0mc/mqdefault.jpg",
    id: "EAI7Q2zp0mc",
    type: "video",
  },
  {
    lat: 56.430916003736684,
    lng: -5.241004250929927,
    thumbnail: "https://img.youtube.com/vi/FvcUxiM5LUI/mqdefault.jpg",
    id: "FvcUxiM5LUI",
    type: "video",
  },
  {
    lat: 56.43951570312547,
    lng: -5.232333868030695,
    thumbnail: "https://img.youtube.com/vi/q9KOjW1apf8/mqdefault.jpg",
    id: "q9KOjW1apf8",
    type: "video",
  },
  {
    lat: 56.40964637506549,
    lng: -5.421272890383012,
    thumbnail: "https://img.youtube.com/vi/Oh1j5k4qB3w/mqdefault.jpg",
    id: "Oh1j5k4qB3w",
    type: "video",
  },
  {
    lat: 56.404654188699624,
    lng: -5.370818000437225,
    thumbnail: "https://img.youtube.com/vi/pvKReK8bOHo/mqdefault.jpg",
    id: "pvKReK8bOHo",
    type: "video",
  },
  {
    lat: 56.423339220670776,
    lng: -5.483245947701118,
    thumbnail: "https://img.youtube.com/vi/HLuKmF8nyWE/mqdefault.jpg",
    id: "HLuKmF8nyWE",
    type: "video",
  },
  {
    lat: 56.41575755191852,
    lng: -5.46920438593126,
    thumbnail: "https://img.youtube.com/vi/t6VQCk90J6w/mqdefault.jpg",
    id: "t6VQCk90J6w",
    type: "video",
  },
  {
    lat: 56.414815173423726,
    lng: -5.470436743165211,
    thumbnail: "https://img.youtube.com/vi/8_rdm2WCEOQ/mqdefault.jpg",
    id: "8_rdm2WCEOQ",
    type: "video",
  },
  {
    lat: 56.41857091017793,
    lng: -5.4975162406801745,
    thumbnail: "https://img.youtube.com/vi/YhfbVJyJRHk/mqdefault.jpg",
    id: "YhfbVJyJRHk",
    type: "video",
  },
  {
    lat: 56.41219242022513,
    lng: -5.73709806658417,
    thumbnail: "https://img.youtube.com/vi/oDBfD8GOD2w/mqdefault.jpg",
    id: "oDBfD8GOD2w",
    type: "video",
  },
  {
    lat: 56.43180449232112,
    lng: -6.340689632142405,
    thumbnail: "https://img.youtube.com/vi/GjBV-NREEzM/mqdefault.jpg",
    id: "GjBV-NREEzM",
    type: "video",
  },
  {
    lat: 56.43137787890772,
    lng: -6.34105130613986,
    thumbnail: "https://img.youtube.com/vi/dyM-vMJRF48/mqdefault.jpg",
    id: "dyM-vMJRF48",
    type: "video",
  },
  {
    lat: 56.33495099608625,
    lng: -6.3920588041169575,
    thumbnail: "https://img.youtube.com/vi/ChJl9R8nKkc/mqdefault.jpg",
    id: "ChJl9R8nKkc",
    type: "video",
  },
  {
    lat: 56.32600913213207,
    lng: -6.370276536557802,
    thumbnail: "https://img.youtube.com/vi/FNlPwg3eh98/mqdefault.jpg",
    id: "FNlPwg3eh98",
    type: "video",
  },
  {
    lat: 56.62275485867728,
    lng: -6.07407993167166,
    thumbnail: "https://img.youtube.com/vi/4M7cFb7s8J8/mqdefault.jpg",
    id: "4M7cFb7s8J8",
    type: "video",
  },
  {
    lat: 56.69104342612137,
    lng: -6.094749012818154,
    thumbnail: "https://img.youtube.com/vi/V7X_Cb9BW_M/mqdefault.jpg",
    id: "V7X_Cb9BW_M",
    type: "video",
  },
  {
    lat: 56.790661409625294,
    lng: -5.761734021081154,
    thumbnail: "https://img.youtube.com/vi/-1qnzr4jZfE/mqdefault.jpg",
    id: "-1qnzr4jZfE",
    type: "video",
  },
  {
    lat: 56.879886956972165,
    lng: -5.67739462148683,
    thumbnail: "https://img.youtube.com/vi/sjJ1-VCsKlI/mqdefault.jpg",
    id: "sjJ1-VCsKlI",
    type: "video",
  },
  {
    lat: 56.91291167820147,
    lng: -5.839228379147282,
    thumbnail: "https://img.youtube.com/vi/B3dRuQ0UoTk/mqdefault.jpg",
    id: "B3dRuQ0UoTk",
    type: "video",
  },
  {
    lat: 57.00595129684645,
    lng: -5.829797732876949,
    thumbnail: "https://img.youtube.com/vi/30gyh2QE53A/mqdefault.jpg",
    id: "30gyh2QE53A",
    type: "video",
  },
  {
    lat: 57.07549702403542,
    lng: -5.888280614009613,
    thumbnail: "https://img.youtube.com/vi/SAm8WTKP1WY/mqdefault.jpg",
    id: "SAm8WTKP1WY",
    type: "video",
  },
  {
    lat: 57.28020374224112,
    lng: -5.7138833675837395,
    thumbnail: "https://img.youtube.com/vi/uas-fyzbZA4/mqdefault.jpg",
    id: "uas-fyzbZA4",
    type: "video",
  },
  {
    lat: 57.52842925833288,
    lng: -5.544807641685262,
    thumbnail: "https://img.youtube.com/vi/TL9-oD494Lk/mqdefault.jpg",
    id: "TL9-oD494Lk",
    type: "video",
  },
  {
    lat: 57.72572867683769,
    lng: -5.689956315762557,
    thumbnail: "https://img.youtube.com/vi/k8ZH30r71Qo/mqdefault.jpg",
    id: "k8ZH30r71Qo",
    type: "video",
  },
  {
    lat: 58.004947413756014,
    lng: -5.140003507734924,
    thumbnail: "https://img.youtube.com/vi/02phib5DWxg/mqdefault.jpg",
    id: "02phib5DWxg",
    type: "video",
  },
  {
    lat: 58.04939634411455,
    lng: -5.277160948064443,
    thumbnail: "https://img.youtube.com/vi/01_xtT7-gZE/mqdefault.jpg",
    id: "01_xtT7-gZE",
    type: "video",
  },
  {
    lat: 58.34616017524772,
    lng: -5.163794701826242,
    thumbnail: "https://img.youtube.com/vi/XZVS7eCyoY4/mqdefault.jpg",
    id: "XZVS7eCyoY4",
    type: "video",
  },
  {
    lat: 58.25573395904394,
    lng: -5.022635405692996,
    thumbnail: "https://img.youtube.com/vi/zspW5DBZhNU/mqdefault.jpg",
    id: "zspW5DBZhNU",
    type: "video",
  },
  {
    lat: 58.42480718586356,
    lng: -4.987659400208058,
    thumbnail: "https://img.youtube.com/vi/pGevliWGdIo/mqdefault.jpg",
    id: "pGevliWGdIo",
    type: "video",
  },
  {
    lat: 58.495540000983226,
    lng: -4.8334806616514046,
    thumbnail: "https://img.youtube.com/vi/ZtZuvYiskVQ/mqdefault.jpg",
    id: "ZtZuvYiskVQ",
    type: "video",
  },
  {
    lat: 58.56419966587117,
    lng: -4.7271248991516766,
    thumbnail: "https://img.youtube.com/vi/nbkNWzfuB4E/mqdefault.jpg",
    id: "nbkNWzfuB4E",
    type: "video",
  },
  {
    lat: 58.625941951829866,
    lng: -4.998839596528679,
    thumbnail: "https://img.youtube.com/vi/9cTvVVrqmM4/mqdefault.jpg",
    id: "9cTvVVrqmM4",
    type: "video",
  },
  {
    lat: 58.56433757130181,
    lng: -4.726441342647751,
    thumbnail: "https://img.youtube.com/vi/VMP8XcRiY78/mqdefault.jpg",
    id: "VMP8XcRiY78",
    type: "video",
  },
  {
    lat: 58.576118223319455,
    lng: -4.768483262326407,
    thumbnail: "https://img.youtube.com/vi/XNc-eb1IMIg/mqdefault.jpg",
    id: "XNc-eb1IMIg",
    type: "video",
  },
  {
    lat: 58.56345760192964,
    lng: -4.721011445457102,
    thumbnail: "https://img.youtube.com/vi/iyggc2_qK6c/mqdefault.jpg",
    id: "iyggc2_qK6c",
    type: "video",
  },
  {
    lat: 58.56410052865997,
    lng: -4.719993374046942,
    thumbnail: "https://img.youtube.com/vi/n-h5N4Uygso/mqdefault.jpg",
    id: "n-h5N4Uygso",
    type: "video",
  },
  {
    lat: 58.55059441092167,
    lng: -4.681996543838177,
    thumbnail: "https://img.youtube.com/vi/4aHf0jxEbU0/mqdefault.jpg",
    id: "4aHf0jxEbU0",
    type: "video",
  },
  {
    lat: 58.45722422582996,
    lng: -4.725952882026555,
    thumbnail: "https://img.youtube.com/vi/WgK89giNXoI/mqdefault.jpg",
    id: "WgK89giNXoI",
    type: "video",
  },
  {
    lat: 58.55485150475305,
    lng: -3.857256949832612,
    thumbnail: "https://img.youtube.com/vi/W92N24ADKIs/mqdefault.jpg",
    id: "W92N24ADKIs",
    type: "video",
  },
  {
    lat: 58.579016491152174,
    lng: -3.7266610403869374,
    thumbnail: "https://img.youtube.com/vi/ZrL0nfDmub0/mqdefault.jpg",
    id: "ZrL0nfDmub0",
    type: "video",
  },
  {
    lat: 58.59226192259042,
    lng: -3.514765378648511,
    thumbnail: "https://img.youtube.com/vi/TFZspUyGKbw/mqdefault.jpg",
    id: "TFZspUyGKbw",
    type: "video",
  },
  {
    lat: 58.591826714925475,
    lng: -3.5174673360748208,
    thumbnail: "https://img.youtube.com/vi/MrR0e46BGrE/mqdefault.jpg",
    id: "MrR0e46BGrE",
    type: "video",
  },
  {
    lat: 58.58994153682801,
    lng: -3.527862353416697,
    thumbnail: "https://img.youtube.com/vi/PTHEWDj5_-g/mqdefault.jpg",
    id: "PTHEWDj5_-g",
    type: "video",
  },
  {
    lat: 58.671304,
    lng: -3.376141,
    thumbnail: "https://img.youtube.com/vi/8W8pxfXuVCU/mqdefault.jpg",
    id: "8W8pxfXuVCU",
    type: "video",
  },
  {
    lat: 58.646608483452084,
    lng: -3.1876123428537797,
    thumbnail: "https://img.youtube.com/vi/Fduz-IMjLMQ/mqdefault.jpg",
    id: "Fduz-IMjLMQ",
    type: "video",
  },
  {
    lat: 58.63800424303871,
    lng: -3.169844623176151,
    thumbnail: "https://img.youtube.com/vi/kqyTo5qd0OY/mqdefault.jpg",
    id: "kqyTo5qd0OY",
    type: "video",
  },
  {
    lat: 58.63787394845329,
    lng: -3.160461910414057,
    thumbnail: "https://img.youtube.com/vi/hdRvEVpB56g/mqdefault.jpg",
    id: "hdRvEVpB56g",
    type: "video",
  },
  {
    lat: 58.64399157972517,
    lng: -3.070033546897185,
    thumbnail: "https://img.youtube.com/vi/NqZ83sENS4o/mqdefault.jpg",
    id: "NqZ83sENS4o",
    type: "video",
  },
  {
    lat: 58.43953347727866,
    lng: -3.086993355806175,
    thumbnail: "https://img.youtube.com/vi/RaUuYThuXeY/mqdefault.jpg",
    id: "RaUuYThuXeY",
    type: "video",
  },
  {
    lat: 58.441048114360505,
    lng: -3.09388222666775,
    thumbnail: "https://img.youtube.com/vi/MBQNXH6POtQ/mqdefault.jpg",
    id: "MBQNXH6POtQ",
    type: "video",
  },
  {
    lat: 58.44111554359759,
    lng: -3.094053635187353,
    thumbnail: "https://img.youtube.com/vi/uA388rLlwTg/mqdefault.jpg",
    id: "uA388rLlwTg",
    type: "video",
  },
  {
    lat: 58.44164986616064,
    lng: -3.0976831354892025,
    thumbnail: "https://img.youtube.com/vi/6s-HV4egoDU/mqdefault.jpg",
    id: "6s-HV4egoDU",
    type: "video",
  },
  {
    lat: 58.433025804515715,
    lng: -3.09339796120642,
    thumbnail: "https://img.youtube.com/vi/jm5-csjZB2U/mqdefault.jpg",
    id: "jm5-csjZB2U",
    type: "video",
  },
  {
    lat: 58.39004995181913,
    lng: -3.1365841082948718,
    thumbnail: "https://img.youtube.com/vi/0vsZ3O25VR4/mqdefault.jpg",
    id: "0vsZ3O25VR4",
    type: "video",
  },
  {
    lat: 58.351853995095524,
    lng: -3.1577834235662245,
    thumbnail: "https://img.youtube.com/vi/MO7WAUdgfPM/mqdefault.jpg",
    id: "MO7WAUdgfPM",
    type: "video",
  },
  {
    lat: 58.32856784761578,
    lng: -3.205271935973476,
    thumbnail: "https://img.youtube.com/vi/M7CLSdaHBEo/mqdefault.jpg",
    id: "M7CLSdaHBEo",
    type: "video",
  },
  {
    lat: 58.37311923577521,
    lng: -3.1529635782319505,
    thumbnail: "https://img.youtube.com/vi/S8cz1-JUF5Q/mqdefault.jpg",
    id: "S8cz1-JUF5Q",
    type: "video",
  },
  {
    lat: 58.308361665509175,
    lng: -3.286220391145438,
    thumbnail: "https://img.youtube.com/vi/-xFJPWLI7LE/mqdefault.jpg",
    id: "-xFJPWLI7LE",
    type: "video",
  },
  {
    lat: 58.1171785372522,
    lng: -3.653860269657289,
    thumbnail: "https://img.youtube.com/vi/2byr65xMiwQ/mqdefault.jpg",
    id: "2byr65xMiwQ",
    type: "video",
  },
  {
    lat: 58.16089174013692,
    lng: -3.5526078143822524,
    thumbnail: "https://img.youtube.com/vi/DKzaE2wZGDs/mqdefault.jpg",
    id: "DKzaE2wZGDs",
    type: "video",
  },
  {
    lat: 58.10166761676594,
    lng: -3.675481999307504,
    thumbnail: "https://img.youtube.com/vi/9wwcA2-c7Uw/mqdefault.jpg",
    id: "9wwcA2-c7Uw",
    type: "video",
  },
  {
    lat: 57.98726181937316,
    lng: -3.9120812291443885,
    thumbnail: "https://img.youtube.com/vi/W4u4uNWamk8/mqdefault.jpg",
    id: "W4u4uNWamk8",
    type: "video",
  },
  {
    lat: 57.88024918902823,
    lng: -4.0299137348178915,
    thumbnail: "https://img.youtube.com/vi/5poLGbDL7Eo/mqdefault.jpg",
    id: "5poLGbDL7Eo",
    type: "video",
  },
  {
    lat: 57.876800897594705,
    lng: -4.024047534133107,
    thumbnail: "https://img.youtube.com/vi/33PIDREPhl0/mqdefault.jpg",
    id: "33PIDREPhl0",
    type: "video",
  },
  {
    lat: 57.88015450352359,
    lng: -4.031237683434076,
    thumbnail: "https://img.youtube.com/vi/Hy-G15Yc6GA/mqdefault.jpg",
    id: "Hy-G15Yc6GA",
    type: "video",
  },
  {
    lat: 57.683605337840966,
    lng: -4.03698348474455,
    thumbnail: "https://img.youtube.com/vi/9Py1m0e96qY/mqdefault.jpg",
    id: "9Py1m0e96qY",
    type: "video",
  },
  {
    lat: 57.64395650614039,
    lng: -4.087817884990121,
    thumbnail: "https://img.youtube.com/vi/8jeETFZNTD0/mqdefault.jpg",
    id: "8jeETFZNTD0",
    type: "video",
  },
  {
    lat: 57.57404223717716,
    lng: -4.0936984441984,
    thumbnail: "https://img.youtube.com/vi/VLcPgv6hxRI/mqdefault.jpg",
    id: "VLcPgv6hxRI",
    type: "video",
  },
  {
    lat: 57.50155816170742,
    lng: -4.235243199529113,
    thumbnail: "https://img.youtube.com/vi/MiWFUq_9WhM/mqdefault.jpg",
    id: "MiWFUq_9WhM",
    type: "video",
  },
  {
    lat: 57.51914576494744,
    lng: -4.009142684798419,
    thumbnail: "https://img.youtube.com/vi/9ciff_gAt9Y/mqdefault.jpg",
    id: "9ciff_gAt9Y",
    type: "video",
  },
  {
    lat: 57.477570592345785,
    lng: -4.096655139189846,
    thumbnail: "https://img.youtube.com/vi/fQ0XRTp9pis/mqdefault.jpg",
    id: "fQ0XRTp9pis",
    type: "video",
  },
  {
    lat: 57.524324128115985,
    lng: -3.926762617582258,
    thumbnail: "https://img.youtube.com/vi/V3TEC5xk4I4/mqdefault.jpg",
    id: "V3TEC5xk4I4",
    type: "video",
  },
  {
    lat: 57.60530912358519,
    lng: -3.729031534857113,
    thumbnail: "https://img.youtube.com/vi/d4HGcyLXEY4/mqdefault.jpg",
    id: "d4HGcyLXEY4",
    type: "video",
  },
  {
    lat: 57.61157526919441,
    lng: -3.609445050296582,
    thumbnail: "https://img.youtube.com/vi/_33UJXAqGOw/mqdefault.jpg",
    id: "_33UJXAqGOw",
    type: "video",
  },
  {
    lat: 57.615605125173374,
    lng: -3.5976927150997287,
    thumbnail: "https://img.youtube.com/vi/aNoGYwp5KpA/mqdefault.jpg",
    id: "aNoGYwp5KpA",
    type: "video",
  },
  {
    lat: 57.63378194651472,
    lng: -3.566892214141725,
    thumbnail: "https://img.youtube.com/vi/BgEZ70PX3pk/mqdefault.jpg",
    id: "BgEZ70PX3pk",
    type: "video",
  },
  {
    lat: 57.719066872523165,
    lng: -3.282353522561917,
    thumbnail: "https://img.youtube.com/vi/OZFImIy65ts/mqdefault.jpg",
    id: "OZFImIy65ts",
    type: "video",
  },
  {
    lat: 57.67581890267936,
    lng: -3.245691231392696,
    thumbnail: "https://img.youtube.com/vi/_DXo9UQdLpY/mqdefault.jpg",
    id: "_DXo9UQdLpY",
    type: "video",
  },
  {
    lat: 57.66277181787281,
    lng: -3.0987181103356387,
    thumbnail: "https://img.youtube.com/vi/mrwwbdBzCLo/mqdefault.jpg",
    id: "mrwwbdBzCLo",
    type: "video",
  },
  {
    lat: 57.680117510184694,
    lng: -2.957329898171407,
    thumbnail: "https://img.youtube.com/vi/6v5qDkRW38c/mqdefault.jpg",
    id: "6v5qDkRW38c",
    type: "video",
  },
  {
    lat: 57.697801800488676,
    lng: -2.906684448895607,
    thumbnail: "https://img.youtube.com/vi/m2wZ8jkyozA/mqdefault.jpg",
    id: "m2wZ8jkyozA",
    type: "video",
  },
  {
    lat: 57.704790170089936,
    lng: -2.859298517698168,
    thumbnail: "https://img.youtube.com/vi/xl9SWCHRiLQ/mqdefault.jpg",
    id: "xl9SWCHRiLQ",
    type: "video",
  },
  {
    lat: 57.676034447647034,
    lng: -2.32500109307182,
    thumbnail: "https://img.youtube.com/vi/r1TTae_0pB8/mqdefault.jpg",
    id: "r1TTae_0pB8",
    type: "video",
  },
  {
    lat: 57.679046180713385,
    lng: -2.2592116901536334,
    thumbnail: "https://img.youtube.com/vi/FiXSgimRUzo/mqdefault.jpg",
    id: "FiXSgimRUzo",
    type: "video",
  },
  {
    lat: 57.66948879581715,
    lng: -2.1952646480667846,
    thumbnail: "https://img.youtube.com/vi/9u3yXu0TaQM/mqdefault.jpg",
    id: "9u3yXu0TaQM",
    type: "video",
  },
  {
    lat: 57.68964194450312,
    lng: -2.0059308560302567,
    thumbnail: "https://img.youtube.com/vi/k4YHzDG7Ve0/mqdefault.jpg",
    id: "k4YHzDG7Ve0",
    type: "video",
  },
  {
    lat: 57.51138793587972,
    lng: -1.79643971367081,
    thumbnail: "https://img.youtube.com/vi/ROdVMxAzGjU/mqdefault.jpg",
    id: "ROdVMxAzGjU",
    type: "video",
  },
  {
    lat: 57.50152803348401,
    lng: -1.792158612312867,
    thumbnail: "https://img.youtube.com/vi/F9n-h6AZK3I/mqdefault.jpg",
    id: "F9n-h6AZK3I",
    type: "video",
  },
  {
    lat: 57.43248732977553,
    lng: -1.823590866333506,
    thumbnail: "https://img.youtube.com/vi/4usD0Uyx_YA/mqdefault.jpg",
    id: "4usD0Uyx_YA",
    type: "video",
  },
  {
    lat: 57.41503994289647,
    lng: -1.8327138340285083,
    thumbnail: "https://img.youtube.com/vi/EUaieeh5udo/mqdefault.jpg",
    id: "EUaieeh5udo",
    type: "video",
  },
  {
    lat: 57.30994726245089,
    lng: -1.9924742057010356,
    thumbnail: "https://img.youtube.com/vi/4lXNxKXt4A0/mqdefault.jpg",
    id: "4lXNxKXt4A0",
    type: "video",
  },
  {
    lat: 57.112636041398765,
    lng: -2.0970240304705707,
    thumbnail: "https://img.youtube.com/vi/B48KENQUOWk/mqdefault.jpg",
    id: "B48KENQUOWk",
    type: "video",
  },
  {
    lat: 57.107571550368014,
    lng: -2.1973755538847635,
    thumbnail: "https://img.youtube.com/vi/okI-Lqhi8a8/mqdefault.jpg",
    id: "okI-Lqhi8a8",
    type: "video",
  },
  {
    lat: 57.12881609486885,
    lng: -2.1039221947489652,
    thumbnail: "https://img.youtube.com/vi/yG8stnJs2z8/mqdefault.jpg",
    id: "yG8stnJs2z8",
    type: "video",
  },
  {
    lat: 57.13881404089494,
    lng: -2.0486363611858636,
    thumbnail: "https://img.youtube.com/vi/vqGGM3z9xz0/mqdefault.jpg",
    id: "vqGGM3z9xz0",
    type: "video",
  },
  {
    lat: 56.96080231845938,
    lng: -2.2031201818305703,
    thumbnail: "https://img.youtube.com/vi/zHFMlHf76I0/mqdefault.jpg",
    id: "zHFMlHf76I0",
    type: "video",
  },
  {
    lat: 56.96080231845938,
    lng: -2.2031201818305703,
    thumbnail: "https://img.youtube.com/vi/DpenjhQAn5Y/mqdefault.jpg",
    id: "DpenjhQAn5Y",
    type: "video",
  },
  {
    lat: 56.94597655075578,
    lng: -2.1985001872496173,
    thumbnail: "https://img.youtube.com/vi/LHiey0sdLug/mqdefault.jpg",
    id: "LHiey0sdLug",
    type: "video",
  },
  {
    lat: 56.57817895929816,
    lng: -2.56052942148557,
    thumbnail: "https://img.youtube.com/vi/v8bAZTWHfjg/mqdefault.jpg",
    id: "v8bAZTWHfjg",
    type: "video",
  },
  {
    lat: 56.56235496527396,
    lng: -2.583509987586658,
    thumbnail: "https://img.youtube.com/vi/qcZL76fkE9w/mqdefault.jpg",
    id: "qcZL76fkE9w",
    type: "video",
  },
  {
    lat: 56.4587449619212,
    lng: -2.9622418853249908,
    thumbnail: "https://img.youtube.com/vi/cIldNjh7Z3E/mqdefault.jpg",
    id: "cIldNjh7Z3E",
    type: "video",
  },
  {
    lat: 56.345665966895275,
    lng: -2.8052564667196505,
    thumbnail: "https://img.youtube.com/vi/avjKEaPjzFA/mqdefault.jpg",
    id: "avjKEaPjzFA",
    type: "video",
  },
  {
    lat: 56.30501080579426,
    lng: -2.6618433569700537,
    thumbnail: "https://img.youtube.com/vi/8LpYJgcnjf4/mqdefault.jpg",
    id: "8LpYJgcnjf4",
    type: "video",
  },
  {
    lat: 56.188629939769854,
    lng: -2.999426476527092,
    thumbnail: "https://img.youtube.com/vi/8QTY0kXkUBI/mqdefault.jpg",
    id: "8QTY0kXkUBI",
    type: "video",
  },
  {
    lat: 56.06397141153416,
    lng: -3.23764832846804,
    thumbnail: "https://img.youtube.com/vi/0QY2MDEEhbg/mqdefault.jpg",
    id: "0QY2MDEEhbg",
    type: "video",
  },
  {
    lat: 56.05124330674328,
    lng: -3.297656684770555,
    thumbnail: "https://img.youtube.com/vi/ZSfZid73TuE/mqdefault.jpg",
    id: "ZSfZid73TuE",
    type: "video",
  },
  {
    lat: 55.99019497408872,
    lng: -3.395751139803426,
    thumbnail: "https://img.youtube.com/vi/ctKMaD83ad0/mqdefault.jpg",
    id: "ctKMaD83ad0",
    type: "video",
  },
  {
    lat: 55.99066305010791,
    lng: -3.381935081077525,
    thumbnail: "https://img.youtube.com/vi/KDMz_rao1SQ/mqdefault.jpg",
    id: "KDMz_rao1SQ",
    type: "video",
  },
  {
    lat: 56.00833516929906,
    lng: -3.4041277967910166,
    thumbnail: "https://img.youtube.com/vi/qU_2Wwx0m4g/mqdefault.jpg",
    id: "qU_2Wwx0m4g",
    type: "video",
  },
  {
    lat: 55.95496219975441,
    lng: -2.9601484017714865,
    thumbnail: "https://img.youtube.com/vi/ez4OgmIH0N0/mqdefault.jpg",
    id: "ez4OgmIH0N0",
    type: "video",
  },
  {
    lat: 56.058751150326366,
    lng: -2.7134999335872765,
    thumbnail: "https://img.youtube.com/vi/oljTyB-nxlI/mqdefault.jpg",
    id: "oljTyB-nxlI",
    type: "video",
  },
  {
    lat: 56.05834380334276,
    lng: -2.7121910156834783,
    thumbnail: "https://img.youtube.com/vi/WfV2Ywk4PyI/mqdefault.jpg",
    id: "WfV2Ywk4PyI",
    type: "video",
  },
  {
    lat: 56.06072193010645,
    lng: -2.717737823521704,
    thumbnail: "https://img.youtube.com/vi/DVx5GOlioIs/mqdefault.jpg",
    id: "DVx5GOlioIs",
    type: "video",
  },
  {
    lat: 56.059134531791905,
    lng: -2.714309960650692,
    thumbnail: "https://img.youtube.com/vi/CicklWrA-hc/mqdefault.jpg",
    id: "CicklWrA-hc",
    type: "video",
  },
  {
    lat: 55.98374261363969,
    lng: -2.484587029781372,
    thumbnail: "https://img.youtube.com/vi/NrL7hbara6A/mqdefault.jpg",
    id: "NrL7hbara6A",
    type: "video",
  },
  {
    lat: 55.899520851541276,
    lng: -2.131908725128045,
    thumbnail: "https://img.youtube.com/vi/nkKX2ShDsTc/mqdefault.jpg",
    id: "nkKX2ShDsTc",
    type: "video",
  },
  {
    lat: 55.928472931829546,
    lng: -2.3304172528308675,
    thumbnail: "https://img.youtube.com/vi/V-84Z1Sx7q4/mqdefault.jpg",
    id: "V-84Z1Sx7q4",
    type: "video",
  },
  {
    lat: 55.86959045657284,
    lng: -2.0907101359376035,
    thumbnail: "https://img.youtube.com/vi/Uclbv331glQ/mqdefault.jpg",
    id: "Uclbv331glQ",
    type: "video",
  },
  {
    lat: 55.792912355369914,
    lng: -2.0862826158987082,
    thumbnail: "https://img.youtube.com/vi/C5lc-AHBNpc/mqdefault.jpg",
    id: "C5lc-AHBNpc",
    type: "video",
  },
  {
    lat: 51.032441986013616,
    lng: -3.014654003652134,
    thumbnail: "https://img.youtube.com/vi/xMpwVPtpPgo/mqdefault.jpg",
    id: "xMpwVPtpPgo",
    type: "video",
  },
  {
    lat: 51.017806387892826,
    lng: -3.101079242965516,
    thumbnail: "https://img.youtube.com/vi/bk5jNHOGX0c/mqdefault.jpg",
    id: "bk5jNHOGX0c",
    type: "video",
  },
  {
    lat: 51.01882175465774,
    lng: -3.101871870054284,
    thumbnail: "https://img.youtube.com/vi/gbXMuXvPpmw/mqdefault.jpg",
    id: "gbXMuXvPpmw",
    type: "video",
  },
  {
    lat: 51.03009651388016,
    lng: -3.017294268680427,
    thumbnail: "https://img.youtube.com/vi/MeG4A9UKsiM/mqdefault.jpg",
    id: "MeG4A9UKsiM",
    type: "video",
  },
  {
    lat: 51.06723229191897,
    lng: -2.9170997116020576,
    thumbnail: "https://img.youtube.com/vi/JYUWkFZQ6so/mqdefault.jpg",
    id: "JYUWkFZQ6so",
    type: "video",
  },
  {
    lat: 51.058857209992674,
    lng: -2.934401368008176,
    thumbnail: "https://img.youtube.com/vi/bnxni-BlcCU/mqdefault.jpg",
    id: "bnxni-BlcCU",
    type: "video",
  },
  {
    lat: 51.06662575869269,
    lng: -2.9171197315857254,
    thumbnail: "https://img.youtube.com/vi/F_rsOMGpDV0/mqdefault.jpg",
    id: "F_rsOMGpDV0",
    type: "video",
  },
  {
    lat: 51.093947415941784,
    lng: -2.9575574314650357,
    thumbnail: "https://img.youtube.com/vi/cdYAIkNW3cA/mqdefault.jpg",
    id: "cdYAIkNW3cA",
    type: "video",
  },
  {
    lat: 52.00215415411855,
    lng: -4.989929915492478,
    thumbnail: "https://img.youtube.com/vi/IMfxwD5_IG0/mqdefault.jpg",
    id: "IMfxwD5_IG0",
    type: "video",
  },


  //North West England YouTube Videos
  {
    lat: 53.358277484515085,
    lng: -3.1723156724721338,
    thumbnail: "https://img.youtube.com/vi/6ZZVlUdVKMM/mqdefault.jpg",
    id: "6ZZVlUdVKMM",
    type: "video",
  },
  {
    lat: 53.39569329949207,
    lng: -3.0079326390062198,
    thumbnail: "https://img.youtube.com/vi/sXJP0duppBI/mqdefault.jpg",
    id: "sXJP0duppBI",
    type: "video",
  },
  {
    lat: 53.404135109292405,
    lng: -2.968968336491156,
    thumbnail: "https://img.youtube.com/vi/BkvGhQIrL5M/mqdefault.jpg",
    id: "BkvGhQIrL5M",
    type: "video",
  },
  {
    lat: 53.71055398305319,
    lng: -2.7836482074462574,
    thumbnail: "https://img.youtube.com/vi/YEVk20Fk-4Q/mqdefault.jpg",
    id: "YEVk20Fk-4Q",
    type: "video",
  },
  {
    lat: 53.792369181805206,
    lng: -3.0555272817431605,
    thumbnail: "https://img.youtube.com/vi/p9OChD_zEuU/mqdefault.jpg",
    id: "p9OChD_zEuU",
    type: "video",
  },
  {
    lat: 53.697319300770815,
    lng: -2.886944465023411,
    thumbnail: "https://img.youtube.com/vi/AG2d_e3IrYY/mqdefault.jpg",
    id: "AG2d_e3IrYY",
    type: "video",
  },
  {
    lat: 53.740853362203374,
    lng: -3.015130861304501,
    thumbnail: "https://img.youtube.com/vi/ukInjF85z_o/mqdefault.jpg",
    id: "ukInjF85z_o",
    type: "video",
  },
  {
    lat: 53.92257470085243,
    lng: -3.0116590723274683,
    thumbnail: "https://img.youtube.com/vi/lJM0O7re8aU/mqdefault.jpg",
    id: "lJM0O7re8aU",
    type: "video",
  },
  {
    lat: 53.92847322341308,
    lng: -2.996940628500552,
    thumbnail: "https://img.youtube.com/vi/-w2afWyLSgs/mqdefault.jpg",
    id: "-w2afWyLSgs",
    type: "video",
  },
  {
    lat: 53.93082865015461,
    lng: -2.9463690259963653,
    thumbnail: "https://img.youtube.com/vi/HVHHRhnw1pc/mqdefault.jpg",
    id: "HVHHRhnw1pc",
    type: "video",
  },
  {
    lat: 54.05248257695778,
    lng: -2.8024745710644607,
    thumbnail: "https://img.youtube.com/vi/dajDk0du6Bo/mqdefault.jpg",
    id: "dajDk0du6Bo",
    type: "video",
  },
  {
    lat: 54.07292717201113,
    lng: -2.8677569163403014,
    thumbnail: "https://img.youtube.com/vi/X_jSFoOkb2s/mqdefault.jpg",
    id: "X_jSFoOkb2s",
    type: "video",
  },
  {
    lat: 54.12963048564567,
    lng: -2.771258561349826,
    thumbnail: "https://img.youtube.com/vi/HnJyFFiPjdE/mqdefault.jpg",
    id: "HnJyFFiPjdE",
    type: "video",
  },
  {
    lat: 54.17537260617656,
    lng: -2.8337861914331643,
    thumbnail: "https://img.youtube.com/vi/EO1IIy8ppuU/mqdefault.jpg",
    id: "EO1IIy8ppuU",
    type: "video",
  },
  {
    lat: 54.184711466307505,
    lng: -2.8313312225658347,
    thumbnail: "https://img.youtube.com/vi/rO79a5mVEzI/mqdefault.jpg",
    id: "rO79a5mVEzI",
    type: "video",
  },
  {
    lat: 54.6544449026576,
    lng: -2.717885563048898,
    thumbnail: "https://img.youtube.com/vi/xy--qZZ-CCU/mqdefault.jpg",
    id: "xy--qZZ-CCU",
    type: "video",
  },
  {
    lat: 54.35449654331929,
    lng: -2.9300189793221842,
    thumbnail: "https://img.youtube.com/vi/eZrHaGvkAQo/mqdefault.jpg",
    id: "eZrHaGvkAQo",
    type: "video",
  },
  {
    lat: 54.20101233766257,
    lng: -2.95257941250434,
    thumbnail: "https://img.youtube.com/vi/Zsb6kOa9DJg/mqdefault.jpg",
    id: "Zsb6kOa9DJg",
    type: "video",
  },
  {
    lat: 54.19330032630243,
    lng: -3.0906089882690564,
    thumbnail: "https://img.youtube.com/vi/kabqkGrS_eE/mqdefault.jpg",
    id: "kabqkGrS_eE",
    type: "video",
  },
  {
    lat: 54.10269494949222,
    lng: -3.262703707168331,
    thumbnail: "https://img.youtube.com/vi/5zYchJ2Ndqk/mqdefault.jpg",
    id: "5zYchJ2Ndqk",
    type: "video",
  },
  {
    lat: 54.08445526213763,
    lng: -3.2399094047651578,
    thumbnail: "https://img.youtube.com/vi/I3GixyjZdwE/mqdefault.jpg",
    id: "I3GixyjZdwE",
    type: "video",
  },
  {
    lat: 54.1361924056667,
    lng: -3.198241935618114,
    thumbnail: "https://img.youtube.com/vi/gXrTjdfLUO0/mqdefault.jpg",
    id: "gXrTjdfLUO0",
    type: "video",
  },
  {
    lat: 54.33548991536382,
    lng: -3.4051212937708937,
    thumbnail: "https://img.youtube.com/vi/DFA7Egi6L4c/mqdefault.jpg",
    id: "DFA7Egi6L4c",
    type: "video",
  },
  {
    lat: 54.35757899108905,
    lng: -3.4116329367620932,
    thumbnail: "https://img.youtube.com/vi/WwvIy_U-MFk/mqdefault.jpg",
    id: "WwvIy_U-MFk",
    type: "video",
  },
  {
    lat: 54.4404388320569,
    lng: -3.520424006266376,
    thumbnail: "https://img.youtube.com/vi/CrH0fMZkGb0/mqdefault.jpg",
    id: "CrH0fMZkGb0",
    type: "video",
  },
  {
    lat: 54.493950858777104,
    lng: -3.592910811097772,
    thumbnail: "https://img.youtube.com/vi/Pec92z9s1s4/mqdefault.jpg",
    id: "Pec92z9s1s4",
    type: "video",
  },
  {
    lat: 54.49149148309952,
    lng: -3.5899075388605897,
    thumbnail: "https://img.youtube.com/vi/GInZwv9Q2a8/mqdefault.jpg",
    id: "GInZwv9Q2a8",
    type: "video",
  },
  {
    lat: 54.68693580228451,
    lng: -3.5197688124243864,
    thumbnail: "https://img.youtube.com/vi/bx6NYkaDor4/mqdefault.jpg",
    id: "bx6NYkaDor4",
    type: "video",
  },
  {
    lat: 54.72114989431671,
    lng: -3.4977630194266927,
    thumbnail: "https://img.youtube.com/vi/019PqbMOxmo/mqdefault.jpg",
    id: "019PqbMOxmo",
    type: "video",
  },
  {
    lat: 54.922172883816536,
    lng: -3.049051200344915,
    thumbnail: "https://img.youtube.com/vi/iS9Xz0ECV3U/mqdefault.jpg",
    id: "iS9Xz0ECV3U",
    type: "video",
  },
  {
    lat: 54.89484825046179,
    lng: -2.9388388497878903,
    thumbnail: "https://img.youtube.com/vi/XgRUvMO04cw/mqdefault.jpg",
    id: "XgRUvMO04cw",
    type: "video",
  },

  
  // South of England YouTube videos
  {
    lat: 51.51648673380236,
    lng: -0.17602118982977036,
    thumbnail: "https://img.youtube.com/vi/R-3zzXeLpeo/mqdefault.jpg",
    id: "R-3zzXeLpeo",
    type: "video",
  },
  {
    lat: 51.469953847108656,
    lng: 0.2087983000338975,
    thumbnail: "https://img.youtube.com/vi/u0zpRAaQJ88/mqdefault.jpg",
    id: "u0zpRAaQJ88",
    type: "video",
  },
  {
    lat: 51.39243697563456,
    lng: 0.4987613525755561,
    thumbnail: "https://img.youtube.com/vi/psAWrbJU21Q/mqdefault.jpg",
    id: "psAWrbJU21Q",
    type: "video",
  },
  {
    lat: 50.68734369650161,
    lng: -1.3146372402823416,
    thumbnail: "https://img.youtube.com/vi/hbO2foBGsf8/mqdefault.jpg",
    id: "hbO2foBGsf8",
    type: "video",
  },
  {
    lat: 50.729561235443654,
    lng: -1.5536649765839654,
    thumbnail: "https://img.youtube.com/vi/mgQ2Ghr5N8w/mqdefault.jpg",
    id: "mgQ2Ghr5N8w",
    type: "video",
  },
  {
    lat: 50.69439702732522,
    lng: -1.9331653655034602,
    thumbnail: "https://img.youtube.com/vi/B6qCOsbYP5Y/mqdefault.jpg",
    id: "B6qCOsbYP5Y",
    type: "video",
  },
  {
    lat: 50.660927029355655,
    lng: -1.9729732690865083,
    thumbnail: "https://img.youtube.com/vi/Xqt0pqvoLNk/mqdefault.jpg",
    id: "Xqt0pqvoLNk",
    type: "video",
  },
  {
    lat: 50.63901865355512,
    lng: -2.052787137981935,
    thumbnail: "https://img.youtube.com/vi/FJJn5hFiY1A/mqdefault.jpg",
    id: "FJJn5hFiY1A",
    type: "video",
  },
  {
    lat: 50.64522953994984,
    lng: -2.3907169633726832,
    thumbnail: "https://img.youtube.com/vi/BvBzTGLzexw/mqdefault.jpg",
    id: "BvBzTGLzexw",
    type: "video",
  },
  {
    lat: 50.673934340537215,
    lng: -2.6238942711573414,
    thumbnail: "https://img.youtube.com/vi/PaU4GOvy-D8/mqdefault.jpg",
    id: "PaU4GOvy-D8",
    type: "video",
  },
  {
    lat: 50.65886281889659,
    lng: -2.624529522817995,
    thumbnail: "https://img.youtube.com/vi/PWCjQB9yg-8/mqdefault.jpg",
    id: "PWCjQB9yg-8",
    type: "video",
  },
  {
    lat: 50.70932848479324,
    lng: -2.760515130400533,
    thumbnail: "https://img.youtube.com/vi/jzq_Fg6DZzc/mqdefault.jpg",
    id: "jzq_Fg6DZzc",
    type: "video",
  },
  {
    lat: 50.69227984144116,
    lng: -3.137957888350759,
    thumbnail: "https://img.youtube.com/vi/yp_CZTUgZgg/mqdefault.jpg",
    id: "yp_CZTUgZgg",
    type: "video",
  },
  {
    lat: 50.696672983486074,
    lng: -3.190169457725522,
    thumbnail: "https://img.youtube.com/vi/JGQegjO-MZ8/mqdefault.jpg",
    id: "JGQegjO-MZ8",
    type: "video",
  },
  {
    lat: 50.461238224649115,
    lng: -3.530581994524634,
    thumbnail: "https://img.youtube.com/vi/edt0JydRaZY/mqdefault.jpg",
    id: "edt0JydRaZY",
    type: "video",
  },
  {
    lat: 50.38266372821074,
    lng: -3.5947939934895077,
    thumbnail: "https://img.youtube.com/vi/9eWd-QleLh4/mqdefault.jpg",
    id: "9eWd-QleLh4",
    type: "video",
  },
  {
    lat: 50.384387709137734,
    lng: -3.6032268586375147,
    thumbnail: "https://img.youtube.com/vi/3NnhnaNkXQQ/mqdefault.jpg",
    id: "3NnhnaNkXQQ",
    type: "video",
  },
  {
    lat: 50.38438428858577,
    lng: -3.611981588857458,
    thumbnail: "https://img.youtube.com/vi/mGLcb1KQx3o/mqdefault.jpg",
    id: "mGLcb1KQx3o",
    type: "video",
  },
  {
    lat: 50.34956311531192,
    lng: -4.1848370965790505,
    thumbnail: "https://img.youtube.com/vi/_A7ARP_XhKs/mqdefault.jpg",
    id: "_A7ARP_XhKs",
    type: "video",
  },
  {
    lat: 50.33411582009153,
    lng: -4.199836009583746,
    thumbnail: "https://img.youtube.com/vi/BTC8DgIi3qA/mqdefault.jpg",
    id: "BTC8DgIi3qA",
    type: "video",
  },
  {
    lat: 50.33405922337941,
    lng: -4.226550729993789,
    thumbnail: "https://img.youtube.com/vi/fGL3azi_SMs/mqdefault.jpg",
    id: "fGL3azi_SMs",
    type: "video",
  },
  {
    lat: 50.34002602186486,
    lng: -4.236970556415559,
    thumbnail: "https://img.youtube.com/vi/onQudQ43zxk/mqdefault.jpg",
    id: "onQudQ43zxk",
    type: "video",
  },
  {
    lat: 50.35145763539666,
    lng: -4.452296169144774,
    thumbnail: "https://img.youtube.com/vi/5TdQSVtjNoA/mqdefault.jpg",
    id: "5TdQSVtjNoA",
    type: "video",
  },
  {
    lat: 50.33044859162061,
    lng: -4.614075615170869,
    thumbnail: "https://img.youtube.com/vi/-eOqb41sJfk/mqdefault.jpg",
    id: "-eOqb41sJfk",
    type: "video",
  },
  {
    lat: 51.81103448984107,
    lng: -0.9351253878337176,
    thumbnail: "https://img.youtube.com/vi/9mfxeqiwtH0/mqdefault.jpg",
    id: "9mfxeqiwtH0",
    type: "video",
  },
  {
    lat: 50.36628895576411,
    lng: -4.1337724000274525,
    thumbnail: "https://img.youtube.com/vi/VDp6RZahIMw/mqdefault.jpg",
    id: "VDp6RZahIMw",
    type: "video",
  },
  {
    lat: 50.43495660309812,
    lng: -3.5646398408394,
    thumbnail: "https://img.youtube.com/vi/Zb5hfuJFSE4/mqdefault.jpg",
    id: "Zb5hfuJFSE4",
    type: "video",
  },
  {
    lat: 50.43495660309812,
    lng: -3.5646398408394,
    thumbnail: "https://img.youtube.com/vi/yZACDqGqkDg/mqdefault.jpg",
    id: "yZACDqGqkDg",
    type: "video",
  },
  {
    lat: 50.35145295981414,
    lng: -3.5662491676182895,
    thumbnail: "https://img.youtube.com/vi/8NNeekDNYc0/mqdefault.jpg",
    id: "8NNeekDNYc0",
    type: "video",
  },
  {
    lat: 50.34976543533235,
    lng: -3.570444142483463,
    thumbnail: "https://img.youtube.com/vi/tBfNKv2wovw/mqdefault.jpg",
    id: "tBfNKv2wovw",
    type: "video",
  },
  {
    lat: 50.34976543533235,
    lng: -3.570444142483463,
    thumbnail: "https://img.youtube.com/vi/GZRK8XR4AMk/mqdefault.jpg",
    id: "GZRK8XR4AMk",
    type: "video",
  },
  {
    lat: 50.35154195482517,
    lng: -3.5774822631339784,
    thumbnail: "https://img.youtube.com/vi/ejV7yUwQvgM/mqdefault.jpg",
    id: "ejV7yUwQvgM",
    type: "video",
  },
  {
    lat: 50.32020520947117,
    lng: -3.610419785331415,
    thumbnail: "https://img.youtube.com/vi/tO8aUWn8-Ls/mqdefault.jpg",
    id: "tO8aUWn8-Ls",
    type: "video",
  },
  {
    lat: 50.28764132359937,
    lng: -3.6449237222566424,
    thumbnail: "https://img.youtube.com/vi/-jwnyrCoABo/mqdefault.jpg",
    id: "-jwnyrCoABo",
    type: "video",
  },
  {
    lat: 50.236365629355525,
    lng: -3.7663097734572455,
    thumbnail: "https://img.youtube.com/vi/3PHoc7QJMTI/mqdefault.jpg",
    id: "3PHoc7QJMTI",
    type: "video",
  },
  {
    lat: 50.10466393230093,
    lng: -5.095306546959454,
    thumbnail: "https://img.youtube.com/vi/tgN-A9Ej7SU/mqdefault.jpg",
    id: "tgN-A9Ej7SU",
    type: "video",
  },
  {
    lat: 50.10009450598132,
    lng: -5.128909261032371,
    thumbnail: "https://img.youtube.com/vi/UrgHt7Fw2SM/mqdefault.jpg",
    id: "UrgHt7Fw2SM",
    type: "video",
  },
  {
    lat: 49.971816493201594,
    lng: -5.2020470762064654,
    thumbnail: "https://img.youtube.com/vi/llsvs_BPZuQ/mqdefault.jpg",
    id: "llsvs_BPZuQ",
    type: "video",
  },
  {
    lat: 49.95893171299768,
    lng: -5.206478085672409,
    thumbnail: "https://img.youtube.com/vi/cfvFDlVnJS4/mqdefault.jpg",
    id: "cfvFDlVnJS4",
    type: "video",
  },
  {
    lat: 50.08621143453979,
    lng: -5.315965858226611,
    thumbnail: "https://img.youtube.com/vi/0KItY4ckuTk/mqdefault.jpg",
    id: "0KItY4ckuTk",
    type: "video",
  },
  {
    lat: 50.12338102948381,
    lng: -5.474291978443062,
    thumbnail: "https://img.youtube.com/vi/qblJxPFiWko/mqdefault.jpg",
    id: "qblJxPFiWko",
    type: "video",
  },
  {
    lat: 50.062349270481285,
    lng: -5.564472531365677,
    thumbnail: "https://img.youtube.com/vi/bwW8SwumpLI/mqdefault.jpg",
    id: "bwW8SwumpLI",
    type: "video",
  },
  {
    lat: 50.06570753680633,
    lng: -5.588737811448318,
    thumbnail: "https://img.youtube.com/vi/Ulwa6dT6KLk/mqdefault.jpg",
    id: "Ulwa6dT6KLk",
    type: "video",
  },
  {
    lat: 50.06266579535387,
    lng: -5.598334583361455,
    thumbnail: "https://img.youtube.com/vi/YwEan7HroYA/mqdefault.jpg",
    id: "YwEan7HroYA",
    type: "video",
  },
  {
    lat: 50.043308680292824,
    lng: -5.651436530704716,
    thumbnail: "https://img.youtube.com/vi/zYDVAv_AfPk/mqdefault.jpg",
    id: "zYDVAv_AfPk",
    type: "video",
  },
  {
    lat: 50.06632480803377,
    lng: -5.714815073802801,
    thumbnail: "https://img.youtube.com/vi/f8igojivLIU/mqdefault.jpg",
    id: "f8igojivLIU",
    type: "video",
  },
  {
    lat: 50.104149597426115,
    lng: -5.6698467683737555,
    thumbnail: "https://img.youtube.com/vi/rtTNo1GMgCU/mqdefault.jpg",
    id: "rtTNo1GMgCU",
    type: "video",
  },
  {
    lat: 50.305413114319116,
    lng: -5.233100549104054,
    thumbnail: "https://img.youtube.com/vi/mmOwfacuDIs/mqdefault.jpg",
    id: "mmOwfacuDIs",
    type: "video",
  },
  {
    lat: 50.412780874463834,
    lng: -5.1023034404494165,
    thumbnail: "https://img.youtube.com/vi/bcp57NLB8d8/mqdefault.jpg",
    id: "bcp57NLB8d8",
    type: "video",
  },
  {
    lat: 50.667655110595284,
    lng: -4.758667634675553,
    thumbnail: "https://img.youtube.com/vi/W-1qY1zWiWU/mqdefault.jpg",
    id: "W-1qY1zWiWU",
    type: "video",
  },
  {
    lat: 50.690017008253534,
    lng: -4.695379506554146,
    thumbnail: "https://img.youtube.com/vi/LUHl_szOgdM/mqdefault.jpg",
    id: "LUHl_szOgdM",
    type: "video",
  },
  {
    lat: 50.74261278359725,
    lng: -4.60559820751126,
    thumbnail: "https://img.youtube.com/vi/FyxbEPfoTwo/mqdefault.jpg",
    id: "FyxbEPfoTwo",
    type: "video",
  },
  {
    lat: 50.77107594007802,
    lng: -4.57725631835635,
    thumbnail: "https://img.youtube.com/vi/1pe1MW7hxUM/mqdefault.jpg",
    id: "1pe1MW7hxUM",
    type: "video",
  },
  {
    lat: 50.837273073049374,
    lng: -4.518906377942892,
    thumbnail: "https://img.youtube.com/vi/M940cArXeDI/mqdefault.jpg",
    id: "M940cArXeDI",
    type: "video",
  },
  {
    lat: 50.60013884186992,
    lng: -4.446133891580548,
    thumbnail: "https://img.youtube.com/vi/5RLWipqCnAo/mqdefault.jpg",
    id: "5RLWipqCnAo",
    type: "video",
  },
  {
    lat: 50.877375298344724,
    lng: -4.546107411679256,
    thumbnail: "https://img.youtube.com/vi/kJiljRfdC9g/mqdefault.jpg",
    id: "kJiljRfdC9g",
    type: "video",
  },
  {
    lat: 50.93363037352942,
    lng: -4.545085384747753,
    thumbnail: "https://img.youtube.com/vi/_dtYwLkr-38/mqdefault.jpg",
    id: "_dtYwLkr-38",
    type: "video",
  },
  {
    lat: 50.99740387997032,
    lng: -4.400506728377372,
    thumbnail: "https://img.youtube.com/vi/KdzIwURkAKk/mqdefault.jpg",
    id: "KdzIwURkAKk",
    type: "video",
  },
  {
    lat: 50.99485094083518,
    lng: -4.516560548179881,
    thumbnail: "https://img.youtube.com/vi/hgEjHvdm3wE/mqdefault.jpg",
    id: "hgEjHvdm3wE",
    type: "video",
  },
  {
    lat: 50.964663583835744,
    lng: -4.3765258518097205,
    thumbnail: "https://img.youtube.com/vi/TtdFJInGEFg/mqdefault.jpg",
    id: "TtdFJInGEFg",
    type: "video",
  },
  {
    lat: 50.97528179012424,
    lng: -4.288750838335698,
    thumbnail: "https://img.youtube.com/vi/zvOVKSuFC4o/mqdefault.jpg",
    id: "zvOVKSuFC4o",
    type: "video",
  },
  {
    lat: 50.948629090920676,
    lng: -4.315292820225113,
    thumbnail: "https://img.youtube.com/vi/NMmGkTqQM_w/mqdefault.jpg",
    id: "NMmGkTqQM_w",
    type: "video",
  },
  {
    lat: 50.86256793368724,
    lng: -4.433358122138717,
    thumbnail: "https://img.youtube.com/vi/6YlED2x-fSM/mqdefault.jpg",
    id: "6YlED2x-fSM",
    type: "video",
  },
  {
    lat: 51.038800896777666,
    lng: -4.235268121982777,
    thumbnail: "https://img.youtube.com/vi/XvA409aXWOk/mqdefault.jpg",
    id: "XvA409aXWOk",
    type: "video",
  },
  {
    lat: 51.45162333263117,
    lng: -2.769888796949372,
    thumbnail: "https://img.youtube.com/vi/vcf3YXn0AT4/mqdefault.jpg",
    id: "vcf3YXn0AT4",
    type: "video",
  },
  {
    lat: 51.063680650810795,
    lng: -4.175215621630968,
    thumbnail: "https://img.youtube.com/vi/SR6-EZ1zaT8/mqdefault.jpg",
    id: "SR6-EZ1zaT8",
    type: "video",
  },
  {
    lat: 51.11956334279736,
    lng: -4.227459849461755,
    thumbnail: "https://img.youtube.com/vi/QxptbXMHIss/mqdefault.jpg",
    id: "QxptbXMHIss",
    type: "video",
  },
  {
    lat: 51.21085442118295,
    lng: -4.111581043709097,
    thumbnail: "https://img.youtube.com/vi/x4QIcJCDb7U/mqdefault.jpg",
    id: "x4QIcJCDb7U",
    type: "video",
  },
  {
    lat: 51.21449703426298,
    lng: -3.9617039750198964,
    thumbnail: "https://img.youtube.com/vi/qcrj3mdmeig/mqdefault.jpg",
    id: "qcrj3mdmeig",
    type: "video",
  },
  {
    lat: 51.21489244621429,
    lng: -4.077432370330901,
    thumbnail: "https://img.youtube.com/vi/x58H2adfZVw/mqdefault.jpg",
    id: "x58H2adfZVw",
    type: "video",
  },
  {
    lat: 51.231792062084025,
    lng: -3.831102626628578,
    thumbnail: "https://img.youtube.com/vi/g_fHmaZTpfw/mqdefault.jpg",
    id: "g_fHmaZTpfw",
    type: "video",
  },
  {
    lat: 51.231715399587294,
    lng: -3.8324727231363145,
    thumbnail: "https://img.youtube.com/vi/r36vKXLIazo/mqdefault.jpg",
    id: "r36vKXLIazo",
    type: "video",
  },
  {
    lat: 51.21939289840223,
    lng: -3.8011590064621372,
    thumbnail: "https://img.youtube.com/vi/lrqWGcUO9PE/mqdefault.jpg",
    id: "lrqWGcUO9PE",
    type: "video",
  },
  {
    lat: 51.2159553422797,
    lng: -3.7306930537738285,
    thumbnail: "https://img.youtube.com/vi/2E2WSHPI8EY/mqdefault.jpg",
    id: "2E2WSHPI8EY",
    type: "video",
  },
  {
    lat: 51.20369864178623,
    lng: -3.66012738295005,
    thumbnail: "https://img.youtube.com/vi/qVereBFIU9o/mqdefault.jpg",
    id: "qVereBFIU9o",
    type: "video",
  },
  {
    lat: 51.20839993545355,
    lng: -3.595656493736753,
    thumbnail: "https://img.youtube.com/vi/xKMOXijWtmM/mqdefault.jpg",
    id: "xKMOXijWtmM",
    type: "video",
  },
  {
    lat: 51.210999757730335,
    lng: -3.473799617865813,
    thumbnail: "https://img.youtube.com/vi/VMbQTgplpN4/mqdefault.jpg",
    id: "VMbQTgplpN4",
    type: "video",
  },
  {
    lat: 51.183650212463625,
    lng: -3.444128845586344,
    thumbnail: "https://img.youtube.com/vi/UfuJslfQxJs/mqdefault.jpg",
    id: "UfuJslfQxJs",
    type: "video",
  },
  {
    lat: 51.16769442848307,
    lng: -3.4602699879218446,
    thumbnail: "https://img.youtube.com/vi/E9DfxhKhWO4/mqdefault.jpg",
    id: "E9DfxhKhWO4",
    type: "video",
  },
  {
    lat: 51.16149508755096,
    lng: -3.4085674962256967,
    thumbnail: "https://img.youtube.com/vi/LnbMXgf5BCk/mqdefault.jpg",
    id: "LnbMXgf5BCk",
    type: "video",
  },
  {
    lat: 51.180737296002675,
    lng: -3.329557481092605,
    thumbnail: "https://img.youtube.com/vi/i5JiHXSUx_o/mqdefault.jpg",
    id: "i5JiHXSUx_o",
    type: "video",
  },
  {
    lat: 51.23455189020558,
    lng: -2.9996429471544532,
    thumbnail: "https://img.youtube.com/vi/wPSzmN03ojc/mqdefault.jpg",
    id: "wPSzmN03ojc",
    type: "video",
  },
  {
    lat: 51.347459504365126,
    lng: -2.981569725461068,
    thumbnail: "https://img.youtube.com/vi/qdWP4VPvpaw/mqdefault.jpg",
    id: "qdWP4VPvpaw",
    type: "video",
  },
  {
    lat: 51.35151684727407,
    lng: -2.984367632271591,
    thumbnail: "https://img.youtube.com/vi/pNbOcF1pXds/mqdefault.jpg",
    id: "pNbOcF1pXds",
    type: "video",
  },
  {
    lat: 51.604608709346515,
    lng: -2.626668830877479,
    thumbnail: "https://img.youtube.com/vi/gfIAup1JKjY/mqdefault.jpg",
    id: "gfIAup1JKjY",
    type: "video",
  },
  {
    lat: 51.39243697563456,
    lng: 0.4987613525755561,
    thumbnail: "https://img.youtube.com/vi/AHp8UN1zzis/mqdefault.jpg",
    id: "AHp8UN1zzis",
    type: "video",
  },
  {
    lat: 51.44405543471428,
    lng: 0.3680300550163265,
    thumbnail: "https://img.youtube.com/vi/vsiZCd54Ht0/mqdefault.jpg",
    id: "vsiZCd54Ht0",
    type: "video",
  },
  {
    lat: 51.44421798973156,
    lng: 0.37772744983128115,
    thumbnail: "https://img.youtube.com/vi/iWewjwKsKEY/mqdefault.jpg",
    id: "iWewjwKsKEY",
    type: "video",
  },
  {
    lat: 51.46123121896543,
    lng: 0.4946775147215927,
    thumbnail: "https://img.youtube.com/vi/xk5jh_oGbgg/mqdefault.jpg",
    id: "xk5jh_oGbgg",
    type: "video",
  },
  {
    lat: 51.45516120270075,
    lng: 0.5261233374553826,
    thumbnail: "https://img.youtube.com/vi/JeRbAGdmRsg/mqdefault.jpg",
    id: "JeRbAGdmRsg",
    type: "video",
  },
  {
    lat: 51.45471001773498,
    lng: 0.5229751015614672,
    thumbnail: "https://img.youtube.com/vi/nhdjmHjWb_Y/mqdefault.jpg",
    id: "nhdjmHjWb_Y",
    type: "video",
  },
  {
    lat: 51.39030116098678,
    lng: 0.5010949318128836,
    thumbnail: "https://img.youtube.com/vi/GmHcuKhE8y4/mqdefault.jpg",
    id: "GmHcuKhE8y4",
    type: "video",
  },
  {
    lat: 51.38926343644996,
    lng: 0.502816909934952,
    thumbnail: "https://img.youtube.com/vi/6r20iDjA74k/mqdefault.jpg",
    id: "6r20iDjA74k",
    type: "video",
  },
  {
    lat: 51.41625964949428,
    lng: 0.747792241643703,
    thumbnail: "https://img.youtube.com/vi/ZVvIlEukt-4/mqdefault.jpg",
    id: "ZVvIlEukt-4",
    type: "video",
  },
  {
    lat: 51.44505924145609,
    lng: 0.7526471383957986,
    thumbnail: "https://img.youtube.com/vi/kXhQ2sHo9tQ/mqdefault.jpg",
    id: "kXhQ2sHo9tQ",
    type: "video",
  },
  {
    lat: 51.37952145605981,
    lng: 1.199908026842853,
    thumbnail: "https://img.youtube.com/vi/FTwUJOoZZ6g/mqdefault.jpg",
    id: "FTwUJOoZZ6g",
    type: "video",
  },
  {
    lat: 51.3647774438479,
    lng: 0.6464907175111668,
    thumbnail: "https://img.youtube.com/vi/MgV8Wz1xb_Y/mqdefault.jpg",
    id: "MgV8Wz1xb_Y",
    type: "video",
  },
  {
    lat: 51.077615,
    lng: 1.1895186,
    thumbnail: "https://img.youtube.com/vi/i7-0utu8gZo/mqdefault.jpg",
    id: "i7-0utu8gZo",
    type: "video",
  },
  {
    lat: 51.31706548734096,
    lng: 0.8949682144373972,
    thumbnail: "https://img.youtube.com/vi/xU89tfm7cPk/mqdefault.jpg",
    id: "xU89tfm7cPk",
    type: "video",
  },
  {
    lat: 51.38233083913756,
    lng: 1.2883614872848268,
    thumbnail: "https://img.youtube.com/vi/ywqADQnMKYE/mqdefault.jpg",
    id: "ywqADQnMKYE",
    type: "video",
  },
  {
    lat: 51.01544149824717,
    lng: -4.201095836139719,
    thumbnail: "https://img.youtube.com/vi/_WIEI_cCKYM/mqdefault.jpg",
    id: "_WIEI_cCKYM",
    type: "video",
  },
  {
    lat: 51.371636266262186,
    lng: 1.106468286841787,
    thumbnail: "https://img.youtube.com/vi/H3HBoxcwkFg/mqdefault.jpg",
    id: "H3HBoxcwkFg",
    type: "video",
  },
  {
    lat: 50.92260278930444,
    lng: 0.9765174551119242,
    thumbnail: "https://img.youtube.com/vi/ZzhYeEtjogY/mqdefault.jpg",
    id: "ZzhYeEtjogY",
    type: "video",
  },
  {
    lat: 50.951814460978206,
    lng: 0.9064661549890841,
    thumbnail: "https://img.youtube.com/vi/WDtxe0pG9_Y/mqdefault.jpg",
    id: "WDtxe0pG9_Y",
    type: "video",
  },
  {
    lat: 50.92917939027513,
    lng: 0.8203440538424952,
    thumbnail: "https://img.youtube.com/vi/qY0hJ2a0BZQ/mqdefault.jpg",
    id: "qY0hJ2a0BZQ",
    type: "video",
  },
  {
    lat: 51.383807073646736,
    lng: 1.4419723490511047,
    thumbnail: "https://img.youtube.com/vi/svxoMTW_B0g/mqdefault.jpg",
    id: "svxoMTW_B0g",
    type: "video",
  },
  {
    lat: 50.83637859866639,
    lng: -0.7807679248975384,
    thumbnail: "https://img.youtube.com/vi/BVXisiGF2lE/mqdefault.jpg",
    id: "BVXisiGF2lE",
    type: "video",
  },
  {
    lat: 51.12246596487274,
    lng: 1.315425752564934,
    thumbnail: "https://img.youtube.com/vi/MEsij83oURM/mqdefault.jpg",
    id: "MEsij83oURM",
    type: "video",
  },
  {
    lat: 51.12994319324653,
    lng: 1.3326321758804518,
    thumbnail: "https://img.youtube.com/vi/-ipLxr5CsuA/mqdefault.jpg",
    id: "-ipLxr5CsuA",
    type: "video",
  },
  {
    lat: 50.85631056062732,
    lng: 0.5864119404329173,
    thumbnail: "https://img.youtube.com/vi/8sixPZs04RE/mqdefault.jpg",
    id: "8sixPZs04RE",
    type: "video",
  },
  {
    lat: 50.74251808201175,
    lng: 0.2013185445856149,
    thumbnail: "https://img.youtube.com/vi/nSaT0j7ecTg/mqdefault.jpg",
    id: "nSaT0j7ecTg",
    type: "video",
  },
  {
    lat: 50.85084110362352,
    lng: 0.554464079640289,
    thumbnail: "https://img.youtube.com/vi/I2P3a6XXnN0/mqdefault.jpg",
    id: "I2P3a6XXnN0",
    type: "video",
  },
  {
    lat: 50.758952670287066,
    lng: 0.14385143645186402,
    thumbnail: "https://img.youtube.com/vi/HMW8h7U-GKU/mqdefault.jpg",
    id: "HMW8h7U-GKU",
    type: "video",
  },
  {
    lat: 50.8225263199872,
    lng: -0.1563819205423937,
    thumbnail: "https://img.youtube.com/vi/TT3-JaaUykM/mqdefault.jpg",
    id: "TT3-JaaUykM",
    type: "video",
  },
  {
    lat: 50.80952211312433,
    lng: -0.3696747196557726,
    thumbnail: "https://img.youtube.com/vi/tyqsMwKkgs4/mqdefault.jpg",
    id: "tyqsMwKkgs4",
    type: "video",
  },
  {
    lat: 50.83631924959039,
    lng: -0.7808526789973257,
    thumbnail: "https://img.youtube.com/vi/Y7F77ABhTLU/mqdefault.jpg",
    id: "Y7F77ABhTLU",
    type: "video",
  },
  {
    lat: 50.82885096628185,
    lng: -0.8594510820193423,
    thumbnail: "https://img.youtube.com/vi/HenPpvaPtqo/mqdefault.jpg",
    id: "HenPpvaPtqo",
    type: "video",
  },
  {
    lat: 50.78192480248619,
    lng: -1.0888394246617679,
    thumbnail: "https://img.youtube.com/vi/LA9AcqIlJVA/mqdefault.jpg",
    id: "LA9AcqIlJVA",
    type: "video",
  },




  // Er, She & Me YouTube videos
  {
    lat: 55.85916595105068,
    lng: -4.258591515956469,
    thumbnail: "https://img.youtube.com/vi/jRgyNaL-umU/mqdefault.jpg",
    id: "jRgyNaL-umU",
    type: "video",
  },
  {
    lat: 56.20330148811498,
    lng: -4.723148555622444,
    thumbnail: "https://img.youtube.com/vi/tmHR80dB94I/mqdefault.jpg",
    id: "tmHR80dB94I",
    type: "video",
  },
  {
    lat: 56.190410665833305,
    lng: -4.748390244871329,
    thumbnail: "https://img.youtube.com/vi/NQJV7VZ3HGQ/mqdefault.jpg",
    id: "NQJV7VZ3HGQ",
    type: "video",
  },
  {
    lat: 56.163015628339835,
    lng: -4.7800637730107285,
    thumbnail: "https://img.youtube.com/vi/w52uMlJozIY/mqdefault.jpg",
    id: "w52uMlJozIY",
    type: "video",
  },
  {
    lat: 56.148575747316926,
    lng: -4.6599372593232555,
    thumbnail: "https://img.youtube.com/vi/c7JpHsSrQC0/mqdefault.jpg",
    id: "c7JpHsSrQC0",
    type: "video",
  },
  {
    lat: 56.20276692271898,
    lng: -4.707593733959763,
    thumbnail: "https://img.youtube.com/vi/4WrgZXRDK5g/mqdefault.jpg",
    id: "4WrgZXRDK5g",
    type: "video",
  },
  {
    lat: 56.24266133852923,
    lng: -4.684831185453346,
    thumbnail: "https://img.youtube.com/vi/-K2ZYMmfc1s/mqdefault.jpg",
    id: "-K2ZYMmfc1s",
    type: "video",
  },
  {
    lat: 56.23074134702123,
    lng: -4.4059750950778716,
    thumbnail: "https://img.youtube.com/vi/V2Ny_YKnjX8/mqdefault.jpg",
    id: "V2Ny_YKnjX8",
    type: "video",
  },
  {
    lat: 56.22961853057853,
    lng: -4.363620512848492,
    thumbnail: "https://img.youtube.com/vi/GdNwW7axa6o/mqdefault.jpg",
    id: "GdNwW7axa6o",
    type: "video",
  },
  {
    lat: 56.23075970876006,
    lng: -4.365455195235579,
    thumbnail: "https://img.youtube.com/vi/wEZU7ENDckg/mqdefault.jpg",
    id: "wEZU7ENDckg",
    type: "video",
  },
  {
    lat: 56.226372633395755,
    lng: -4.373117119580024,
    thumbnail: "https://img.youtube.com/vi/DL7k2CF0cxU/mqdefault.jpg",
    id: "DL7k2CF0cxU",
    type: "video",
  },
  {
    lat: 56.24875336357599,
    lng: -4.372596215257092,
    thumbnail: "https://img.youtube.com/vi/dkYPvSJEIBI/mqdefault.jpg",
    id: "dkYPvSJEIBI",
    type: "video",
  },
  {
    lat: 56.21606598815992,
    lng: -4.292506710405474,
    thumbnail: "https://img.youtube.com/vi/2sorwwN7_qQ/mqdefault.jpg",
    id: "2sorwwN7_qQ",
    type: "video",
  },
  {
    lat: 56.24384145755516,
    lng: -4.214654125103303,
    thumbnail: "https://img.youtube.com/vi/SVqionW_q1A/mqdefault.jpg",
    id: "SVqionW_q1A",
    type: "video",
  },
  {
    lat: 56.242851958845016,
    lng: -4.238819909774711,
    thumbnail: "https://img.youtube.com/vi/rp5NYd-uKXI/mqdefault.jpg",
    id: "rp5NYd-uKXI",
    type: "video",
  },
  {
    lat: 56.25080628830946,
    lng: -4.281392255000385,
    thumbnail: "https://img.youtube.com/vi/UMr_R0nwBqk/mqdefault.jpg",
    id: "UMr_R0nwBqk",
    type: "video",
  },
  {
    lat: 56.34438113544952,
    lng: -4.470953555415879,
    thumbnail: "https://img.youtube.com/vi/zShiHRO_voE/mqdefault.jpg",
    id: "zShiHRO_voE",
    type: "video",
  },
  {
    lat: 56.345068340948714,
    lng: -4.469219468854527,
    thumbnail: "https://img.youtube.com/vi/6_ntKYGxivU/mqdefault.jpg",
    id: "6_ntKYGxivU",
    type: "video",
  },
  {
    lat: 56.35431117539381,
    lng: -4.326234049788764,
    thumbnail: "https://img.youtube.com/vi/b8iHA0SyfHc/mqdefault.jpg",
    id: "b8iHA0SyfHc",
    type: "video",
  },
  {
    lat: 56.40737874949032,
    lng: -4.3159217699702035,
    thumbnail: "https://img.youtube.com/vi/B85HtYnynbM/mqdefault.jpg",
    id: "B85HtYnynbM",
    type: "video",
  },
  {
    lat: 56.48017614917668,
    lng: -4.301892287030497,
    thumbnail: "https://img.youtube.com/vi/fqjbOz8eHcs/mqdefault.jpg",
    id: "fqjbOz8eHcs",
    type: "video",
  },
  {
    lat: 56.468420094774615,
    lng: -4.317328970810667,
    thumbnail: "https://img.youtube.com/vi/z1ruI_gnmNc/mqdefault.jpg",
    id: "z1ruI_gnmNc",
    type: "video",
  },
  {
    lat: 56.39874389640211,
    lng: -4.57003697698657,
    thumbnail: "https://img.youtube.com/vi/6oDjEebPnIc/mqdefault.jpg",
    id: "6oDjEebPnIc",
    type: "video",
  },
  {
    lat: 56.392689211672455,
    lng: -4.619478185855332,
    thumbnail: "https://img.youtube.com/vi/9rVPfQTdDtU/mqdefault.jpg",
    id: "9rVPfQTdDtU",
    type: "video",
  },
  {
    lat: 56.39037855966776,
    lng: -4.61842976023684,
    thumbnail: "https://img.youtube.com/vi/6tjvgUhZmhA/mqdefault.jpg",
    id: "6tjvgUhZmhA",
    type: "video",
  },
  {
    lat: 56.76036243284878,
    lng: -4.691011932648343,
    thumbnail: "https://img.youtube.com/vi/ZALfnQBR09o/mqdefault.jpg",
    id: "ZALfnQBR09o",
    type: "video",
  },
  {
    lat: 56.817845087647726,
    lng: -5.111083632801907,
    thumbnail: "https://img.youtube.com/vi/5wqb_lj4-Ls/mqdefault.jpg",
    id: "5wqb_lj4-Ls",
    type: "video",
  },
  {
    lat: 56.822959742837526,
    lng: -5.1009784109587795,
    thumbnail: "https://img.youtube.com/vi/1RP-Wedxd2A/mqdefault.jpg",
    id: "1RP-Wedxd2A",
    type: "video",
  },
  {
    lat: 56.81788737876884,
    lng: -5.111209643929203,
    thumbnail: "https://img.youtube.com/vi/9HIJrLyxDRU/mqdefault.jpg",
    id: "9HIJrLyxDRU",
    type: "video",
  },
  {
    lat: 56.82216021665935,
    lng: -5.082644350293376,
    thumbnail: "https://img.youtube.com/vi/urbtx3AymQU/mqdefault.jpg",
    id: "urbtx3AymQU",
    type: "video",
  },
  {
    lat: 56.81532519024189,
    lng: -5.076549274668819,
    thumbnail: "https://img.youtube.com/vi/_5DVI7f8Hn4/mqdefault.jpg",
    id: "_5DVI7f8Hn4",
    type: "video",
  },
  {
    lat: 56.81532519024189,
    lng: -5.076549274668819,
    thumbnail: "https://img.youtube.com/vi/HIyiaVlaumg/mqdefault.jpg",
    id: "HIyiaVlaumg",
    type: "video",
  },
  {
    lat: 56.80206311709868,
    lng: -5.069482301141077,
    thumbnail: "https://img.youtube.com/vi/MbgJPfVz8Ks/mqdefault.jpg",
    id: "MbgJPfVz8Ks",
    type: "video",
  },
  {
    lat: 56.70059038346042,
    lng: -5.1926690732226675,
    thumbnail: "https://img.youtube.com/vi/EPgF-qlD-4A/mqdefault.jpg",
    id: "EPgF-qlD-4A",
    type: "video",
  },
  {
    lat: 56.66407067863213,
    lng: -5.046564402619746,
    thumbnail: "https://img.youtube.com/vi/X7LTY4dOM_A/mqdefault.jpg",
    id: "X7LTY4dOM_A",
    type: "video",
  },
  {
    lat: 56.664382691874614,
    lng: -5.037665133971635,
    thumbnail: "https://img.youtube.com/vi/Nr5JapxrdgE/mqdefault.jpg",
    id: "Nr5JapxrdgE",
    type: "video",
  },
  {
    lat: 56.67799934106575,
    lng: -5.1555270584970385,
    thumbnail: "https://img.youtube.com/vi/REEeLrjdZNs/mqdefault.jpg",
    id: "REEeLrjdZNs",
    type: "video",
  },
  {
    lat: 56.68935420779035,
    lng: -5.179760115509937,
    thumbnail: "https://img.youtube.com/vi/h8nydQQ_tEQ/mqdefault.jpg",
    id: "h8nydQQ_tEQ",
    type: "video",
  },
  {
    lat: 56.62678207203604,
    lng: -5.307858796705745,
    thumbnail: "https://img.youtube.com/vi/4NsMkYMxu0U/mqdefault.jpg",
    id: "4NsMkYMxu0U",
    type: "video",
  },
  {
    lat: 56.5723656409921,
    lng: -5.381234495543106,
    thumbnail: "https://img.youtube.com/vi/k0eI5aDEqws/mqdefault.jpg",
    id: "k0eI5aDEqws",
    type: "video",
  },
  {
    lat: 56.554904895065256,
    lng: -5.325793937692663,
    thumbnail: "https://img.youtube.com/vi/EkCU081H-8c/mqdefault.jpg",
    id: "EkCU081H-8c",
    type: "video",
  },
  {
    lat: 56.46546507536035,
    lng: -5.397157025737057,
    thumbnail: "https://img.youtube.com/vi/Hgx7nloEHIE/mqdefault.jpg",
    id: "Hgx7nloEHIE",
    type: "video",
  },
  {
    lat: 56.50865861980454,
    lng: -5.38367033652473,
    thumbnail: "https://img.youtube.com/vi/y4vYeAXsjk0/mqdefault.jpg",
    id: "y4vYeAXsjk0",
    type: "video",
  },
  {
    lat: 56.46357458866127,
    lng: -5.395847312217777,
    thumbnail: "https://img.youtube.com/vi/TVIZAc74OaA/mqdefault.jpg",
    id: "TVIZAc74OaA",
    type: "video",
  },
  {
    lat: 56.457114485607484,
    lng: -5.391916350545525,
    thumbnail: "https://img.youtube.com/vi/RoT4Vyhaszo/mqdefault.jpg",
    id: "RoT4Vyhaszo",
    type: "video",
  },
  {
    lat: 56.453353095544806,
    lng: -5.381700991220036,
    thumbnail: "https://img.youtube.com/vi/ouqBxRQSMCc/mqdefault.jpg",
    id: "ouqBxRQSMCc",
    type: "video",
  },
  {
    lat: 56.41327669083659,
    lng: -5.472052636792653,
    thumbnail: "https://img.youtube.com/vi/lJL377jPEvs/mqdefault.jpg",
    id: "lJL377jPEvs",
    type: "video",
  },
  {
    lat: 56.40946460797445,
    lng: -5.4818338609444295,
    thumbnail: "https://img.youtube.com/vi/d02FIzb64Ms/mqdefault.jpg",
    id: "d02FIzb64Ms",
    type: "video",
  },
  {
    lat: 56.430821844516664,
    lng: -5.239556256209988,
    thumbnail: "https://img.youtube.com/vi/Fb_fFUsVbfk/mqdefault.jpg",
    id: "Fb_fFUsVbfk",
    type: "video",
  },
  {
    lat: 56.34412728350492,
    lng: -5.160355656605151,
    thumbnail: "https://img.youtube.com/vi/bMdjgvyXzRU/mqdefault.jpg",
    id: "bMdjgvyXzRU",
    type: "video",
  },
  {
    lat: 56.25246502812309,
    lng: -5.093455165895298,
    thumbnail: "https://img.youtube.com/vi/A8N0H3LVGRA/mqdefault.jpg",
    id: "A8N0H3LVGRA",
    type: "video",
  },
  {
    lat: 56.230431807975606,
    lng: -5.0728054649644045,
    thumbnail: "https://img.youtube.com/vi/dSUYhYsjkq8/mqdefault.jpg",
    id: "dSUYhYsjkq8",
    type: "video",
  },
  {
    lat: 56.22980766579357,
    lng: -5.072306423498039,
    thumbnail: "https://img.youtube.com/vi/BO-SaYx3Ok8/mqdefault.jpg",
    id: "BO-SaYx3Ok8",
    type: "video",
  },
  {
    lat: 56.23266890276806,
    lng: -4.974093060391876,
    thumbnail: "https://img.youtube.com/vi/YqAJExACKkc/mqdefault.jpg",
    id: "YqAJExACKkc",
    type: "video",
  },
  {
    lat: 56.23252158908067,
    lng: -4.973485683552213,
    thumbnail: "https://img.youtube.com/vi/EXH4Wz2Frgc/mqdefault.jpg",
    id: "EXH4Wz2Frgc",
    type: "video",
  },
  {
    lat: 56.226305901827516,
    lng: -4.961707827632675,
    thumbnail: "https://img.youtube.com/vi/Ht8TrPCqgwA/mqdefault.jpg",
    id: "Ht8TrPCqgwA",
    type: "video",
  },
  {
    lat: 56.22542642247144,
    lng: -4.85628815925846,
    thumbnail: "https://img.youtube.com/vi/tZhY6DykUJg/mqdefault.jpg",
    id: "tZhY6DykUJg",
    type: "video",
  },
  {
    lat: 56.22527154874381,
    lng: -4.856390307459896,
    thumbnail: "https://img.youtube.com/vi/hLS9xQMhu2M/mqdefault.jpg",
    id: "hLS9xQMhu2M",
    type: "video",
  },
  {
    lat: 56.19966194810073,
    lng: -4.746219122635192,
    thumbnail: "https://img.youtube.com/vi/1KMrPhXz0FQ/mqdefault.jpg",
    id: "1KMrPhXz0FQ",
    type: "video",
  },
  {
    lat: 56.19979884467452,
    lng: -4.746230730385355,
    thumbnail: "https://img.youtube.com/vi/hNAPopUeLA0/mqdefault.jpg",
    id: "1hNAPopUeLA0",
    type: "video",
  },


  // Wales YouTube videos
  {
    lat: 51.64427681712369,
    lng: -2.67495622262487,
    thumbnail: "https://img.youtube.com/vi/YvUeE_KXQuY/mqdefault.jpg",
    id: "YvUeE_KXQuY",
    type: "video",
  },
  {
    lat: 51.631318129894936,
    lng: -2.6733894783456806,
    thumbnail: "https://img.youtube.com/vi/VC5u3BuGa00/mqdefault.jpg",
    id: "VC5u3BuGa00",
    type: "video",
  },
  {
    lat: 51.5703355906902,
    lng: -2.984236701180703,
    thumbnail: "https://img.youtube.com/vi/VTKlTqi6bNk/mqdefault.jpg",
    id: "VTKlTqi6bNk",
    type: "video",
  },
  {
    lat: 51.49560445090976,
    lng: -3.2174156391990736,
    thumbnail: "https://img.youtube.com/vi/WyNJqVLyCKo/mqdefault.jpg",
    id: "WyNJqVLyCKo",
    type: "video",
  },
  {
    lat: 51.390496395330466,
    lng: -3.2771348005286867,
    thumbnail: "https://img.youtube.com/vi/LSPmQhAIOhY/mqdefault.jpg",
    id: "LSPmQhAIOhY",
    type: "video",
  },
  {
    lat: 51.41365881641385,
    lng: -3.4794072995307888,
    thumbnail: "https://img.youtube.com/vi/jtz5CEDQTA0/mqdefault.jpg",
    id: "jtz5CEDQTA0",
    type: "video",
  },
  {
    lat: 51.40793827566508,
    lng: -3.4879528210311395,
    thumbnail: "https://img.youtube.com/vi/PuF6NVRCpZE/mqdefault.jpg",
    id: "PuF6NVRCpZE",
    type: "video",
  },
  {
    lat: 51.43300732844216,
    lng: -3.5528312785715057,
    thumbnail: "https://img.youtube.com/vi/AxmtSLSeAnQ/mqdefault.jpg",
    id: "AxmtSLSeAnQ",
    type: "video",
  },
  {
    lat: 51.47626879558479,
    lng: -3.70552188273344,
    thumbnail: "https://img.youtube.com/vi/VtnCTpEaI5g/mqdefault.jpg",
    id: "VtnCTpEaI5g",
    type: "video",
  },
  {
    lat: 51.58653497744505,
    lng: -3.7680430985899567,
    thumbnail: "https://img.youtube.com/vi/7GGOwaJC3Xg/mqdefault.jpg",
    id: "7GGOwaJC3Xg",
    type: "video",
  },
  {
    lat: 51.5679630563947,
    lng: -4.006365421602268,
    thumbnail: "https://img.youtube.com/vi/09-da8mjSLw/mqdefault.jpg",
    id: "09-da8mjSLw",
    type: "video",
  },
  {
    lat: 51.73866039828176,
    lng: -4.302835863224165,
    thumbnail: "https://img.youtube.com/vi/itTL0_pj32I/mqdefault.jpg",
    id: "itTL0_pj32I",
    type: "video",
  },
  {
    lat: 51.73745981824038,
    lng: -4.304817619197641,
    thumbnail: "https://img.youtube.com/vi/a6C8hiAMExY/mqdefault.jpg",
    id: "a6C8hiAMExY",
    type: "video",
  },
  {
    lat: 51.76056589178444,
    lng: -4.3726731817547755,
    thumbnail: "https://img.youtube.com/vi/F5rsmnSthOs/mqdefault.jpg",
    id: "F5rsmnSthOs",
    type: "video",
  },
  {
    lat: 51.76056589178444,
    lng: -4.3726731817547755,
    thumbnail: "https://img.youtube.com/vi/C-wBPjB8GN4/mqdefault.jpg",
    id: "C-wBPjB8GN4",
    type: "video",
  },
  {
    lat: 51.77202467563431,
    lng: -4.456443784831147,
    thumbnail: "https://img.youtube.com/vi/qyT3CPeRfas/mqdefault.jpg",
    id: "qyT3CPeRfas",
    type: "video",
  },
  {
    lat: 51.73142241218287,
    lng: -4.66280412031024,
    thumbnail: "https://img.youtube.com/vi/HPj-Ae3O1Zg/mqdefault.jpg",
    id: "HPj-Ae3O1Zg",
    type: "video",
  },
  {
    lat: 51.67241104789888,
    lng: -4.86700956735689,
    thumbnail: "https://img.youtube.com/vi/JhTLTrD4bWA/mqdefault.jpg",
    id: "JhTLTrD4bWA",
    type: "video",
  },
  {
    lat: 51.66946600080004,
    lng: -4.870686689396746,
    thumbnail: "https://img.youtube.com/vi/WeyVTliS9gg/mqdefault.jpg",
    id: "WeyVTliS9gg",
    type: "video",
  },
  {
    lat: 51.677200792799425,
    lng: -4.918328179709838,
    thumbnail: "https://img.youtube.com/vi/WQabC8BWN9k/mqdefault.jpg",
    id: "WQabC8BWN9k",
    type: "video",
  },
  {
    lat: 51.706365752206445,
    lng: -4.933356828148994,
    thumbnail: "https://img.youtube.com/vi/Q_093Yy1pnA/mqdefault.jpg",
    id: "Q_093Yy1pnA",
    type: "video",
  },
  {
    lat: 51.7104604400071,
    lng: -5.030360455102757,
    thumbnail: "https://img.youtube.com/vi/RlINH9SqVDw/mqdefault.jpg",
    id: "RlINH9SqVDw",
    type: "video",
  },
  {
    lat: 51.7295341238491,
    lng: -5.083146169402778,
    thumbnail: "https://img.youtube.com/vi/ytGWIHKZe3g/mqdefault.jpg",
    id: "ytGWIHKZe3g",
    type: "video",
  },
  {
    lat: 51.768472163910644,
    lng: -5.115381419190907,
    thumbnail: "https://img.youtube.com/vi/_P0t-wZb710/mqdefault.jpg",
    id: "_P0t-wZb710",
    type: "video",
  },
  {
    lat: 51.85717252726874,
    lng: -5.127419443166246,
    thumbnail: "https://img.youtube.com/vi/jRaa9vkabY0/mqdefault.jpg",
    id: "jRaa9vkabY0",
    type: "video",
  },
  {
    lat: 51.881554594689085,
    lng: -5.267536558196394,
    thumbnail: "https://img.youtube.com/vi/zGjHbP_ISRs/mqdefault.jpg",
    id: "zGjHbP_ISRs",
    type: "video",
  },
  {
    lat: 51.8825122443072,
    lng: -5.269595803801503,
    thumbnail: "https://img.youtube.com/vi/h6dYQ8SOXBg/mqdefault.jpg",
    id: "h6dYQ8SOXBg",
    type: "video",
  },
  {
    lat: 51.8724975864861,
    lng: -5.2684098710571865,
    thumbnail: "https://img.youtube.com/vi/SHJfk86sF5Q/mqdefault.jpg",
    id: "SHJfk86sF5Q",
    type: "video",
  },
  {
    lat: 52.00335821854468,
    lng: -4.994335055859242,
    thumbnail: "https://img.youtube.com/vi/8uF4U19cxIc/mqdefault.jpg",
    id: "8uF4U19cxIc",
    type: "video",
  },
  {
    lat: 52.01864728073539,
    lng: -4.828273343621866,
    thumbnail: "https://img.youtube.com/vi/24X01ZcBAHc/mqdefault.jpg",
    id: "24X01ZcBAHc",
    type: "video",
  },
  {
    lat: 52.0879620481924,
    lng: -4.6564190837107775,
    thumbnail: "https://img.youtube.com/vi/idLHBLDNdIA/mqdefault.jpg",
    id: "idLHBLDNdIA",
    type: "video",
  },
  {
    lat: 52.3148530624096,
    lng: -4.059195890506473,
    thumbnail: "https://img.youtube.com/vi/fXaq2_TiBGw/mqdefault.jpg",
    id: "fXaq2_TiBGw",
    type: "video",
  },
  {
    lat: 52.49097528393881,
    lng: -4.051480044143746,
    thumbnail: "https://img.youtube.com/vi/NjXSm6s7f1U/mqdefault.jpg",
    id: "NjXSm6s7f1U",
    type: "video",
  },
  {
    lat: 52.552758562352984,
    lng: -3.931278844573727,
    thumbnail: "https://img.youtube.com/vi/6_DW6yHVMMw/mqdefault.jpg",
    id: "6_DW6yHVMMw",
    type: "video",
  },
  {
    lat: 52.58905469569541,
    lng: -3.8891901700252642,
    thumbnail: "https://img.youtube.com/vi/B1sAqJ4PLTo/mqdefault.jpg",
    id: "B1sAqJ4PLTo",
    type: "video",
  },
  {
    lat: 52.56855508544384,
    lng: -4.035072069713102,
    thumbnail: "https://img.youtube.com/vi/lLTUDYqvmiw/mqdefault.jpg",
    id: "lLTUDYqvmiw",
    type: "video",
  },
  {
    lat: 52.58372866756756,
    lng: -4.08863502006603,
    thumbnail: "https://img.youtube.com/vi/vtEbSiiSGy8/mqdefault.jpg",
    id: "vtEbSiiSGy8",
    type: "video",
  },
  {
    lat: 52.686437759006765,
    lng: -4.05834085770293,
    thumbnail: "https://img.youtube.com/vi/yIYbjvLU2pI/mqdefault.jpg",
    id: "yIYbjvLU2pI",
    type: "video",
  },
  {
    lat: 52.713834844778454,
    lng: -4.037512688958734,
    thumbnail: "https://img.youtube.com/vi/JnppgiS2MRw/mqdefault.jpg",
    id: "JnppgiS2MRw",
    type: "video",
  },
  {
    lat: 52.61043512944069,
    lng: -4.1200729857148675,
    thumbnail: "https://img.youtube.com/vi/xwDtgLkElpc/mqdefault.jpg",
    id: "xwDtgLkElpc",
    type: "video",
  },
  {
    lat: 52.72508576520971,
    lng: -4.063999535447418,
    thumbnail: "https://img.youtube.com/vi/Wk8fHZwKP50/mqdefault.jpg",
    id: "Wk8fHZwKP50",
    type: "video",
  },
  {
    lat: 52.72551571486252,
    lng: -4.063992707856637,
    thumbnail: "https://img.youtube.com/vi/X4yqq54WTpc/mqdefault.jpg",
    id: "X4yqq54WTpc",
    type: "video",
  },
  {
    lat: 52.85933791427473,
    lng: -4.107750674366784,
    thumbnail: "https://img.youtube.com/vi/oYUkCA61fLQ/mqdefault.jpg",
    id: "oYUkCA61fLQ",
    type: "video",
  },
  {
    lat: 52.85755555443676,
    lng: -4.110494360381371,
    thumbnail: "https://img.youtube.com/vi/inmtH0Nadjk/mqdefault.jpg",
    id: "inmtH0Nadjk",
    type: "video",
  },
  {
    lat: 52.901594517878586,
    lng: -4.087100084863556,
    thumbnail: "https://img.youtube.com/vi/yv67-OiP3HA/mqdefault.jpg",
    id: "yv67-OiP3HA",
    type: "video",
  },
  {
    lat: 52.924087849372974,
    lng: -4.126019901960141,
    thumbnail: "https://img.youtube.com/vi/rIlpGk3ZJSU/mqdefault.jpg",
    id: "rIlpGk3ZJSU",
    type: "video",
  },
  {
    lat: 52.80386342706265,
    lng: -4.709980786525585,
    thumbnail: "https://img.youtube.com/vi/qTEcUM3joRU/mqdefault.jpg",
    id: "qTEcUM3joRU",
    type: "video",
  },
  {
    lat: 52.834610597666945,
    lng: -4.72440684093901,
    thumbnail: "https://img.youtube.com/vi/M94h2Npo0Ss/mqdefault.jpg",
    id: "M94h2Npo0Ss",
    type: "video",
  },
  {
    lat: 52.826837615347316,
    lng: -4.667321050803997,
    thumbnail: "https://img.youtube.com/vi/pEs4rzRkLbQ/mqdefault.jpg",
    id: "pEs4rzRkLbQ",
    type: "video",
  },
  {
    lat: 53.10475771456117,
    lng: -4.276086812236574,
    thumbnail: "https://img.youtube.com/vi/zLQRnxYzsJk/mqdefault.jpg",
    id: "zLQRnxYzsJk",
    type: "video",
  },
  {
    lat: 53.21995482983526,
    lng: -4.159558698315444,
    thumbnail: "https://img.youtube.com/vi/4nlFd8j-Xgs/mqdefault.jpg",
    id: "4nlFd8j-Xgs",
    type: "video",
  },
  {
    lat: 53.222635355415726,
    lng: -4.183426331398115,
    thumbnail: "https://img.youtube.com/vi/6UMulCETNss/mqdefault.jpg",
    id: "6UMulCETNss",
    type: "video",
  },
  {
    lat: 53.240370957547576,
    lng: -4.139007170920059,
    thumbnail: "https://img.youtube.com/vi/AAe4QqQck5U/mqdefault.jpg",
    id: "AAe4QqQck5U",
    type: "video",
  },
  {
    lat: 53.22086303355368,
    lng: -4.209563116882072,
    thumbnail: "https://img.youtube.com/vi/eXouRZTHqO4/mqdefault.jpg",
    id: "eXouRZTHqO4",
    type: "video",
  },
  {
    lat: 53.3088666159473,
    lng: -4.629742879209658,
    thumbnail: "https://img.youtube.com/vi/d7xy4sDaq7o/mqdefault.jpg",
    id: "d7xy4sDaq7o",
    type: "video",
  },
  {
    lat: 53.311262683468904,
    lng: -4.632490969927038,
    thumbnail: "https://img.youtube.com/vi/EGIIVSbNrNE/mqdefault.jpg",
    id: "EGIIVSbNrNE",
    type: "video",
  },
  {
    lat: 53.30445916540168,
    lng: -4.685869995618524,
    thumbnail: "https://img.youtube.com/vi/bC0yuBy8AfQ/mqdefault.jpg",
    id: "bC0yuBy8AfQ",
    type: "video",
  },
  {
    lat: 53.30671032121749,
    lng: -4.69610582278639,
    thumbnail: "https://img.youtube.com/vi/oDFR9xjCl8U/mqdefault.jpg",
    id: "oDFR9xjCl8U",
    type: "video",
  },
  {
    lat: 53.273792747795625,
    lng: -4.58153751737419,
    thumbnail: "https://img.youtube.com/vi/j8mcR2Fi9qY/mqdefault.jpg",
    id: "j8mcR2Fi9qY",
    type: "video",
  },
  {
    lat: 53.28016210384228,
    lng: -4.622645607322987,
    thumbnail: "https://img.youtube.com/vi/OAn9tXYBn-U/mqdefault.jpg",
    id: "OAn9tXYBn-U",
    type: "video",
  },
  {
    lat: 53.297779583592124,
    lng: -4.531208042816958,
    thumbnail: "https://img.youtube.com/vi/ngJuMvLOerE/mqdefault.jpg",
    id: "ngJuMvLOerE",
    type: "video",
  },
  {
    lat: 53.38803980358787,
    lng: -4.516556088061493,
    thumbnail: "https://img.youtube.com/vi/W5DJ92k0jmA/mqdefault.jpg",
    id: "W5DJ92k0jmA",
    type: "video",
  },
  {
    lat: 53.41409047017542,
    lng: -4.448662966565954,
    thumbnail: "https://img.youtube.com/vi/Coa18nbT6Xg/mqdefault.jpg",
    id: "Coa18nbT6Xg",
    type: "video",
  },
  {
    lat: 53.36972345104897,
    lng: -4.513294129682439,
    thumbnail: "https://img.youtube.com/vi/jxliDtEEgVQ/mqdefault.jpg",
    id: "jxliDtEEgVQ",
    type: "video",
  },
  {
    lat: 53.315797169257195,
    lng: -4.5114951911613534,
    thumbnail: "https://img.youtube.com/vi/NqrdSW7nVbI/mqdefault.jpg",
    id: "NqrdSW7nVbI",
    type: "video",
  },
  {
    lat: 53.264178408927656,
    lng: -4.090474335378239,
    thumbnail: "https://img.youtube.com/vi/k5Z9zYIPntk/mqdefault.jpg",
    id: "k5Z9zYIPntk",
    type: "video",
  },
  {
    lat: 53.21111790567367,
    lng: -3.9958126842874444,
    thumbnail: "https://img.youtube.com/vi/zUnlSG7XW6o/mqdefault.jpg",
    id: "zUnlSG7XW6o",
    type: "video",
  },
  {
    lat: 53.259574754403594,
    lng: -3.982592357603134,
    thumbnail: "https://img.youtube.com/vi/aW17nbm39Jk/mqdefault.jpg",
    id: "aW17nbm39Jk",
    type: "video",
  },
  {
    lat: 53.266530184952984,
    lng: -3.9532570671246536,
    thumbnail: "https://img.youtube.com/vi/tK8koHrAF70/mqdefault.jpg",
    id: "tK8koHrAF70",
    type: "video",
  },
  {
    lat: 53.336641812781124,
    lng: -3.831858320399948,
    thumbnail: "https://img.youtube.com/vi/kN_Y1AGKY5Y/mqdefault.jpg",
    id: "kN_Y1AGKY5Y",
    type: "video",
  },
  {
    lat: 53.27858082326365,
    lng: -3.8225754508030567,
    thumbnail: "https://img.youtube.com/vi/S_egDWM_9uE/mqdefault.jpg",
    id: "S_egDWM_9uE",
    type: "video",
  },
  {
    lat: 53.31445977675444,
    lng: -3.7404695774356242,
    thumbnail: "https://img.youtube.com/vi/UpI-r9QAvxg/mqdefault.jpg",
    id: "UpI-r9QAvxg",
    type: "video",
  },
  {
    lat: 53.29326627019429,
    lng: -3.68985201000779,
    thumbnail: "https://img.youtube.com/vi/waOcDZUAz8o/mqdefault.jpg",
    id: "waOcDZUAz8o",
    type: "video",
  },
  {
    lat: 53.33444624779769,
    lng: -3.442634462206083,
    thumbnail: "https://img.youtube.com/vi/WBHy_rMnAUs/mqdefault.jpg",
    id: "WBHy_rMnAUs",
    type: "video",
  },
  {
    lat: 53.27732989254989,
    lng: -3.2236519980425493,
    thumbnail: "https://img.youtube.com/vi/nzohvJubz8c/mqdefault.jpg",
    id: "nzohvJubz8c",
    type: "video",
  },
  {
    lat: 53.25140963908814,
    lng: -3.12997097572858,
    thumbnail: "https://img.youtube.com/vi/dGNg1zvP350/mqdefault.jpg",
    id: "dGNg1zvP350",
    type: "video",
  },
  {
    lat: 53.252019051137026,
    lng: -3.0420468503091422,
    thumbnail: "https://img.youtube.com/vi/WNzmeW4pVhg/mqdefault.jpg",
    id: "WNzmeW4pVhg",
    type: "video",
  },


  //Eastern England Videos
  {
    lat: 55.77103899775733,
    lng: -2.0063978074310884,
    thumbnail: "https://img.youtube.com/vi/ixJDRNQNsrM/mqdefault.jpg",
    id: "ixJDRNQNsrM",
    type: "video",
  },
  {
    lat: 55.774732395399084,
    lng: -2.015129762238881,
    thumbnail: "https://img.youtube.com/vi/BONgAqG1XNE/mqdefault.jpg",
    id: "BONgAqG1XNE",
    type: "video",
  },
  {
    lat: 55.68889179188211,
    lng: -1.8829161100585636,
    thumbnail: "https://img.youtube.com/vi/5o0OSdY6qkk/mqdefault.jpg",
    id: "5o0OSdY6qkk",
    type: "video",
  },
  {
    lat: 55.67921194184705,
    lng: -1.8654034202008574,
    thumbnail: "https://img.youtube.com/vi/7nlCxljzDx4/mqdefault.jpg",
    id: "7nlCxljzDx4",
    type: "video",
  },
  {
    lat: 55.60786795675302,
    lng: -1.7184215553138542,
    thumbnail: "https://img.youtube.com/vi/axmSRAq7_zc/mqdefault.jpg",
    id: "axmSRAq7_zc",
    type: "video",
  },
  {
    lat: 55.10081786247863,
    lng: -1.4952604404592726,
    thumbnail: "https://img.youtube.com/vi/F9tTyFab1j8/mqdefault.jpg",
    id: "F9tTyFab1j8",
    type: "video",
  },
  {
    lat: 55.07008042138743,
    lng: -1.451436072713646,
    thumbnail: "https://img.youtube.com/vi/WCY2oNqkqg8/mqdefault.jpg",
    id: "WCY2oNqkqg8",
    type: "video",
  },
  {
    lat: 55.04836859718161,
    lng: -1.447264211887972,
    thumbnail: "https://img.youtube.com/vi/WweglbDpDBc/mqdefault.jpg",
    id: "WweglbDpDBc",
    type: "video",
  },
  {
    lat: 54.98890299367344,
    lng: -1.4874992278355872,
    thumbnail: "https://img.youtube.com/vi/9SHdTNnRqkQ/mqdefault.jpg",
    id: "9SHdTNnRqkQ",
    type: "video",
  },
  {
    lat: 54.976970543649124,
    lng: -1.3775754784467165,
    thumbnail: "https://img.youtube.com/vi/SajibGcNURE/mqdefault.jpg",
    id: "SajibGcNURE",
    type: "video",
  },
  {
    lat: 54.58518420111332,
    lng: -1.2250022163024716,
    thumbnail: "https://img.youtube.com/vi/Q5jXkbtDca4/mqdefault.jpg",
    id: "Q5jXkbtDca4",
    type: "video",
  },
  {
    lat: 54.57540083671584,
    lng: -1.270596074375005,
    thumbnail: "https://img.youtube.com/vi/GNCCEhEFBt0/mqdefault.jpg",
    id: "GNCCEhEFBt0",
    type: "video",
  },
  {
    lat: 54.57293839020269,
    lng: -1.1579247870156286,
    thumbnail: "https://img.youtube.com/vi/7rNFBb5LBnQ/mqdefault.jpg",
    id: "7rNFBb5LBnQ",
    type: "video",
  },
  {
    lat: 54.577998014845065,
    lng: -1.2181661829124353,
    thumbnail: "https://img.youtube.com/vi/dkgnJA7qTjo/mqdefault.jpg",
    id: "dkgnJA7qTjo",
    type: "video",
  },
  {
    lat: 54.61944566895501,
    lng: -1.0670609157276367,
    thumbnail: "https://img.youtube.com/vi/T5F2BRhLX_k/mqdefault.jpg",
    id: "T5F2BRhLX_k",
    type: "video",
  },
  {
    lat: 54.624099549556,
    lng: -1.118071201508692,
    thumbnail: "https://img.youtube.com/vi/-fFZf3ZFCbc/mqdefault.jpg",
    id: "-fFZf3ZFCbc",
    type: "video",
  },
  {
    lat: 54.58378054069068,
    lng: -0.9944192534940804,
    thumbnail: "https://img.youtube.com/vi/zy3NQ5wTaII/mqdefault.jpg",
    id: "zy3NQ5wTaII",
    type: "video",
  },
  {
    lat: 54.590093861636745,
    lng: -1.004818024767892,
    thumbnail: "https://img.youtube.com/vi/cObYpkhWvb0/mqdefault.jpg",
    id: "cObYpkhWvb0",
    type: "video",
  },
  {
    lat: 54.55915171576194,
    lng: -0.7918208271504316,
    thumbnail: "https://img.youtube.com/vi/IOBWX8NpJC8/mqdefault.jpg",
    id: "IOBWX8NpJC8",
    type: "video",
  },
  {
    lat: 54.551757739234766,
    lng: -0.7915104851480159,
    thumbnail: "https://img.youtube.com/vi/PJs3H1xzMII/mqdefault.jpg",
    id: "PJs3H1xzMII",
    type: "video",
  },
  {
    lat: 54.489684807413745,
    lng: -0.6158700236170361,
    thumbnail: "https://img.youtube.com/vi/TmQtZ1-yMAI/mqdefault.jpg",
    id: "TmQtZ1-yMAI",
    type: "video",
  },
  {
    lat: 54.474804244252816,
    lng: -0.6184308717911746,
    thumbnail: "https://img.youtube.com/vi/beSGZuZjRMQ/mqdefault.jpg",
    id: "beSGZuZjRMQ",
    type: "video",
  },
  {
    lat: 54.429931046775046,
    lng: -0.5323994599366126,
    thumbnail: "https://img.youtube.com/vi/n0SJm9d7ilA/mqdefault.jpg",
    id: "n0SJm9d7ilA",
    type: "video",
  },
  {
    lat: 54.397397914210586,
    lng: -0.48493946848954644,
    thumbnail: "https://img.youtube.com/vi/wXvVhlaFHXY/mqdefault.jpg",
    id: "wXvVhlaFHXY",
    type: "video",
  },
  {
    lat: 54.4016531067944,
    lng: -0.4920576466588856,
    thumbnail: "https://img.youtube.com/vi/ps1uqSLxCw0/mqdefault.jpg",
    id: "ps1uqSLxCw0",
    type: "video",
  },
  {
    lat: 54.319106770951166,
    lng: -0.4384849661040603,
    thumbnail: "https://img.youtube.com/vi/6FALBV3AAvs/mqdefault.jpg",
    id: "6FALBV3AAvs",
    type: "video",
  },
  {
    lat: 54.38921628851988,
    lng: -0.4764561337024701,
    thumbnail: "https://img.youtube.com/vi/Boge6F3cnMw/mqdefault.jpg",
    id: "Boge6F3cnMw",
    type: "video",
  },
  {
    lat: 54.182015909147985,
    lng: -0.32336003848170186,
    thumbnail: "https://img.youtube.com/vi/d1wnR6QNTGU/mqdefault.jpg",
    id: "d1wnR6QNTGU",
    type: "video",
  },
  {
    lat: 54.152420128211915,
    lng: -0.2423474255739703,
    thumbnail: "https://img.youtube.com/vi/jT-goWOjYng/mqdefault.jpg",
    id: "jT-goWOjYng",
    type: "video",
  },
  {
    lat: 54.15524964826354,
    lng: -0.23870839993264859,
    thumbnail: "https://img.youtube.com/vi/kRyHmQsjJ14/mqdefault.jpg",
    id: "kRyHmQsjJ14",
    type: "video",
  },
  {
    lat: 54.143700964258805,
    lng: -0.21005927080416853,
    thumbnail: "https://img.youtube.com/vi/IxN3zV5p5Bw/mqdefault.jpg",
    id: "IxN3zV5p5Bw",
    type: "video",
  },
  {
    lat: 54.137659454395184,
    lng: -0.19164266374776892,
    thumbnail: "https://img.youtube.com/vi/tw6NKQ651N4/mqdefault.jpg",
    id: "tw6NKQ651N4",
    type: "video",
  },
  {
    lat: 54.15081961763766,
    lng: -0.17088437455521363,
    thumbnail: "https://img.youtube.com/vi/kUR2lN4oCDU/mqdefault.jpg",
    id: "kUR2lN4oCDU",
    type: "video",
  },
  {
    lat: 54.08943629705384,
    lng: -0.1803861953036931,
    thumbnail: "https://img.youtube.com/vi/AhI61DcRLGE/mqdefault.jpg",
    id: "AhI61DcRLGE",
    type: "video",
  },
  {
    lat: 53.99243795637243,
    lng: -0.23077842980139987,
    thumbnail: "https://img.youtube.com/vi/SrnE8gPzzMs/mqdefault.jpg",
    id: "SrnE8gPzzMs",
    type: "video",
  },
  {
    lat: 53.91187926674659,
    lng: -0.16013994665600492,
    thumbnail: "https://img.youtube.com/vi/MIF9gKuCvHY/mqdefault.jpg",
    id: "MIF9gKuCvHY",
    type: "video",
  },
  {
    lat: 53.91011370206767,
    lng: -0.16200598840675695,
    thumbnail: "https://img.youtube.com/vi/PHFRhrXV2Jw/mqdefault.jpg",
    id: "PHFRhrXV2Jw",
    type: "video",
  },
  {
    lat: 53.87604797709147,
    lng: -0.13419023961574575,
    thumbnail: "https://img.youtube.com/vi/N3nLDUNrorc/mqdefault.jpg",
    id: "N3nLDUNrorc",
    type: "video",
  },
  {
    lat: 53.76578550308359,
    lng: -0.00916873204472776,
    thumbnail: "https://img.youtube.com/vi/NjSHZZC-QI4/mqdefault.jpg",
    id: "NjSHZZC-QI4",
    type: "video",
  },
  {
    lat: 53.61975113523053,
    lng: 0.13008818107587172,
    thumbnail: "https://img.youtube.com/vi/IDcWGu1ZfAc/mqdefault.jpg",
    id: "IDcWGu1ZfAc",
    type: "video",
  },
  {
    lat: 53.61095945141432,
    lng: 0.1448061986309118,
    thumbnail: "https://img.youtube.com/vi/nuyNiGlEX8E/mqdefault.jpg",
    id: "nuyNiGlEX8E",
    type: "video",
  },
  {
    lat: 53.70690761931573,
    lng: -0.07891922950883844,
    thumbnail: "https://img.youtube.com/vi/4sAtzE9b7vA/mqdefault.jpg",
    id: "4sAtzE9b7vA",
    type: "video",
  },
  {
    lat: 53.715135996000285,
    lng: -0.11174450943891023,
    thumbnail: "https://img.youtube.com/vi/N_PeYMTgx6M/mqdefault.jpg",
    id: "N_PeYMTgx6M",
    type: "video",
  },
  {
    lat: 53.74586295761915,
    lng: -0.3334155212982924,
    thumbnail: "https://img.youtube.com/vi/Pz42X4YrlGw/mqdefault.jpg",
    id: "Pz42X4YrlGw",
    type: "video",
  },
  {
    lat: 53.74313310958531,
    lng: -0.33439110155957774,
    thumbnail: "https://img.youtube.com/vi/_n1B1zeMo6c/mqdefault.jpg",
    id: "_n1B1zeMo6c",
    type: "video",
  },
  {
    lat: 53.74190270470619,
    lng: -0.3349458492820496,
    thumbnail: "https://img.youtube.com/vi/MqSJOrWEvKY/mqdefault.jpg",
    id: "MqSJOrWEvKY",
    type: "video",
  },
  {
    lat: 53.71019336510978,
    lng: -0.4503191635833512,
    thumbnail: "https://img.youtube.com/vi/vYgHALoAGp4/mqdefault.jpg",
    id: "vYgHALoAGp4",
    type: "video",
  },
  {
    lat: 53.69238782128097,
    lng: -0.45040673665516356,
    thumbnail: "https://img.youtube.com/vi/8wsR9lIsjo8/mqdefault.jpg",
    id: "8wsR9lIsjo8",
    type: "video",
  },
  {
    lat: 53.69734353302735,
    lng: -0.44449323357083764,
    thumbnail: "https://img.youtube.com/vi/MLUTJ7EvctY/mqdefault.jpg",
    id: "MLUTJ7EvctY",
    type: "video",
  },
  {
    lat: 53.68437972116722,
    lng: -0.43679945909073026,
    thumbnail: "https://img.youtube.com/vi/v00kEpc9hUo/mqdefault.jpg",
    id: "v00kEpc9hUo",
    type: "video",
  },
  {
    lat: 53.62508421750813,
    lng: -0.19123785452587153,
    thumbnail: "https://img.youtube.com/vi/BvWWAizCkHY/mqdefault.jpg",
    id: "BvWWAizCkHY",
    type: "video",
  },
  {
    lat: 53.545196624431014,
    lng: -0.008992413367659513,
    thumbnail: "https://img.youtube.com/vi/cj4S8gQxrDM/mqdefault.jpg",
    id: "cj4S8gQxrDM",
    type: "video",
  },
  {
    lat: 53.54341097337978,
    lng: -0.009797190531860477,
    thumbnail: "https://img.youtube.com/vi/E0v-wUlJCqM/mqdefault.jpg",
    id: "E0v-wUlJCqM",
    type: "video",
  },
  {
    lat: 53.54165924949792,
    lng: -0.0017010997064324817,
    thumbnail: "https://img.youtube.com/vi/FnRXh0G8qLc/mqdefault.jpg",
    id: "FnRXh0G8qLc",
    type: "video",
  },
  {
    lat: 53.53935949916695,
    lng: 0.0015317329423839088,
    thumbnail: "https://img.youtube.com/vi/_34m1VP3-i8/mqdefault.jpg",
    id: "_34m1VP3-i8",
    type: "video",
  },
  {
    lat: 53.33028427720004,
    lng: 0.27471792734185757,
    thumbnail: "https://img.youtube.com/vi/gbJGlRBWwpo/mqdefault.jpg",
    id: "gbJGlRBWwpo",
    type: "video",
  },
  {
    lat: 53.33085854881003,
    lng: 0.274410517335974,
    thumbnail: "https://img.youtube.com/vi/CJbgI_-mglY/mqdefault.jpg",
    id: "CJbgI_-mglY",
    type: "video",
  },
  {
    lat: 53.22398267703034,
    lng: 0.33801953862496203,
    thumbnail: "https://img.youtube.com/vi/otnNKJVKihQ/mqdefault.jpg",
    id: "otnNKJVKihQ",
    type: "video",
  },
  {
    lat: 53.18651858695592,
    lng: 0.28114869800417125,
    thumbnail: "https://img.youtube.com/vi/3XwLXywFUoA/mqdefault.jpg",
    id: "3XwLXywFUoA",
    type: "video",
  },
  {
    lat: 53.14327067248354,
    lng: 0.33494156368677525,
    thumbnail: "https://img.youtube.com/vi/PdaBy3XOLTI/mqdefault.jpg",
    id: "PdaBy3XOLTI",
    type: "video",
  },
  {
    lat: 53.10244271711586,
    lng: 0.21614896707947145,
    thumbnail: "https://img.youtube.com/vi/09ItgW9DAso/mqdefault.jpg",
    id: "09ItgW9DAso",
    type: "video",
  },
  {
    lat: 53.22031778514649,
    lng: -0.652918715034678,
    thumbnail: "https://img.youtube.com/vi/sLMpDcYUrK4/mqdefault.jpg",
    id: "sLMpDcYUrK4",
    type: "video",
  },
  {
    lat: 53.220089315965076,
    lng:  -0.6533365772969181,
    thumbnail: "https://img.youtube.com/vi/WgSfFStSLkM/mqdefault.jpg",
    id: "WgSfFStSLkM",
    type: "video",
  },
  {
    lat: 52.76548056798311,
    lng:  0.19332036717421752,
    thumbnail: "https://img.youtube.com/vi/2tJuFQhWIp8/mqdefault.jpg",
    id: "2tJuFQhWIp8",
    type: "video",
  },
  {
    lat: 52.751701466902794,
    lng:  0.3950337590612632,
    thumbnail: "https://img.youtube.com/vi/Ui2zFLFmJ0o/mqdefault.jpg",
    id: "Ui2zFLFmJ0o",
    type: "video",
  },
  {
    lat: 52.880801238177426,
    lng:  0.8524790992635145,
    thumbnail: "https://img.youtube.com/vi/utLPfN5-69A/mqdefault.jpg",
    id: "utLPfN5-69A",
    type: "video",
  },
  {
    lat: 52.90130819910698,
    lng:  0.8856515465698003,
    thumbnail: "https://img.youtube.com/vi/P8d3r5SpRtI/mqdefault.jpg",
    id: "P8d3r5SpRtI",
    type: "video",
  },
  {
    lat: 52.9322159701569,
    lng: 1.3006569477960936,
    thumbnail: "https://img.youtube.com/vi/weZ8A2qLgd0/mqdefault.jpg",
    id: "weZ8A2qLgd0",
    type: "video",
  },
  {
    lat: 52.932301065349,
    lng: 1.3019406660980806,
    thumbnail: "https://img.youtube.com/vi/xkSSpe-yWN0/mqdefault.jpg",
    id: "xkSSpe-yWN0",
    type: "video",
  },
  {
    lat: 52.84675499163808,
    lng: 1.4841029205053344,
    thumbnail: "https://img.youtube.com/vi/toxPZcblb8c/mqdefault.jpg",
    id: "toxPZcblb8c",
    type: "video",
  },
  {
    lat: 52.822767026946366,
    lng: 1.5374967754749929,
    thumbnail: "https://img.youtube.com/vi/Np3LW8K4_fo/mqdefault.jpg",
    id: "Np3LW8K4_fo",
    type: "video",
  },
  {
    lat: 52.759617504118076,
    lng: 1.651865078650303,
    thumbnail: "https://img.youtube.com/vi/OBtgNr7qebI/mqdefault.jpg",
    id: "OBtgNr7qebI",
    type: "video",
  },
  {
    lat: 52.714766930858175,
    lng: 1.692803894226155,
    thumbnail: "https://img.youtube.com/vi/tAFDiP_qSu0/mqdefault.jpg",
    id: "tAFDiP_qSu0",
    type: "video",
  },
  {
    lat: 52.609019141908355,
    lng: 1.7371908657774346,
    thumbnail: "https://img.youtube.com/vi/YA6Gtjs1hfM/mqdefault.jpg",
    id: "YA6Gtjs1hfM",
    type: "video",
  },
  {
    lat: 52.57088202927873,
    lng: 1.7342309140693584,
    thumbnail: "https://img.youtube.com/vi/1BzKRsX3RR0/mqdefault.jpg",
    id: "1BzKRsX3RR0",
    type: "video",
  },
  {
    lat: 52.4812123367611,
    lng: 1.7627984738591427,
    thumbnail: "https://img.youtube.com/vi/32sYxz1C-Lo/mqdefault.jpg",
    id: "32sYxz1C-Lo",
    type: "video",
  },
  {
    lat: 52.47963477369755,
    lng: 1.7555672598714307,
    thumbnail: "https://img.youtube.com/vi/OU_usHrjJSU/mqdefault.jpg",
    id: "OU_usHrjJSU",
    type: "video",
  },
  {
    lat: 52.314079808711035,
    lng: 1.6518172767331192,
    thumbnail: "https://img.youtube.com/vi/K3D3n3uE5nY/mqdefault.jpg",
    id: "K3D3n3uE5nY",
    type: "video",
  },
  {
    lat: 52.27618184697573,
    lng: 1.6300976231967745,
    thumbnail: "https://img.youtube.com/vi/_Dt6zRUAk3M/mqdefault.jpg",
    id: "_Dt6zRUAk3M",
    type: "video",
  },
  {
    lat: 52.278510201272155,
    lng: 1.6331805570712177,
    thumbnail: "https://img.youtube.com/vi/Qf2aRhZGYKU/mqdefault.jpg",
    id: "Qf2aRhZGYKU",
    type: "video",
  },
  {
    lat: 52.18160142347458,
    lng: 1.6091977639070387,
    thumbnail: "https://img.youtube.com/vi/_3do4z90hXA/mqdefault.jpg",
    id: "_3do4z90hXA",
    type: "video",
  },
  {
    lat: 52.181579574938205,
    lng: 1.609282861453508,
    thumbnail: "https://img.youtube.com/vi/oJdYN5Dgwxo/mqdefault.jpg",
    id: "oJdYN5Dgwxo",
    type: "video",
  },
  {
    lat: 52.1799098198038,
    lng: 1.613137307874879,
    thumbnail: "https://img.youtube.com/vi/RnazRrR8udg/mqdefault.jpg",
    id: "RnazRrR8udg",
    type: "video",
  },
  {
    lat: 52.16062159125659,
    lng: 1.605159621454547,
    thumbnail: "https://img.youtube.com/vi/ZOkx7HsjEus/mqdefault.jpg",
    id: "ZOkx7HsjEus",
    type: "video",
  },
  {
    lat: 52.14318224550595,
    lng: 1.5992408682720818,
    thumbnail: "https://img.youtube.com/vi/-I7KDb_kfeg/mqdefault.jpg",
    id: "-I7KDb_kfeg",
    type: "video",
  },
  {
    lat: 52.15511499792273,
    lng: 1.525196799497554,
    thumbnail: "https://img.youtube.com/vi/eBoWjJhl6nQ/mqdefault.jpg",
    id: "eBoWjJhl6nQ",
    type: "video",
  },
  {
    lat: 52.0909654593974,
    lng: 1.5391988168303066,
    thumbnail: "https://img.youtube.com/vi/A3fedWsSO_I/mqdefault.jpg",
    id: "A3fedWsSO_I",
    type: "video",
  },
  {
    lat: 51.94207215870347,
    lng: 1.3266664713864351,
    thumbnail: "https://img.youtube.com/vi/VZEqZ9R02yk/mqdefault.jpg",
    id: "VZEqZ9R02yk",
    type: "video",
  },
  {
    lat: 51.93998042123073,
    lng: 1.3196305356768214,
    thumbnail: "https://img.youtube.com/vi/02gQKcMYsnI/mqdefault.jpg",
    id: "02gQKcMYsnI",
    type: "video",
  },
  {
    lat: 51.93885054029345,
    lng: 1.3206492378464418,
    thumbnail: "https://img.youtube.com/vi/GOnLCevsrEI/mqdefault.jpg",
    id: "GOnLCevsrEI",
    type: "video",
  },
  {
    lat: 51.94837432064404,
    lng: 1.2868744113708,
    thumbnail: "https://img.youtube.com/vi/CUyDu4pYfU0/mqdefault.jpg",
    id: "CUyDu4pYfU0",
    type: "video",
  },
  {
    lat: 51.90270648348751,
    lng: 1.186583595054674,
    thumbnail: "https://img.youtube.com/vi/Es4VRxiZeMM/mqdefault.jpg",
    id: "Es4VRxiZeMM",
    type: "video",
  },
  {
    lat: 51.86439049511185,
    lng: 1.2879945777236956,
    thumbnail: "https://img.youtube.com/vi/77_A599WBJU/mqdefault.jpg",
    id: "77_A599WBJU",
    type: "video",
  },
  {
    lat: 51.780378967945076,
    lng: 1.1401096890840794,
    thumbnail: "https://img.youtube.com/vi/C0RUVJRahRY/mqdefault.jpg",
    id: "C0RUVJRahRY",
    type: "video",
  },
  {
    lat: 51.77729051305472,
    lng: 1.1321499749973787,
    thumbnail: "https://img.youtube.com/vi/Ts4B6lNJtmQ/mqdefault.jpg",
    id: "Ts4B6lNJtmQ",
    type: "video",
  },
  {
    lat: 51.77309926908994,
    lng: 1.1092398211786738,
    thumbnail: "https://img.youtube.com/vi/tE540o200I0/mqdefault.jpg",
    id: "tE540o200I0",
    type: "video",
  },
  {
    lat: 51.804048862281185,
    lng: 1.018896694373963,
    thumbnail: "https://img.youtube.com/vi/WXv5VAhvDcg/mqdefault.jpg",
    id: "WXv5VAhvDcg",
    type: "video",
  },
  {
    lat: 51.79926178601123,
    lng: 0.917859717416009,
    thumbnail: "https://img.youtube.com/vi/5UCgex9IXdk/mqdefault.jpg",
    id: "5UCgex9IXdk",
    type: "video",
  },
  {
    lat: 51.773295422033335,
    lng: 0.7957970393033591,
    thumbnail: "https://img.youtube.com/vi/zXWa1lxatz0/mqdefault.jpg",
    id: "zXWa1lxatz0",
    type: "video",
  },
  {
    lat: 51.72094168499165,
    lng: 0.6929593984764403,
    thumbnail: "https://img.youtube.com/vi/3ytcjsjPz3E/mqdefault.jpg",
    id: "3ytcjsjPz3E",
    type: "video",
  },
  {
    lat: 51.72911100227289,
    lng: 0.6883569319526588,
    thumbnail: "https://img.youtube.com/vi/oXH41SGapk0/mqdefault.jpg",
    id: "oXH41SGapk0",
    type: "video",
  },
  {
    lat: 51.71887874936864,
    lng: 0.70633636210696,
    thumbnail: "https://img.youtube.com/vi/QGbnIO-MzZo/mqdefault.jpg",
    id: "QGbnIO-MzZo",
    type: "video",
  },
  {
    lat: 51.691152788435225,
    lng: 0.7185494880016844,
    thumbnail: "https://img.youtube.com/vi/BMC0jfIOxJQ/mqdefault.jpg",
    id: "BMC0jfIOxJQ",
    type: "video",
  },
  {
    lat: 51.68851372988159,
    lng: 0.7529059547313014,
    thumbnail: "https://img.youtube.com/vi/obQKQHses3o/mqdefault.jpg",
    id: "obQKQHses3o",
    type: "video",
  },
  {
    lat: 51.69177230807608,
    lng:  0.7933680998542724,
    thumbnail: "https://img.youtube.com/vi/pEuQQOTIvTE/mqdefault.jpg",
    id: "pEuQQOTIvTE",
    type: "video",
  },
  {
    lat: 51.692162666098085,
    lng:  0.7996876346169023,
    thumbnail: "https://img.youtube.com/vi/KCVdcom92K8/mqdefault.jpg",
    id: "KCVdcom92K8",
    type: "video",
  },
  {
    lat: 51.735275387663286,
    lng:  0.9398022300373778,
    thumbnail: "https://img.youtube.com/vi/HEGZGInHn_w/mqdefault.jpg",
    id: "HEGZGInHn_w",
    type: "video",
  },
  {
    lat: 51.62159852364063,
    lng: 0.7978018176560036,
    thumbnail: "https://img.youtube.com/vi/5BckIQXwV3k/mqdefault.jpg",
    id: "5BckIQXwV3k",
    type: "video",
  },
  {
    lat: 51.52959861712062,
    lng: 0.798436814166209,
    thumbnail: "https://img.youtube.com/vi/fK2lnf1eizA/mqdefault.jpg",
    id: "fK2lnf1eizA",
    type: "video",
  },
  {
    lat: 51.53301289656076,
    lng: 0.71873577299632,
    thumbnail: "https://img.youtube.com/vi/Wu6MZG5ml7w/mqdefault.jpg",
    id: "Wu6MZG5ml7w",
    type: "video",
  },
  {
    lat: 51.533335309910335,
    lng: 0.7052503457972187,
    thumbnail: "https://img.youtube.com/vi/i8LtyrJ-qhM/mqdefault.jpg",
    id: "i8LtyrJ-qhM",
    type: "video",
  },
  {
    lat: 51.535156284831196,
    lng: 0.6976640515694494,
    thumbnail: "https://img.youtube.com/vi/M88qcG5NWF4/mqdefault.jpg",
    id: "M88qcG5NWF4",
    type: "video",
  },
  {
    lat: 51.53817044845683,
    lng: 0.6292861804682827,
    thumbnail: "https://img.youtube.com/vi/rsVpaoJ66qQ/mqdefault.jpg",
    id: "rsVpaoJ66qQ",
    type: "video",
  },
  {
    lat: 51.51182176587123,
    lng: 0.595123797457803,
    thumbnail: "https://img.youtube.com/vi/VyeUpYR4a7s/mqdefault.jpg",
    id: "VyeUpYR4a7s",
    type: "video",
  },
  {
    lat: 51.51181893755599,
    lng: 0.5950214259658906,
    thumbnail: "https://img.youtube.com/vi/RGxNr9LUvBk/mqdefault.jpg",
    id: "RGxNr9LUvBk",
    type: "video",
  },
  {
    lat: 51.48118763930708,
    lng: 0.23279801687709145,
    thumbnail: "https://img.youtube.com/vi/iqU_eEB-nLI/mqdefault.jpg",
    id: "iqU_eEB-nLI",
    type: "video",
  },
  {
    lat: 51.48216982858887,
    lng: 0.23115203297146866,
    thumbnail: "https://img.youtube.com/vi/K7P749SMVdc/mqdefault.jpg",
    id: "K7P749SMVdc",
    type: "video",
  },
  {
    lat: 51.489713930192565,
    lng: 0.2069457814613364,
    thumbnail: "https://img.youtube.com/vi/HYDzEu9uEAI/mqdefault.jpg",
    id: "HYDzEu9uEAI",
    type: "video",
  },
  {
    lat: 51.49070061175845,
    lng: 0.18509711652983032,
    thumbnail: "https://img.youtube.com/vi/A_ipnxavYMw/mqdefault.jpg",
    id: "A_ipnxavYMw",
    type: "video",
  },
  {
    lat: 51.52759680437323,
    lng: 0.1589402219230836,
    thumbnail: "https://img.youtube.com/vi/wC3ex-nOOMo/mqdefault.jpg",
    id: "wC3ex-nOOMo",
    type: "video",
  },
  {
    lat: 51.50650137045056,
    lng: -0.08941645272429004,
    thumbnail: "https://img.youtube.com/vi/RKyukuENAQc/mqdefault.jpg",
    id: "RKyukuENAQc",
    type: "video",
  },
  {
    lat: 51.51630968987884,
    lng: -0.17572185308356383,
    thumbnail: "https://img.youtube.com/vi/0mGE1kIf2AU/mqdefault.jpg",
    id: "0mGE1kIf2AU",
    type: "video",
  },
  {
    lat: 51.51630968987884,
    lng: -0.17572185308356383,
    thumbnail: "https://img.youtube.com/vi/0LbkVAZlcno/mqdefault.jpg",
    id: "0LbkVAZlcno",
    type: "video",
  },
//Western Isles YouTube videos
{
  lat:51.557467842105346,
  lng: -0.7221490693028711,
  thumbnail: "https://img.youtube.com/vi/sFJ6-Dg4xAQ/mqdefault.jpg",
  id: "sFJ6-Dg4xAQ",
  type: "video",
},
{
  lat:51.52922165130831,
  lng: -0.13583165461795035,
  thumbnail: "https://img.youtube.com/vi/onNCZ9xFqvU/mqdefault.jpg",
  id: "onNCZ9xFqvU",
  type: "video",
},
{
  lat:56.392705455451754,
  lng: -4.619521457031908,
  thumbnail: "https://img.youtube.com/vi/p2vwHbauXsc/mqdefault.jpg",
  id: "p2vwHbauXsc",
  type: "video",
},
{
  lat:55.85799423259378,
  lng:-4.257969372198968,
  thumbnail: "https://img.youtube.com/vi/iH3nrFklgUc/mqdefault.jpg",
  id: "iH3nrFklgUc",
  type: "video",
},
{
  lat: 56.41221168785305,
  lng: -5.476293512602642,
  thumbnail: "https://img.youtube.com/vi/HGbm7r_YnVE/mqdefault.jpg",
  id: "HGbm7r_YnVE",
  type: "video",
},
{
  lat: 56.41221168785305,
  lng: -5.476293512602642,
  thumbnail: "https://img.youtube.com/vi/FI6u4klklVQ/mqdefault.jpg",
  id: "FI6u4klklVQ",
  type: "video",
},
{
  lat: 56.954667525919774,
  lng: -7.488763541037792,
  thumbnail: "https://img.youtube.com/vi/0XUiCrNJYVY/mqdefault.jpg",
  id: "0XUiCrNJYVY",
  type: "video",
},
{
  lat: 56.95514141022254,
  lng: -7.4848662914298965,
  thumbnail: "https://img.youtube.com/vi/O904DTBOm-E/mqdefault.jpg",
  id: "O904DTBOm-E",
  type: "video",
},
{
  lat: 56.95421264988985,
  lng: -7.486413925976693,
  thumbnail: "https://img.youtube.com/vi/2_C53DyUHr4/mqdefault.jpg",
  id: "2_C53DyUHr4",
  type: "video",
},
{
  lat: 56.96752315739605,
  lng: -7.47002562860667,
  thumbnail: "https://img.youtube.com/vi/F6OG_Kj-ajw/mqdefault.jpg",
  id: "F6OG_Kj-ajw",
  type: "video",
},
{
  lat: 56.92726414064269,
  lng: -7.5358792248998245,
  thumbnail: "https://img.youtube.com/vi/UV5gnwBX2pI/mqdefault.jpg",
  id: "UV5gnwBX2pI",
  type: "video",
},
{
  lat:56.947726770914095,
  lng: -7.530986875844538,
  thumbnail: "https://img.youtube.com/vi/1696pNUviwE/mqdefault.jpg",
  id: "1696pNUviwE",
  type: "video",
},
{
  lat:56.93108124943304,
  lng: -7.523691267604199,
  thumbnail: "https://img.youtube.com/vi/c7D5-qKYs64/mqdefault.jpg",
  id: "c7D5-qKYs64",
  type: "video",
},
{
  lat: 56.95478307237658,
  lng: -7.498027892127106,
  thumbnail: "https://img.youtube.com/vi/QIW1ZtQGkS0/mqdefault.jpg",
  id: "QIW1ZtQGkS0",
  type: "video",
},
{
  lat: 57.02555147741027,
  lng: -7.448771804979551,
  thumbnail: "https://img.youtube.com/vi/EMAd1PkgTPA/mqdefault.jpg",
  id: "EMAd1PkgTPA",
  type: "video",
},
{
  lat: 57.07254003043361,
  lng: -7.30521997708024,
  thumbnail: "https://img.youtube.com/vi/TeApu6RxDKs/mqdefault.jpg",
  id: "TeApu6RxDKs",
  type: "video",
},
{
  lat: 57.079135375440664,
  lng: -7.305209248172079,
  thumbnail: "https://img.youtube.com/vi/BzMVWAPVoJI/mqdefault.jpg",
  id: "BzMVWAPVoJI",
  type: "video",
},
{
  lat: 57.21648979057479,
  lng: -7.400830832719074,
  thumbnail: "https://img.youtube.com/vi/slhRaWYTMK8/mqdefault.jpg",
  id: "slhRaWYTMK8",
  type: "video",
},
{
  lat: 57.32251954548353,
  lng: -7.3867545999366415,
  thumbnail: "https://img.youtube.com/vi/F0jkika0kPA/mqdefault.jpg",
  id: "F0jkika0kPA",
  type: "video",
},
{
  lat: 57.34281121480219,
  lng: -7.361262886088654,
  thumbnail: "https://img.youtube.com/vi/1EOFM3N57Hw/mqdefault.jpg",
  id: "1EOFM3N57Hw",
  type: "video",
},
{
  lat: 57.45640263816151,
  lng: -7.39670559025834,
  thumbnail: "https://img.youtube.com/vi/rrgvNI8TwYU/mqdefault.jpg",
  id: "rrgvNI8TwYU",
  type: "video",
},
{
  lat: 57.60470421089276,
  lng: -7.380256388590534,
  thumbnail: "https://img.youtube.com/vi/uFx2M5m2bDQ/mqdefault.jpg",
  id: "uFx2M5m2bDQ",
  type: "video",
},
{
  lat: 57.70311848259214,
  lng: -7.183370520910629,
  thumbnail: "https://img.youtube.com/vi/h_ytlKzwOKM/mqdefault.jpg",
  id: "h_ytlKzwOKM",
  type: "video",
},
{
  lat: 57.740818596952636,
  lng: -6.963332823686459,
  thumbnail: "https://img.youtube.com/vi/N2aoLcFrN7w/mqdefault.jpg",
  id: "N2aoLcFrN7w",
  type: "video",
},
{
  lat: 57.74138551764171,
  lng:  -6.963354281357755,
  thumbnail: "https://img.youtube.com/vi/WxS494UVLBc/mqdefault.jpg",
  id: "WxS494UVLBc",
  type: "video",
},
{
  lat: 57.74011995519213,
  lng:  -6.964765123245408,
  thumbnail: "https://img.youtube.com/vi/Nc-PDFZgKYQ/mqdefault.jpg",
  id: "Nc-PDFZgKYQ",
  type: "video",
},
{
  lat: 57.81049175967976,
  lng: -7.059988907924699,
  thumbnail: "https://img.youtube.com/vi/nORymrTIcck/mqdefault.jpg",
  id: "nORymrTIcck",
  type: "video",
},
{
  lat: 57.897427819788824,
  lng: -6.7984118299007035,
  thumbnail: "https://img.youtube.com/vi/_dAnFoDlXVA/mqdefault.jpg",
  id: "_dAnFoDlXVA",
  type: "video",
},
{
  lat: 57.89702656067328,
  lng: -6.798843665547876,
  thumbnail: "https://img.youtube.com/vi/Gbfz_IZsd5w/mqdefault.jpg",
  id: "Gbfz_IZsd5w",
  type: "video",
},
{
  lat: 57.90034768238286,
  lng: -6.813654823667551,
  thumbnail: "https://img.youtube.com/vi/TqwiRqB36mY/mqdefault.jpg",
  id: "TqwiRqB36mY",
  type: "video",
},
{
  lat: 57.92833553378884,
  lng: -6.834731623108372,
  thumbnail: "https://img.youtube.com/vi/sfvtVdKa8rY/mqdefault.jpg",
  id: "sfvtVdKa8rY",
  type: "video",
},
{
  lat: 58.00801061248066,
  lng: -6.7530127577669905,
  thumbnail: "https://img.youtube.com/vi/d2sZaU85RGQ/mqdefault.jpg",
  id: "d2sZaU85RGQ",
  type: "video",
},
{
  lat: 58.062565195165874,
  lng: -6.663298230512436,
  thumbnail: "https://img.youtube.com/vi/TOCkbkCJwVo/mqdefault.jpg",
  id: "TOCkbkCJwVo",
  type: "video",
},
{
  lat: 58.07839910600505,
  lng: -6.649640421262225,
  thumbnail: "https://img.youtube.com/vi/xE26GcfExkQ/mqdefault.jpg",
  id: "xE26GcfExkQ",
  type: "video",
},
{
  lat: 58.195644857767604,
  lng: -6.724034160951356,
  thumbnail: "https://img.youtube.com/vi/aouP6dofIFM/mqdefault.jpg",
  id: "aouP6dofIFM",
  type: "video",
},
{
  lat: 58.19753900293803,
  lng: -6.745019764132261,
  thumbnail: "https://img.youtube.com/vi/sZ5RE3A0FUM/mqdefault.jpg",
  id: "sZ5RE3A0FUM",
  type: "video",
},
{
  lat: 58.29662282144284,
  lng: -6.792999118784659,
  thumbnail: "https://img.youtube.com/vi/fP39M5F8-AU/mqdefault.jpg",
  id: "fP39M5F8-AU",
  type: "video",
},
{
  lat: 58.3341392473059,
  lng: -6.628678180763948,
  thumbnail: "https://img.youtube.com/vi/xZ6bYBAomn0/mqdefault.jpg",
  id: "xZ6bYBAomn0",
  type: "video",
},
{
  lat: 58.3426635360555,
  lng: -6.564110491824089,
  thumbnail: "https://img.youtube.com/vi/O_SAh7R5l1w/mqdefault.jpg",
  id: "O_SAh7R5l1w",
  type: "video",
},
{
  lat: 58.41981820179177,
  lng: -6.431491347393197,
  thumbnail: "https://img.youtube.com/vi/auY51lhgsyo/mqdefault.jpg",
  id: "auY51lhgsyo",
  type: "video",
},
{
  lat: 58.471207693897995,
  lng: -6.288422318510402,
  thumbnail: "https://img.youtube.com/vi/oq2ZzvVqghM/mqdefault.jpg",
  id: "oq2ZzvVqghM",
  type: "video",
},
{
  lat: 58.498687894197126,
  lng: -6.256836624055077,
  thumbnail: "https://img.youtube.com/vi/PKLpvw3GGnk/mqdefault.jpg",
  id: "PKLpvw3GGnk",
  type: "video",
},
{
  lat: 58.51545707302592,
  lng: -6.260784836509467,
  thumbnail: "https://img.youtube.com/vi/pMRCzcSHMpw/mqdefault.jpg",
  id: "pMRCzcSHMpw",
  type: "video",
},
{
  lat: 57.661191152343356,
  lng: -6.360691718283832,
  thumbnail: "https://img.youtube.com/vi/xazZ1RZa-V4/mqdefault.jpg",
  id: "xazZ1RZa-V4",
  type: "video",
},
{
  lat: 57.61069221174708,
  lng: -6.173030622740721,
  thumbnail: "https://img.youtube.com/vi/YyGJAtWI8WM/mqdefault.jpg",
  id: "YyGJAtWI8WM",
  type: "video",
},
{
  lat:57.27536470060919,
  lng: -5.51123309913177,
  thumbnail: "https://img.youtube.com/vi/-Gyp90MkpIw/mqdefault.jpg",
  id: "-Gyp90MkpIw",
  type: "video",
},
];